/* Floever v126 compatibility shim: prevents cached/duplicate legacy scripts from failing. */
(function(root){
  if(typeof root.normalizeField !== "function"){
    root.normalizeField = function(value){
      return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
    };
  }
})(typeof window !== "undefined" ? window : globalThis);

(function(){
function initAiDesigner(){
/* Floever AI Studio: translations at presentation boundaries only. */
const floeverAiI18n = (function () {
  const config = window.FLOEVER_AI_STUDIO_CONFIG || {};
  const messages = config.messages || {};
  const enabled = config.locale && config.locale !== 'tr';
  const normalize = value => String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  const escapeRegex = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const patterns = Object.keys(messages).filter(key => /__VAR\d+__/.test(key))
    .sort((a, b) => b.replace(/__VAR\d+__/g, '').length - a.replace(/__VAR\d+__/g, '').length)
    .map(key => {
      const tokens = key.match(/__VAR\d+__/g);
      return {tokens, value:messages[key], regex:new RegExp('^' + key.split(/__VAR\d+__/g).map(escapeRegex).join('([^·]+?)') + '$')};
    });
  function text(value, depth) {
    const raw = String(value == null ? '' : value);
    if (!enabled || !raw || (depth || 0) > 3) return raw;
    const core = normalize(raw);
    const leading = raw.match(/^\s*/)[0], trailing = raw.match(/\s*$/)[0];
    if (Object.prototype.hasOwnProperty.call(messages, core)) return leading + messages[core] + trailing;
    for (const pattern of patterns) {
      const match = core.match(pattern.regex);
      if (!match) continue;
      // Captures remain text; they never become HTML, identifiers or submitted values.
      const translated = pattern.value.replace(/__VAR\d+__/g, token => {
        const index = pattern.tokens.indexOf(token);
        return index < 0 ? token : text(match[index + 1], (depth || 0) + 1);
      });
      return leading + translated + trailing;
    }
    // Dimension rows and recommendation fragments use deliberate separators.
    for (const separator of [' · ', ' × ', '; ']) {
      if (core.includes(separator)) return leading + core.split(separator).map(part => text(part, (depth || 0) + 1)).join(separator) + trailing;
    }
    return raw;
  }
  function html(value) {
    if (!enabled || !value) return value;
    const template = document.createElement('template');
    template.innerHTML = String(value);
    function visit(node) {
      if (node.nodeType === 3) { node.nodeValue = text(node.nodeValue); return; }
      if (node.nodeType !== 1 && node.nodeType !== 11) return;
      if (node.nodeType === 1) {
        if (['SCRIPT', 'STYLE', 'TEXTAREA'].includes(node.tagName) || node.hasAttribute('data-i18n-ignore')) return;
        for (const attribute of ['aria-label', 'title', 'alt', 'placeholder']) {
          if (node.hasAttribute(attribute)) node.setAttribute(attribute, text(node.getAttribute(attribute)));
        }
      }
      for (const child of Array.from(node.childNodes)) visit(child);
    }
    visit(template.content);
    const output = document.createElement('div');
    output.appendChild(template.content);
    return output.innerHTML;
  }
  return {text, html};
})();


window.FLOEVER_RECOMMENDATION_SYSTEM_VERSION = "arrangement-completion-v3.2";
window.FLOEVER_UI_POLISH_VERSION = "v154-quantity-buttons-only";
try { console.info("[Floever] Metafield öneri sistemi aktif"); } catch(error) {}

const form = document.getElementById("aiDesignerForm");
const setupView = document.getElementById("aiDesignerSetupView");
const resultView = document.getElementById("aiDesignerResultView");
const backToDesignerButton = document.getElementById("aiBackToDesigner");
const formMessageBox = document.getElementById("ai-form-message");
const scenarioCards = [];
const selectedScenario = document.getElementById("selectedScenario");
const arrangementImage = document.getElementById("arrangementImage");
const arrangementModeBox = document.getElementById("arrangementModeBox");
const arrangementMode = document.getElementById("arrangementMode");
const flowerColorSection = document.getElementById("flowerColorSection");
const ownFlowersSection = document.getElementById("ownFlowersSection");
const aiStemList = document.getElementById("aiStemList");
const aiAddStemButton = document.getElementById("aiAddStemButton");
const aiSupportMode = document.getElementById("aiSupportMode");
const styleAreaSection = document.getElementById("styleAreaSection");
const arrangementUploadLabel = document.getElementById("arrangementUploadLabel");
const arrangementUploadIcon = document.getElementById("arrangementUploadIcon");
const arrangementUploadTitle = document.getElementById("arrangementUploadTitle");
const arrangementUploadSubtitle = document.getElementById("arrangementUploadSubtitle");
const arrangementFilename = document.getElementById("arrangementFilename");
const resultBox = document.getElementById("ai-result");
const formTitle = document.getElementById("formTitle");
const creditPanel = document.getElementById("aiCreditPanel");
const creditBalanceElement = document.getElementById("aiCreditBalance");
const currentCostElement = document.getElementById("aiCurrentCost");
const creditStatusElement = document.getElementById("aiCreditStatus");
const submitButton = document.getElementById("aiSubmitButton");
const submitButtonText = document.getElementById("aiSubmitButtonText");
const submitCreditElement = document.getElementById("aiSubmitCredit");
const scenarioTwoCreditElement = document.getElementById("scenarioTwoCredit");
const scenarioThreeCreditElement = document.getElementById("scenarioThreeCredit");
const guideModal = null;
const authModal = document.getElementById("aiAuthModal");
const authCloseButton = document.getElementById("aiAuthClose");
const authScenarioText = document.getElementById("aiAuthScenarioText");
const loginButton = document.getElementById("aiLoginButton");
const registerButton = document.getElementById("aiRegisterButton");
const buyCreditsButton = document.getElementById("aiBuyCredits");
const starterCreditBanner = document.getElementById("aiStarterCreditBanner");
const starterLoginButton = document.getElementById("aiStarterLoginButton");
const refreshCreditsButton = document.getElementById("aiRefreshCredits");
const creditModal = document.getElementById("aiCreditModal");
const creditModalCloseButton = document.getElementById("aiCreditModalClose");
const creditModalRefreshButton = document.getElementById("aiCreditModalRefresh");
const creditModalStatus = document.getElementById("aiCreditModalStatus");
const creditModalWarning = document.getElementById("aiCreditModalWarning");
const profileModal = document.getElementById("aiProfileModal");
const profileForm = document.getElementById("aiProfileForm");
const profileFirstName = document.getElementById("aiProfileFirstName");
const profileLastName = document.getElementById("aiProfileLastName");
const profilePhone = document.getElementById("aiProfilePhone");
const profileKvkk = document.getElementById("aiProfileKvkk");
const profileMarketing = document.getElementById("aiProfileMarketing");
const profileStatus = document.getElementById("aiProfileStatus");
const profileSaveButton = document.getElementById("aiProfileSaveButton");
const flowerLibraryStatus = document.getElementById("aiFlowerLibraryStatus");
const flowerLibraryGrid = document.getElementById("aiFlowerLibraryGrid");
const selectedLibraryFlowersInput = document.getElementById("selectedLibraryFlowers");
let flowerLibraryItems = [];
const selectedLibraryFlowerIds = new Set();
const API_BASE_URL = "https://floever-ai-backend-production.up.railway.app";
const APP_PROXY_BASE_URL = "/apps/floever-ai";
const APP_PROXY_SESSION_PREPARE_URL = APP_PROXY_BASE_URL + "/api/storefront-session/prepare";
const AI_STUDIO_CONFIG = window.FLOEVER_AI_STUDIO_CONFIG || {};
const ACCOUNT_URL = AI_STUDIO_CONFIG.accountUrl || "/account";
const LOGIN_URL = AI_STUDIO_CONFIG.loginUrl || "/account/login";
const REGISTER_URL = AI_STUDIO_CONFIG.registerUrl || "/account/register";
const DESIGN_PAGE_URL = window.location.origin + window.location.pathname;
const DESIGNS_GALLERY_URL = "https://account.floever.com.tr/pages/019ecbb4-2549-7a44-b90a-ffd171400531";
const SHOPIFY_CART_ADD_URL = AI_STUDIO_CONFIG.cartAddUrl || "/cart/add.js";
const SHOPIFY_CART_URL = AI_STUDIO_CONFIG.cartUrl || "/cart";
const PENDING_SCENARIO_KEY = "floever_ai_pending_scenario_v1";
const HANDOFF_QUERY_PARAM = "floever_ai_handoff";
const SESSION_STORAGE_KEY = "floever_ai_storefront_session_v1";
const STARTER_NOTICE_KEY = "floever_ai_starter_credit_notice_v1";
const authState = {
token: "",
apiBaseUrl: API_BASE_URL,
expiresAt: 0,
request: null,
mode: "loading",
customer: null
};
const creditState = {
enabled: false,
loaded: false,
balance: null,
starterCredits: 3,
showStarterNotice: false,
starterCreditBlockedByIp: false,
starterCreditBlockReason: "",
starterCreditMessage: "",
costs: {
scenario_1_gpt: 0,
scenario_2a_gpt_same: 0,
scenario_2c_gpt_own_flowers: 0
}
};
const systemState = {
aiSystemPaused: false,
aiSystemPauseMessage: "Floever AI Studio kısa süreli bakım nedeniyle geçici olarak durduruldu. Lütfen daha sonra tekrar deneyin.",
profileCompletionRequired: false
};
const profileState = {
loaded: false,
profile: null
};
if (!form) return;
const FLOEVER_COMPOSITION_VISUAL_LIBRARY = [
  {id:"top_form_compact_dome",name:"Klasik Yuvarlak",family:"top_form",short:"Dengeli ve düzenli yuvarlak form.",svgKey:"top_compact"},
  {id:"top_form_natural_dome",name:"Doğal Yuvarlak",family:"top_form",short:"Yuvarlak ama daha doğal ve hafif hareketli form.",svgKey:"top_organic"},
  {id:"top_form_dense_dome",name:"Alçak ve Dolgun",family:"top_form",short:"Daha geniş, sık ve alçak yuvarlak form.",svgKey:"top_dense"},
  {id:"modern_asymmetric_vertical",name:"Tek Taraf Yükselen",family:"vertical",short:"Bir tarafta güçlü biçimde yükselen heykelsi form.",svgKey:"vertical_asymmetric"},
  {id:"tall_balanced_vertical",name:"Dengeli Yüksek",family:"vertical",short:"Merkezde yükselen dengeli ve uzun form.",svgKey:"vertical_balanced"},
  {id:"tall_minimal_vertical",name:"Sade Heykelsi",family:"vertical",short:"Az kümeli, tek güçlü yükselişli form.",svgKey:"vertical_minimal"},
  {id:"horizontal_low_wide",name:"İki Yana Açılan",family:"horizontal",short:"Sağa ve sola dengeli uzanan geniş form.",svgKey:"horizontal_balanced"},
  {id:"horizontal_directional_wide",name:"Tek Yöne Uzanan",family:"horizontal",short:"Bir tarafa belirgin biçimde daha uzun akan form.",svgKey:"horizontal_directional"},
  {id:"horizontal_compact_console",name:"Alçak ve Toplu",family:"horizontal",short:"Ortası dolgun, yanları daha kısa yatay form.",svgKey:"horizontal_compact"},
  {id:"modern_loose_asymmetric",name:"Dengeli Dağınık",family:"loose",short:"Farklı büyüklükte üç dengeli çiçek kümesi.",svgKey:"loose_controlled"},
  {id:"loose_airy_asymmetric",name:"Ferah ve Boşluklu",family:"loose",short:"Çiçek kümeleri arasında belirgin boşluklar bulunan form.",svgKey:"loose_airy"},
  {id:"loose_sculptural_asymmetric",name:"Yüksek Vurgulu",family:"loose",short:"Alçak ana küme ve karşı tarafta güçlü yüksek vurgu.",svgKey:"loose_sculptural"}
];

function compositionStyleVisualKey(value){
const lowered = String(value || "").toLocaleLowerCase("tr-TR");
if(!lowered) return "ai_selection";
if(lowered.includes("top form") || lowered.includes("topform") || lowered.includes("yuvarlak") || lowered.includes("küresel") || lowered.includes("kuresel")) return "top_form";
if(lowered.includes("yatay")) return "horizontal";
if(lowered.includes("uzun") || lowered.includes("heykelsi") || lowered.includes("dikey")) return "vertical";
if(lowered.includes("dağınık") || lowered.includes("daginik") || lowered.includes("asimetrik") || lowered.includes("modern")) return "loose";
return "ai_selection";
}

function compositionFamilyLabel(key){
switch(String(key || "")){
case "top_form": return "Top Form";
case "vertical": return "Uzun & Heykelsi";
case "horizontal": return "Yatay Akışlı";
case "loose": return "Modern Dağınık";
default: return "AI Seçimi";
}
}

function getCompositionVisualTemplateById(idOrName){
const raw = String(idOrName || "").trim();
if(!raw) return null;
const normalized = raw.toLocaleLowerCase("tr-TR");
return FLOEVER_COMPOSITION_VISUAL_LIBRARY.find(function(item){
return String(item.id || "").toLocaleLowerCase("tr-TR") === normalized || String(item.name || "").toLocaleLowerCase("tr-TR") === normalized;
}) || null;
}

function getCompositionTemplatesForSelection(styleValue){
const key = compositionStyleVisualKey(styleValue);
const byId = function(ids){ return ids.map(getCompositionVisualTemplateById).filter(Boolean); };
if(key === "top_form") return byId(["top_form_compact_dome","top_form_natural_dome","top_form_dense_dome"]);
if(key === "vertical") return byId(["modern_asymmetric_vertical","tall_balanced_vertical","tall_minimal_vertical"]);
if(key === "horizontal") return byId(["horizontal_low_wide","horizontal_directional_wide","horizontal_compact_console"]);
if(key === "loose") return byId(["modern_loose_asymmetric","loose_airy_asymmetric","loose_sculptural_asymmetric"]);
return byId(["modern_loose_asymmetric","top_form_compact_dome","modern_asymmetric_vertical","horizontal_low_wide"]);
}

function renderCompositionVisualSvg(key){
const palette = {
  vase:'#8A8C90', outline:'#D8CEC0', accent:'#C7985B', bloom:'#C9D6F0', bloom2:'#D7E1CC', bloom3:'#E8D6E1', line:'#8CA082', stem:'#6B7C63', bg:'#FBF8F3'
};
const base = function(inner){
return `<svg viewBox="0 0 240 170" width="100%" height="160" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Kompozisyon şeması"><rect x="0" y="0" width="240" height="170" rx="20" fill="${palette.bg}"/><ellipse cx="120" cy="157" rx="68" ry="8" fill="#EAE1D5"/><g opacity="0.95">${inner}</g></svg>`;
};
const vase = `<g><ellipse cx="120" cy="118" rx="26" ry="9" fill="#9C9EA3"/><path d="M100 118 C102 138, 110 151, 120 151 C130 151, 138 138, 140 118 L136 104 C131 107,126 109,120 109 C114 109,109 107,104 104 Z" fill="${palette.vase}"/><ellipse cx="120" cy="104" rx="16" ry="5" fill="#B2B4B8"/></g>`;
const circles = function(items){ return items.map(function(v){ return `<circle cx="${v[0]}" cy="${v[1]}" r="${v[2]}" fill="${v[3] || palette.bloom}" stroke="#FFFFFF" stroke-width="2"/>`; }).join(''); };
const stems = function(items){ return items.map(function(v){ return `<path d="M${v[0]} ${v[1]} C ${v[2]} ${v[3]}, ${v[4]} ${v[5]}, ${v[6]} ${v[7]}" stroke="${v[8] || palette.stem}" stroke-width="2.4" fill="none" stroke-linecap="round"/>`; }).join(''); };
const leaves = function(items){ return items.map(function(v){ return `<ellipse cx="${v[0]}" cy="${v[1]}" rx="${v[2]}" ry="${v[3]}" transform="rotate(${v[4]} ${v[0]} ${v[1]})" fill="${palette.line}" opacity="0.8"/>`; }).join(''); };
switch(String(key || '')){
case 'top_compact':
  return base(`<path d="M58 96 C70 52,170 52,182 96" fill="none" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${stems([[120,106,118,91,120,79,120,69],[118,106,107,94,94,85,84,79],[122,106,133,94,146,85,156,79]])}${circles([[83,80,16,palette.bloom],[103,70,18,palette.bloom3],[121,67,19,palette.bloom2],[139,71,18,palette.bloom],[158,80,16,palette.bloom3],[96,90,17,palette.bloom2],[121,88,18,palette.bloom],[146,90,17,palette.bloom2]])}${leaves([[89,105,9,4,-28],[151,105,9,4,28]])}${vase}`);
case 'top_organic':
  return base(`<path d="M53 96 C69 55,160 47,187 91" fill="none" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${stems([[118,106,108,92,96,85,84,82],[121,106,117,91,122,79,127,67],[124,106,135,95,151,88,165,82]])}${circles([[82,83,15,palette.bloom2],[102,72,18,palette.bloom],[127,66,18,palette.bloom3],[149,74,16,palette.bloom2],[167,83,14,palette.bloom],[94,94,15,palette.bloom3],[120,89,17,palette.bloom2],[148,93,15,palette.bloom]])}${leaves([[76,99,10,4,-18],[158,104,10,4,23]])}${vase}`);
case 'top_dense':
  return base(`<path d="M47 101 C66 64,174 64,193 101" fill="none" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${circles([[67,91,16,palette.bloom],[86,79,17,palette.bloom3],[106,75,18,palette.bloom2],[127,75,18,palette.bloom],[148,80,17,palette.bloom3],[169,91,16,palette.bloom2],[82,98,17,palette.bloom2],[104,94,18,palette.bloom],[127,94,18,palette.bloom3],[150,97,17,palette.bloom]])}${leaves([[72,107,10,4,-12],[167,107,10,4,12]])}${vase}`);
case 'vertical_asymmetric':
  return base(`${stems([[115,106,104,95,92,91,82,88],[123,106,136,88,151,67,166,42],[120,106,124,90,132,76,139,63]])}${circles([[84,88,17,palette.bloom],[105,91,16,palette.bloom3],[126,82,14,palette.bloom2],[166,42,10,palette.bloom3],[140,62,10,palette.bloom2]])}${leaves([[101,106,10,4,-28],[145,89,9,4,22]])}<path d="M76 36 L174 36" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'vertical_balanced':
  return base(`${stems([[118,106,111,88,104,67,104,47],[122,106,129,88,138,68,139,50],[120,106,120,90,120,73,121,59]])}${circles([[104,47,10,palette.bloom2],[139,50,10,palette.bloom3],[121,59,11,palette.bloom],[102,82,15,palette.bloom3],[123,84,16,palette.bloom2],[143,83,14,palette.bloom]])}${leaves([[98,103,10,4,-22],[145,103,10,4,22]])}<path d="M91 39 L151 39" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'vertical_minimal':
  return base(`${stems([[115,106,108,97,101,92,94,88],[123,106,139,85,154,60,170,34]])}${circles([[94,88,18,palette.bloom3],[116,92,10,palette.bloom2],[170,34,10,palette.bloom]])}${leaves([[104,105,9,4,-24]])}<path d="M91 28 L178 28" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'horizontal_balanced':
  return base(`${stems([[118,106,103,101,84,99,62,98],[122,106,137,101,156,99,178,98],[119,106,112,95,102,89,91,86],[121,106,128,95,138,89,149,86]])}${circles([[62,98,11,palette.bloom2],[87,87,15,palette.bloom],[108,80,17,palette.bloom3],[132,80,17,palette.bloom2],[153,87,15,palette.bloom],[178,98,11,palette.bloom3],[120,92,15,palette.bloom]])}${vase}`);
case 'horizontal_directional':
  return base(`${stems([[116,106,103,102,91,101,78,101],[122,106,144,96,169,86,198,72],[121,106,145,103,174,103,202,101]])}${circles([[78,101,12,palette.bloom2],[102,91,16,palette.bloom],[124,87,17,palette.bloom3],[151,89,14,palette.bloom2],[177,82,12,palette.bloom],[199,72,9,palette.bloom3],[202,101,10,palette.bloom2]])}${vase}`);
case 'horizontal_compact':
  return base(`${stems([[117,106,105,102,91,101,78,100],[123,106,135,102,149,101,162,100]])}${circles([[78,100,12,palette.bloom2],[96,89,17,palette.bloom],[117,82,19,palette.bloom3],[139,87,18,palette.bloom2],[162,100,12,palette.bloom],[111,100,16,palette.bloom2],[133,100,16,palette.bloom3]])}${vase}`);
case 'loose_controlled':
  return base(`${stems([[115,106,104,94,92,88,82,81],[120,106,120,91,125,78,129,68],[124,106,137,98,151,96,164,93]])}${circles([[82,81,14,palette.bloom2],[101,91,16,palette.bloom],[129,68,13,palette.bloom3],[141,92,14,palette.bloom2],[164,93,11,palette.bloom]])}${leaves([[91,106,10,4,-24],[150,105,10,4,22]])}${vase}`);
case 'loose_airy':
  return base(`${stems([[115,106,100,100,83,98,69,96],[120,106,119,87,119,70,120,55],[124,106,143,99,163,92,181,84]])}${circles([[69,96,12,palette.bloom2],[91,91,11,palette.bloom],[120,55,12,palette.bloom3],[143,95,11,palette.bloom2],[181,84,12,palette.bloom]])}${vase}`);
case 'loose_sculptural':
  return base(`${stems([[114,106,101,98,89,94,77,90],[118,106,108,95,99,88,91,82],[123,106,139,84,155,59,174,37]])}${circles([[77,90,16,palette.bloom2],[98,88,17,palette.bloom],[119,95,14,palette.bloom3],[174,37,11,palette.bloom2],[151,61,10,palette.bloom]])}${leaves([[91,107,10,4,-23]])}${vase}`);
case 'top_form':
  return base(`<path d="M55 96 C65 52, 175 50, 185 96" fill="none" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${stems([[116,105,108,92,95,84,83,79],[120,105,116,88,120,80,120,72],[124,105,128,90,145,84,158,79],[118,105,112,92,84,95,72,88],[122,105,130,94,154,95,169,88]])}${circles([[83,79,16,palette.bloom],[103,71,18,palette.bloom3],[120,68,19,palette.bloom2],[138,72,18,palette.bloom],[158,79,16,palette.bloom3],[95,89,17,palette.bloom2],[120,87,18,palette.bloom],[145,90,17,palette.bloom2],[74,88,12,palette.bloom2],[169,88,12,palette.bloom2]])}${leaves([[90,105,9,4,-28],[148,106,9,4,25],[74,101,10,4,-18],[168,101,10,4,20]])}${vase}`);
case 'vertical':
  return base(`${stems([[118,106,112,92,104,84,97,76],[122,105,129,92,141,83,152,67],[120,105,120,88,121,76,123,53],[116,104,113,92,109,80,107,61]])}${circles([[98,77,15,palette.bloom3],[117,83,18,palette.bloom],[135,89,15,palette.bloom2],[151,67,10,palette.bloom2],[123,52,9,palette.bloom3],[108,61,9,palette.bloom2]])}${leaves([[100,101,10,4,-28],[146,104,11,4,24],[118,95,8,4,10]])}<path d="M76 46 L164 46" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'directional_arc':
  return base(`${stems([[118,106,112,92,104,86,97,82],[121,106,129,92,154,82,178,70],[119,106,130,98,160,95,186,92],[117,106,115,95,103,94,89,96]])}${circles([[98,82,15,palette.bloom],[117,76,17,palette.bloom3],[140,86,13,palette.bloom2],[178,70,9,palette.bloom3],[186,92,10,palette.bloom2],[88,96,10,palette.bloom2]])}${leaves([[101,104,10,4,-20],[164,87,11,4,20],[182,87,10,4,8]])}${vase}`);
case 'minimal':
  return base(`${stems([[120,106,119,92,118,80,118,66],[123,105,136,89,151,70,166,49]])}${circles([[118,66,20,palette.bloom3],[166,48,10,palette.bloom2],[134,96,8,palette.bloom2]])}${leaves([[114,102,10,4,-22],[126,98,8,4,14]])}<path d="M82 38 L181 38" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'natural_oval':
  return base(`${stems([[118,106,110,92,98,83,87,80],[120,106,118,92,118,83,118,76],[122,106,130,92,142,83,154,80],[117,106,112,94,101,95,92,92],[123,106,128,94,139,95,148,92]])}${circles([[88,80,15,palette.bloom2],[106,74,17,palette.bloom],[122,72,18,palette.bloom3],[139,75,17,palette.bloom2],[154,81,15,palette.bloom],[95,92,14,palette.bloom3],[121,88,15,palette.bloom2],[147,92,14,palette.bloom3]])}${leaves([[95,105,10,4,-26],[144,106,10,4,26],[75,95,10,4,-12],[164,96,10,4,12]])}${vase}`);
case 'triangle':
  return base(`${stems([[120,106,118,92,118,82,120,62],[118,106,110,94,97,88,87,82],[122,106,131,94,144,88,156,82],[119,106,115,96,103,98,93,96],[121,106,126,96,138,98,148,96]])}${circles([[120,62,10,palette.bloom2],[88,82,13,palette.bloom],[105,89,15,palette.bloom3],[120,86,17,palette.bloom2],[137,89,15,palette.bloom],[155,82,13,palette.bloom3],[94,96,11,palette.bloom2],[148,96,11,palette.bloom2]])}${leaves([[94,106,10,4,-20],[147,106,10,4,22]])}<path d="M79 60 L120 38 L161 60" fill="none" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'cascade':
  return base(`${stems([[118,106,116,92,112,82,107,72],[122,106,130,94,145,93,158,92],[121,106,135,104,154,115,167,131],[121,106,136,109,152,124,163,144]])}${circles([[108,72,16,palette.bloom3],[127,80,15,palette.bloom],[145,90,14,palette.bloom2],[159,92,12,palette.bloom3],[167,131,10,palette.bloom2],[162,144,9,palette.bloom]])}${leaves([[150,115,10,4,20],[159,126,9,4,26],[109,101,10,4,-20]])}${vase}`);
case 'fan':
  return base(`${stems([[119,106,113,92,102,81,89,67],[120,106,119,92,119,79,120,59],[121,106,129,92,144,81,159,67],[118,106,112,96,101,95,92,92],[122,106,128,96,139,95,148,92]])}${circles([[89,67,10,palette.bloom2],[120,59,10,palette.bloom3],[159,67,10,palette.bloom2],[96,86,15,palette.bloom],[120,82,17,palette.bloom3],[145,86,15,palette.bloom]])}${leaves([[95,104,10,4,-18],[147,104,10,4,18]])}<path d="M80 43 L120 34 L160 43" fill="none" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'exotic_vertical':
  return base(`${stems([[118,106,113,92,104,83,98,65],[122,106,129,92,140,80,148,60],[120,106,120,90,120,78,120,52],[116,106,112,96,106,93,99,88],[124,106,131,96,138,93,145,88]])}${circles([[99,65,11,palette.bloom2],[120,52,11,palette.bloom3],[148,60,11,palette.bloom2],[105,86,14,palette.bloom],[121,82,15,palette.bloom3],[144,87,14,palette.bloom]])}${leaves([[99,105,10,4,-22],[146,105,10,4,22]])}<path d="M86 40 L154 40" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'horizontal':
  return base(`${stems([[118,106,103,100,86,99,68,98],[121,106,136,100,154,99,173,98],[119,106,113,97,103,91,92,86],[121,106,128,97,138,91,150,86]])}${circles([[68,98,12,palette.bloom2],[89,87,15,palette.bloom],[109,80,17,palette.bloom3],[131,80,17,palette.bloom2],[150,87,15,palette.bloom],[173,98,12,palette.bloom3],[121,92,14,palette.bloom]])}${leaves([[83,103,9,4,-8],[159,103,9,4,8]])}<path d="M55 76 L185 76" stroke="${palette.outline}" stroke-dasharray="5 4" stroke-width="2"/>${vase}`);
case 'loose':
  return base(`${stems([[117,106,110,93,95,87,82,78],[120,106,118,93,118,84,120,74],[123,106,131,95,147,93,162,89],[118,106,111,98,98,100,84,101],[122,106,130,98,143,101,156,106]])}${circles([[82,78,12,palette.bloom2],[98,88,14,palette.bloom],[120,74,16,palette.bloom3],[143,93,13,palette.bloom2],[162,89,11,palette.bloom],[84,101,10,palette.bloom3],[156,106,10,palette.bloom2]])}${leaves([[99,105,10,4,-25],[143,107,10,4,25],[70,91,9,4,-12]])}${vase}`);
case 'balanced':
  return base(`${stems([[118,106,112,92,102,83,92,77],[120,106,119,92,119,82,120,74],[122,106,129,92,139,83,149,77],[119,106,115,95,106,96,98,94],[121,106,126,95,135,96,143,94]])}${circles([[92,77,13,palette.bloom2],[106,83,15,palette.bloom],[121,74,16,palette.bloom3],[136,83,15,palette.bloom2],[149,77,13,palette.bloom],[100,94,11,palette.bloom3],[142,94,11,palette.bloom]])}${leaves([[99,106,9,4,-20],[140,106,9,4,20]])}${vase}`);
default:
  return base(`${circles([[120,80,18,palette.bloom]])}${vase}`);
}
}

function renderCompositionLibraryCard(template, options){
const opts = options || {};
const active = Boolean(opts.active);
const compact = Boolean(opts.compact);
const hint = opts.hint ? `<div style="font-size:12px;color:#7B6D61;margin-top:6px;">${escapeHtml(opts.hint)}</div>` : "";
return `<article style="border:1px solid ${active ? '#B68D5B' : '#E6DCCF'}; background:${active ? '#FFF8EE' : '#FFFFFF'}; border-radius:18px; padding:${compact ? '12px' : '14px'}; box-shadow:${active ? '0 8px 24px rgba(154,116,66,0.08)' : '0 4px 16px rgba(59,42,33,0.04)'}; display:flex; flex-direction:column; gap:10px;">
<div style="display:flex; align-items:center; justify-content:space-between; gap:10px;"><span style="font-size:11px; letter-spacing:.08em; text-transform:uppercase; color:#9A7442; font-weight:700;">${escapeHtml(compositionFamilyLabel(template.family))}</span>${active ? '<span style="font-size:11px; background:#1F4D39; color:#fff; padding:5px 8px; border-radius:999px;">Öne çıkan</span>' : ''}</div>
<div style="background:#FBF8F3; border:1px solid #F0E7DA; border-radius:14px; padding:8px;">${renderCompositionVisualSvg(template.svgKey)}</div>
<div><strong style="display:block; color:#3B2A21; font-size:${compact ? '14px' : '15px'}; line-height:1.35;">${escapeHtml(template.name)}</strong><p style="margin:6px 0 0; color:#6C5A4D; font-size:${compact ? '12px' : '13px'}; line-height:1.5;">${escapeHtml(template.short)}</p>${hint}</div>
</article>`;
}

function renderCompositionLibrarySelectionHtml(styleValue){
const templates = getCompositionTemplatesForSelection(styleValue || getSelectedArrangementStyle());
if(!templates.length) return '';
const visualKey = compositionStyleVisualKey(styleValue || getSelectedArrangementStyle());
const exactLocked = ["top_form","horizontal","loose","cascade"].includes(visualKey);
const styleLabel = styleValue || getSelectedArrangementStyle() || 'AI Seçimi';
const intro = exactLocked
? 'Bu seçimde geometri kilitlidir. Aşağıdaki formun dışına çıkılmaz; yalnızca seçilen ürünlerle aynı siluet uygulanır.'
: visualKey === 'vertical'
? 'Bu seçimde uzun / dikey aileden şablonlar puanlanır. Ürünlere ve vazoya göre en uyumlu olan kullanılır.'
: visualKey === 'modern' || visualKey === 'natural' || visualKey === 'exotic'
? 'Bu tarz için birden fazla kompozisyon şablonu adaydır. Sistem ürün formu, rol, hareket ve vazo oranına göre en uygun olanı seçer.'
: 'AI Seçimi tüm kütüphaneyi tarar ve ürün setinize en uygun şablonu seçer.';
const primary = templates[0];
const others = templates.slice(1);
const allCards = FLOEVER_COMPOSITION_VISUAL_LIBRARY.map(function(item){ return renderCompositionLibraryCard(item, {compact:true}); }).join('');
return `<section class="ai-recommendation-box ai-composition-library-box" style="margin-top:16px;">
<div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Kompozisyon kütüphanesi</span><div class="ai-recommendation-title">${escapeHtml(styleLabel)} için görsel rehber</div></div><p class="ai-recommendation-hint">${escapeHtml(intro)}</p></div>
<div style="display:grid; grid-template-columns:repeat(auto-fit, minmax(240px, 1fr)); gap:14px;">${renderCompositionLibraryCard(primary, {active:true, hint: exactLocked ? 'Bu seçimde ana geometri budur.' : 'Sıklıkla öne çıkan aday.'})}${others.map(function(item){ return renderCompositionLibraryCard(item, {compact:true}); }).join('')}</div>
<details style="margin-top:14px;"><summary style="cursor:pointer; font-weight:600; color:#4D2D18;">Tüm kompozisyon kütüphanesini gör</summary><div style="display:grid; grid-template-columns:repeat(auto-fit, minmax(220px, 1fr)); gap:12px; margin-top:12px;">${allCards}</div></details>
</section>`;
}


let compositionRecommendationRequestSerial = 0;

function compositionRecommendationInputKey(){
return JSON.stringify({
style:getSelectedArrangementStyle(),
vaseMode:configState.vaseMode,
selectedVaseId:configState.vaseMode === "floever" ? configState.selectedVaseId : "own",
flowers:selectedConfigFlowers().map(function(item){ return {id:String(item.id),count:Number(item.count || 1)}; })
});
}

function fallbackCompositionRecommendations(){
return getCompositionTemplatesForSelection(getSelectedArrangementStyle()).slice(0,3).map(function(item,index){
return {id:item.id,name:item.name,description:item.short,visualKey:item.svgKey,recommended:index === 0,score:null};
});
}

function normalizeCompositionRecommendation(item,index){
const fallback = getCompositionVisualTemplateById(item && item.id);
return {
id:String(item && item.id || fallback && fallback.id || ""),
name:String(fallback && fallback.name || item && item.name || "Floever Kompozisyonu"),
description:String(fallback && fallback.short || item && item.description || "Seçtiğiniz ürünlere uygun kompozisyon."),
visualKey:String(fallback && fallback.svgKey || item && item.visualKey || "balanced"),
recommended:index === 0 || Boolean(item && item.recommended),
score:item && item.score !== undefined ? item.score : null
};
}

function invalidateCompositionRecommendations(){
compositionRecommendationRequestSerial += 1;
configState.selectedCompositionTemplateId = "";
configState.compositionRecommendations = [];
configState.compositionRecommendationsLoading = false;
configState.compositionRecommendationsError = "";
configState.compositionRecommendationKey = "";
}

function renderCompositionChoiceCard(item,index){
const selected = String(configState.selectedCompositionTemplateId || "") === String(item.id || "");
const badge = index === 0 ? "Floever Önerisi" : "Alternatif " + index;
return `<button type="button" class="ai-composition-choice-card ${selected ? "is-selected" : ""}" data-composition-template-choice="${escapeHtml(item.id)}" aria-pressed="${selected ? "true" : "false"}" style="appearance:none;text-align:left;width:100%;border:${selected ? "2px solid #8E673C" : "1px solid #E5DACD"};background:${selected ? "#FFF8EE" : "#FFFFFF"};border-radius:18px;padding:12px;box-shadow:${selected ? "0 10px 24px rgba(112,78,41,.10)" : "0 4px 14px rgba(59,42,33,.04)"};cursor:pointer;display:flex;flex-direction:column;gap:9px;">
<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;"><span style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:${index === 0 ? "#1F4D39" : "#9A7442"};">${escapeHtml(badge)}</span>${selected ? '<span style="font-size:11px;background:#1F4D39;color:#fff;border-radius:999px;padding:5px 8px;">Seçildi</span>' : ''}</div>
<div style="background:#FBF8F3;border:1px solid #F0E7DA;border-radius:14px;padding:6px;">${renderCompositionVisualSvg(item.visualKey)}</div>
<div><strong style="display:block;color:#3B2A21;font-size:15px;line-height:1.35;">${escapeHtml(item.name)}</strong><span style="display:block;margin-top:5px;color:#6C5A4D;font-size:12px;line-height:1.5;">${escapeHtml(item.description)}</span></div>
</button>`;
}

function renderCompositionRecommendationPickerHtml(){
if(!selectedConfigFlowers().length) return `<section class="ai-recommendation-box"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Kompozisyon seçimi</span><div class="ai-recommendation-title">Önce çiçeklerinizi seçin</div></div><p class="ai-recommendation-hint">Üç kompozisyon önerisi seçilen ürünlere göre hazırlanacak.</p></div></section>`;
if(configState.compositionRecommendationsLoading){
return `<section class="ai-recommendation-box" id="configCompositionPicker"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Kompozisyon seçimi</span><div class="ai-recommendation-title">En uygun üç form hazırlanıyor…</div></div><p class="ai-recommendation-hint">Vazo, çiçek rolleri, ürün formu ve adetler birlikte değerlendiriliyor.</p></div></section>`;
}
const items = (configState.compositionRecommendations.length ? configState.compositionRecommendations : fallbackCompositionRecommendations()).slice(0,3);
if(!items.length) return `<section class="ai-recommendation-box" id="configCompositionPicker"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Kompozisyon seçimi</span><div class="ai-recommendation-title">Kompozisyon önerisi hazırlanamadı</div></div><p class="ai-recommendation-hint">Tarz veya ürün seçiminizi değiştirerek tekrar deneyebilirsiniz.</p></div></section>`;
return `<section class="ai-recommendation-box ai-composition-choice-box" id="configCompositionPicker"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Son seçim</span><div class="ai-recommendation-title">Aranjmanın formunu seç</div></div><p class="ai-recommendation-hint">Seçtiğin vazo, çiçekler ve tarz için en uygun üç kompozisyon. İlk seçenek Floever önerisidir.</p></div><div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:12px;">${items.map(renderCompositionChoiceCard).join("")}</div>${configState.compositionRecommendationsError ? `<p style="margin:10px 0 0;color:#8A5E3B;font-size:12px;">${escapeHtml(configState.compositionRecommendationsError)}</p>` : ""}</section>`;
}

function updateCompositionPickerUi(){
const picker = document.getElementById("configCompositionPicker");
if(!picker) return;
const wrapper = document.createElement("div");
wrapper.innerHTML = floeverAiI18n.html(renderCompositionRecommendationPickerHtml());
const replacement = wrapper.firstElementChild;
if(replacement) picker.replaceWith(replacement);
bindCompositionChoiceCards(document);
}

function bindCompositionChoiceCards(root){
Array.prototype.forEach.call((root || document).querySelectorAll("[data-composition-template-choice]"), function(button){
if(button.dataset.compositionBound === "true") return;
button.dataset.compositionBound = "true";
button.addEventListener("click", function(){
const id = String(button.getAttribute("data-composition-template-choice") || "");
if(!id) return;
configState.selectedCompositionTemplateId = id;
updateCompositionPickerUi();
renderConfigSummary();
scheduleConfiguratorStateSave();
});
});
}

async function ensureCompositionRecommendationsLoaded(force){
if(configState.step !== 3) return;
if(!selectedConfigFlowers().length) return;
const key = compositionRecommendationInputKey();
if(!force && configState.compositionRecommendationKey === key && (configState.compositionRecommendationsLoading || configState.compositionRecommendations.length)) return;
const requestId = ++compositionRecommendationRequestSerial;
configState.compositionRecommendationKey = key;
configState.compositionRecommendationsLoading = true;
configState.compositionRecommendationsError = "";
configState.compositionRecommendations = [];
configState.selectedCompositionTemplateId = "";
updateCompositionPickerUi();
try{
const response = await apiFetch("/api/composition-recommendations", {
method:"POST",
headers:{"Content-Type":"application/json"},
body:JSON.stringify({style:getSelectedArrangementStyle(),selectedVaseId:configState.vaseMode === "floever" ? configState.selectedVaseId : "",selectedFlowers:selectedConfigFlowers()})
});
const data = await readJsonResponse(response) || {};
if(requestId !== compositionRecommendationRequestSerial || key !== compositionRecommendationInputKey()) return;
if(!response.ok || !Array.isArray(data.recommendations) || !data.recommendations.length) throw new Error(data.error || "Kompozisyon önerileri alınamadı.");
configState.compositionRecommendations = data.recommendations.slice(0,3).map(normalizeCompositionRecommendation);
configState.selectedCompositionTemplateId = configState.compositionRecommendations[0] ? configState.compositionRecommendations[0].id : "";
}catch(error){
if(requestId !== compositionRecommendationRequestSerial) return;
configState.compositionRecommendations = fallbackCompositionRecommendations().map(normalizeCompositionRecommendation).slice(0,3);
configState.selectedCompositionTemplateId = configState.compositionRecommendations[0] ? configState.compositionRecommendations[0].id : "";
configState.compositionRecommendationsError = "Öneriler geçici olarak yerel kütüphaneden gösteriliyor.";
}finally{
if(requestId === compositionRecommendationRequestSerial){
configState.compositionRecommendationsLoading = false;
updateCompositionPickerUi();
scheduleConfiguratorStateSave();
}
}
}


function currentResultCompositionTemplateId(data){
return String(data && data.compositionPlan && data.compositionPlan.templateId || configState.resultCurrentCompositionTemplateId || "");
}

function postDesignCompositionRecommendationKey(data){
return compositionRecommendationInputKey() + "|result:" + currentResultCompositionTemplateId(data);
}

function ensureCurrentTemplateInsideRecommendations(data, items){
const currentId = currentResultCompositionTemplateId(data);
const list = Array.isArray(items) ? items.slice() : [];
if(!currentId || list.some(function(item){ return String(item.id) === currentId; })) return list.slice(0,3);
const plan = data && data.compositionPlan || {};
const visual = getCompositionVisualTemplateById(currentId);
list.unshift(normalizeCompositionRecommendation({
id:currentId,
name:plan.templateName || visual && visual.name || "Mevcut Kompozisyon",
description:plan.templateDescription || visual && visual.short || "İlk tasarımda kullanılan kompozisyon.",
visualKey:plan.templateVisualKey || visual && visual.svgKey || "balanced",
recommended:true
},0));
return list.slice(0,3);
}

function renderPostDesignCompositionCard(item,index,currentId){
const normalizedItem = normalizeCompositionRecommendation(item,index);
const id = String(normalizedItem.id || "");
const selected = String(configState.selectedCompositionTemplateId || "") === id;
const current = id && id === String(currentId || "");
const badge = current ? "Mevcut" : "Seçenek " + (index + 1);
return `<button type="button" class="ai-composition-choice-card ${selected ? "is-selected" : ""}" data-post-design-composition-choice="${escapeHtml(id)}" aria-pressed="${selected ? "true" : "false"}" style="appearance:none;text-align:center;width:100%;border:${selected ? "2px solid #173F2A" : "1px solid #E5DACD"};background:${selected ? "#F5FAF6" : "#FFFFFF"};border-radius:18px;padding:12px;box-shadow:${selected ? "0 8px 20px rgba(23,63,42,.09)" : "none"};cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:9px;">
<div style="width:100%;display:flex;align-items:center;justify-content:center;position:relative;min-height:24px;"><span style="font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:${current ? "#173F2A" : "#9A7442"};">${escapeHtml(badge)}</span>${selected ? '<span style="position:absolute;right:0;font-size:11px;background:#173F2A;color:#fff;border-radius:999px;padding:5px 8px;">Seçildi</span>' : ''}</div>
<div style="width:100%;max-width:250px;margin:0 auto;background:#FBF8F3;border:1px solid #F0E7DA;border-radius:14px;padding:6px;display:flex;justify-content:center;">${renderCompositionVisualSvg(normalizedItem.visualKey)}</div>
<strong style="display:block;color:#3B2A21;font-size:15px;line-height:1.35;text-align:center;">${escapeHtml(normalizedItem.name)}</strong>
<span style="display:block;max-width:230px;color:#6C5A4D;font-size:12px;line-height:1.4;text-align:center;">${escapeHtml(normalizedItem.description)}</span>
</button>`;
}

function currentArrangementStyleLabel(){
const value = getSelectedArrangementStyle() || (configState.lastResultData && configState.lastResultData.style) || "AI Seçimi";
return String(value || "AI Seçimi").replace(/\s+/g, " ").trim() || "AI Seçimi";
}

function compositionPickerTitleText(){
const style = currentArrangementStyleLabel();
if(!style || style === "AI Seçimi") return "Kompozisyon önerisi";
return `${style} Kompozisyon önerisi`;
}

function renderPostDesignCompositionPickerHtml(data){
const currentId = currentResultCompositionTemplateId(data);
const used = Math.max(0, Number(configState.compositionChangesUsed || data && data.beautify && data.beautify.iteration || 0)) >= 2;
if(configState.compositionRecommendationsLoading){
return `<section class="ai-recommendation-box ai-composition-choice-box" id="configPostDesignCompositionPicker" style="max-width:900px;margin:22px auto 0;text-align:center;"><div class="ai-recommendation-kicker">Kompozisyon seçenekleri</div><div class="ai-recommendation-title" style="margin-top:5px;">Seçenekler hazırlanıyor…</div></section>`;
}
let items = configState.compositionRecommendations.length ? configState.compositionRecommendations.slice(0,3) : [];
items = ensureCurrentTemplateInsideRecommendations(data, items);
if(!items.length){
return `<section class="ai-recommendation-box ai-composition-choice-box" id="configPostDesignCompositionPicker" style="max-width:900px;margin:22px auto 0;text-align:center;"><div class="ai-recommendation-kicker">Kompozisyon seçenekleri</div><div class="ai-recommendation-title" style="margin-top:5px;">Seçenekler hazırlanıyor…</div></section>`;
}
if(!configState.selectedCompositionTemplateId){
configState.selectedCompositionTemplateId = currentId || String(items[0].id || "");
}
const selectedIsCurrent = String(configState.selectedCompositionTemplateId || "") === String(currentId || "");
const actionHtml = used || selectedIsCurrent
? ""
: `<div style="display:flex;justify-content:center;margin-top:14px;"><button type="button" id="configApplyCompositionChoice" class="ai-btn" style="min-width:240px;"><span>Bu formu uygula</span></button></div>`;
return `<section class="ai-recommendation-box ai-composition-choice-box" id="configPostDesignCompositionPicker" style="max-width:900px;margin:22px auto 0;grid-column:1/-1;text-align:center;"><div style="margin-bottom:14px;"><div class="ai-recommendation-title">${escapeHtml(compositionPickerTitleText())}</div></div><div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;align-items:stretch;">${items.map(function(item,index){ return renderPostDesignCompositionCard(item,index,currentId); }).join("")}</div>${actionHtml}</section>`;
}

function updatePostDesignCompositionPickerUi(){
const picker = document.getElementById("configPostDesignCompositionPicker");
if(!picker || !configState.lastResultData) return;
const wrapper = document.createElement("div");
wrapper.innerHTML = floeverAiI18n.html(renderPostDesignCompositionPickerHtml(configState.lastResultData));
const replacement = wrapper.firstElementChild;
if(replacement) picker.replaceWith(replacement);
bindPostDesignCompositionControls();
}

function bindPostDesignCompositionControls(){
Array.prototype.forEach.call(document.querySelectorAll("[data-post-design-composition-choice]"), function(button){
if(button.dataset.postCompositionBound === "true") return;
button.dataset.postCompositionBound = "true";
button.addEventListener("click", function(){
const id = String(button.getAttribute("data-post-design-composition-choice") || "");
if(!id) return;
configState.selectedCompositionTemplateId = id;
updatePostDesignCompositionPickerUi();
scheduleConfiguratorStateSave();
});
});
const applyButton = document.getElementById("configApplyCompositionChoice");
if(applyButton && !applyButton.disabled && applyButton.dataset.postCompositionBound !== "true"){
applyButton.dataset.postCompositionBound = "true";
applyButton.addEventListener("click", function(){
const id = String(configState.selectedCompositionTemplateId || "");
const currentId = currentResultCompositionTemplateId(configState.lastResultData);
if(!id || id === currentId) return;
generateConfiguredArrangement({beautifyMode:"same_products", compositionTemplateId:id});
});
}
}

async function ensurePostDesignCompositionRecommendationsLoaded(data, force){
if(!data || !data.image || !selectedConfigFlowers().length) return;
const key = postDesignCompositionRecommendationKey(data);
if(!force && configState.compositionRecommendationKey === key && (configState.compositionRecommendationsLoading || configState.compositionRecommendations.length)) return;
const requestId = ++compositionRecommendationRequestSerial;
configState.compositionRecommendationKey = key;
configState.compositionRecommendationsLoading = true;
configState.compositionRecommendationsError = "";
configState.compositionRecommendations = [];
configState.resultCurrentCompositionTemplateId = currentResultCompositionTemplateId(data);
configState.selectedCompositionTemplateId = configState.resultCurrentCompositionTemplateId;
updatePostDesignCompositionPickerUi();
try{
const response = await apiFetch("/api/composition-recommendations", {
method:"POST",
headers:{"Content-Type":"application/json"},
body:JSON.stringify({style:getSelectedArrangementStyle(),selectedVaseId:configState.vaseMode === "floever" ? configState.selectedVaseId : "",selectedFlowers:selectedConfigFlowers()})
});
const responseData = await readJsonResponse(response) || {};
if(requestId !== compositionRecommendationRequestSerial || key !== postDesignCompositionRecommendationKey(data)) return;
if(!response.ok || !Array.isArray(responseData.recommendations) || !responseData.recommendations.length) throw new Error(responseData.error || "Kompozisyon önerileri alınamadı.");
configState.compositionRecommendations = ensureCurrentTemplateInsideRecommendations(data, responseData.recommendations.map(normalizeCompositionRecommendation)).slice(0,3);
}catch(error){
if(requestId !== compositionRecommendationRequestSerial) return;
configState.compositionRecommendations = ensureCurrentTemplateInsideRecommendations(data, fallbackCompositionRecommendations().map(normalizeCompositionRecommendation)).slice(0,3);
configState.compositionRecommendationsError = "Öneriler geçici olarak yerel kütüphaneden gösteriliyor.";
}finally{
if(requestId === compositionRecommendationRequestSerial){
configState.compositionRecommendationsLoading = false;
updatePostDesignCompositionPickerUi();
scheduleConfiguratorStateSave();
}
}
}

function renderCompositionResultTemplateHtml(data){
const plan = data && data.compositionPlan || {};
const template = getCompositionVisualTemplateById(plan.templateId || plan.templateName) || (plan.templateId ? {id:plan.templateId,name:plan.templateName || "Floever Kompozisyonu",short:plan.templateDescription || "Seçilen kompozisyon formu.",svgKey:plan.templateVisualKey || "balanced",family:plan.styleKey || "adaptive"} : null);
if(!template) return '';
const score = data && data.compositionPlan && data.compositionPlan.templateScore;
const scoreText = score !== undefined && score !== null ? ` · Uyum ${Number(score)}/100` : '';
return `<section class="ai-recommendation-box ai-composition-library-box" style="margin-top:14px;"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Seçilen kompozisyon</span><div class="ai-recommendation-title">${escapeHtml(template.name)}${scoreText}</div></div><p class="ai-recommendation-hint">Bu tasarım bu şablonun siluet ve yerleşim kurallarına göre üretildi.</p></div>${renderCompositionLibraryCard(template, {active:true})}</section>`;
}


function applyAiStudioPagePolish(){
const styleId = "floever-ai-page-polish-v120";
if(!document.getElementById(styleId)){
const style = document.createElement("style");
style.id = styleId;
style.textContent = `
nav[aria-label*="breadcrumb" i],
[class*="breadcrumb" i],
[id*="breadcrumb" i],
.shopify-section:has(nav[aria-label*="breadcrumb" i]),
.shopify-section:has([class*="breadcrumb" i]),
.shopify-section:has([id*="breadcrumb" i]){
  background-color:transparent !important;
  background-image:none !important;
  box-shadow:none !important;
  border-color:transparent !important;
}
#aiDesignerForm,
#aiDesignerSetupView,
#aiDesignerResultView,
#ai-result,
#aiDesignerForm > .shopify-section,
.ai-designer-page,
.ai-designer-shell{
  background-color:transparent !important;
  background-image:none !important;
}
#configResultMainImage{
  display:block;
  margin-left:auto !important;
  margin-right:auto !important;
  object-position:center center !important;
}
@media(max-width:760px){
  #configPostDesignCompositionPicker > div[style*="grid-template-columns"]{
    display:grid !important;
    grid-template-columns:none !important;
    grid-auto-flow:column !important;
    grid-auto-columns:minmax(78%,280px) !important;
    gap:10px !important;
    overflow-x:auto !important;
    overscroll-behavior-inline:contain;
    scroll-snap-type:x mandatory;
    justify-content:start !important;
    padding:2px 2px 12px !important;
    scrollbar-width:thin;
  }
  #configPostDesignCompositionPicker > div[style*="grid-template-columns"] > button{
    scroll-snap-align:start;
  }
}
`;
document.head.appendChild(style);
}

/* Sayfanın ve AI Studio'nun genel arka planına müdahale edilmez; tema rengi korunur. */
const breadcrumbNodes = document.querySelectorAll(
'nav[aria-label*="breadcrumb" i], [class*="breadcrumb" i], [id*="breadcrumb" i]'
);
Array.prototype.forEach.call(breadcrumbNodes, function(node){
try{ node.style.setProperty("background-color", "transparent", "important"); }catch(error){}
const section = node.closest('.shopify-section, [id^="shopify-section-"]');
if(section && !section.contains(form)){
try{ section.style.setProperty("background-color", "transparent", "important"); }catch(error){}
}
});
}
applyAiStudioPagePolish();
try {
  [form, setupView, resultView, resultBox].filter(Boolean).forEach(function(node){
    node.style.setProperty("background-color", "transparent", "important");
    node.style.setProperty("background-image", "none", "important");
  });
  const studioSection = form.closest('.shopify-section, [id^="shopify-section-"]');
  if(studioSection){
    studioSection.style.setProperty("background-color", "transparent", "important");
    studioSection.style.setProperty("background-image", "none", "important");
  }
} catch(error) {}

function escapeHtml(value){
return String(value ?? "")
.replace(/&/g, "&amp;")
.replace(/</g, "&lt;")
.replace(/>/g, "&gt;")
.replace(/"/g, "&quot;")
.replace(/'/g, "&#039;");
}
async function readJsonResponse(response){
try{
return await response.json();
}catch(error){
return null;
}
}
function fetchWithTimeout(url, options, timeoutMs){
if(typeof AbortController === "undefined"){
return fetch(url, options || {});
}
const controller = new AbortController();
const timer = window.setTimeout(function(){
controller.abort();
}, timeoutMs || 6500);
const requestOptions = Object.assign({}, options || {}, { signal: controller.signal });
return fetch(url, requestOptions).finally(function(){
window.clearTimeout(timer);
});
}
function getCleanDesignPageUrl(){
try{
const url = new URL(window.location.href);
url.searchParams.delete(HANDOFF_QUERY_PARAM);
return url.toString();
}catch(error){
return DESIGN_PAGE_URL;
}
}
function getDesignReturnPath(){
try{
const path = window.location.pathname || "/pages/vazona-ozel-tasarla";
return path.startsWith("/") ? path : "/pages/vazona-ozel-tasarla";
}catch(error){
return "/pages/vazona-ozel-tasarla";
}
}
function buildLoginDestination(){
const config = window.FLOEVER_AI_STUDIO_CONFIG || {};
const destination = new URL(config.storefrontLoginUrl || "/customer_authentication/login", window.location.origin);
destination.searchParams.set("return_to", getDesignReturnPath());
destination.searchParams.set("locale", config.locale || document.documentElement.lang || "tr");
return destination.pathname + destination.search;
}
function navigateTopLevel(url){
try{
if(window.top && window.top !== window){
window.top.location.href = url;
return;
}
}catch(error){
// Cross-origin kısıtı olursa normal pencere yönlendirmesine düşeriz.
}
window.location.href = url;
}
function setPageModalState(isOpen){
document.documentElement.style.overflow = isOpen ? "hidden" : "";
document.body.style.overflow = isOpen ? "hidden" : "";
}
function openModal(modal){
if(!modal) return;
modal.hidden = false;
if(modal.id === "aiCreditModal"){
  modal.scrollTop = 0;
  const creditCard = modal.querySelector(".ai-credit-modal");
  if(creditCard) creditCard.scrollTop = 0;
}
setPageModalState(true);
const focusTarget = modal.querySelector("button:not([disabled]), a[href]");
window.setTimeout(function(){ focusTarget?.focus(); }, 30);
}
function closeModal(modal){
if(!modal) return;
modal.hidden = true;
const anotherOpen = [guideModal, authModal, creditModal, profileModal].some(function(item){
return item && !item.hidden;
});
if(!anotherOpen) setPageModalState(false);
}
function renderInlineGuide(){}
function maybeShowFirstUseGuide(){}
async function saveGuideCompletion(){}
function applySystemSettings(settings){
if(!settings) return;
systemState.aiSystemPaused = Boolean(settings.aiSystemPaused);
systemState.aiSystemPauseMessage = settings.aiSystemPauseMessage || systemState.aiSystemPauseMessage;
systemState.profileCompletionRequired = Boolean(settings.profileCompletionRequired);
}
function applyCustomerProfile(profile){
if(!profile) return;
profileState.loaded = true;
profileState.profile = profile;
if(profileFirstName && !profileFirstName.value) profileFirstName.value = profile.firstName || "";
if(profileLastName && !profileLastName.value) profileLastName.value = profile.lastName || "";
if(profilePhone && !profilePhone.value) profilePhone.value = profile.phone || "";
if(profileKvkk) profileKvkk.checked = Boolean(profile.kvkkConsent);
if(profileMarketing) profileMarketing.checked = Boolean(profile.marketingConsent);
}
function isProfileComplete(){
const profile = profileState.profile || authState.customer?.profile || null;
return Boolean(profile && (profile.completed || authState.customer?.profileCompleted));
}
function shouldRequireProfileCompletion(){
return authState.mode === "authenticated" && !systemState.aiSystemPaused && systemState.profileCompletionRequired && !isProfileComplete();
}
function setProfileStatus(message, tone){
if(!profileStatus) return;
profileStatus.textContent = floeverAiI18n.text(message || "");
profileStatus.classList.toggle("is-success", tone === "success");
profileStatus.classList.toggle("is-error", tone === "error");
}
function openProfileCompletionModal(){
if(!profileModal) return;
const profile = profileState.profile || authState.customer?.profile || {};
if(profileFirstName) profileFirstName.value = profile.firstName || profileFirstName.value || "";
if(profileLastName) profileLastName.value = profile.lastName || profileLastName.value || "";
if(profilePhone) profilePhone.value = profile.phone || profilePhone.value || "";
if(profileKvkk) profileKvkk.checked = Boolean(profile.kvkkConsent);
if(profileMarketing) profileMarketing.checked = Boolean(profile.marketingConsent);
setProfileStatus("", "");
openModal(profileModal);
}
async function saveCustomerProfileForm(){
if(!profileForm) return;
if(profileSaveButton) profileSaveButton.disabled = true;
setProfileStatus("Bilgileriniz kaydediliyor…", "");
try{
const response = await apiFetch("/api/me/profile", {
method:"PUT",
headers:{"Content-Type":"application/json"},
body:JSON.stringify({
firstName: profileFirstName?.value || "",
lastName: profileLastName?.value || "",
phone: profilePhone?.value || "",
kvkkConsent: Boolean(profileKvkk?.checked),
marketingConsent: Boolean(profileMarketing?.checked)
})
});
const data = await readJsonResponse(response);
if(!response.ok || !data?.success) throw new Error(data?.error || "Bilgiler kaydedilemedi.");
if(data.systemSettings) applySystemSettings(data.systemSettings);
if(data.profile) applyCustomerProfile(data.profile);
if(data.customer) authState.customer = data.customer;
setProfileStatus("Bilgileriniz kaydedildi.", "success");
window.setTimeout(function(){ closeModal(profileModal); updateCreditUI(); }, 350);
}catch(error){
setProfileStatus(error?.message || "Bilgiler kaydedilemedi.", "error");
}finally{
if(profileSaveButton) profileSaveButton.disabled = false;
}
}
function getScenarioLabel(scenario){
return "Floever Çiçekleriyle Tasarla";
}
function rememberPendingScenario(scenario){
try{
localStorage.setItem(PENDING_SCENARIO_KEY, String(scenario || ""));
}catch(error){
// Depolama kapalıysa yalnızca mevcut oturum için devam edilir.
}
}
function readPendingScenario(){
try{
return String(localStorage.getItem(PENDING_SCENARIO_KEY) || "");
}catch(error){
return "";
}
}
function clearPendingScenario(){
try{
localStorage.removeItem(PENDING_SCENARIO_KEY);
}catch(error){}
}
function openAuthPrompt(scenario, reason){
if(scenario) rememberPendingScenario(scenario);
if(authScenarioText){
authScenarioText.textContent = floeverAiI18n.text(reason === "credits"
? "Kredi satın almak ve bakiyenizi hesabınıza tanımlamak için giriş yapın."
: "Seçiminiz: " + getScenarioLabel(scenario));
}
const loginUrl = buildLoginDestination();
if(loginButton) loginButton.href = loginUrl;
if(registerButton) registerButton.href = loginUrl;
navigateTopLevel(loginUrl);
}
function setCreditModalStatus(message, tone){
if(!creditModalStatus) return;
creditModalStatus.textContent = floeverAiI18n.text(message || "");
creditModalStatus.classList.toggle("is-success", tone === "success");
creditModalStatus.classList.toggle("is-error", tone === "error");
}
function setCreditModalWarning(message){
if(!creditModalWarning) return;
creditModalWarning.textContent = floeverAiI18n.text(message || "");
creditModalWarning.hidden = !message;
}
function openCreditPurchaseModal(options){
if(authState.mode !== "authenticated"){
openAuthPrompt("", "credits");
return;
}
if(!creditModal) return;
const opts = options && !options.type ? options : {};
if(opts.reason === "insufficient") {
const available = Number.isFinite(Number(opts.availableCredits)) ? Number(opts.availableCredits) : Number(creditState.balance || 0);
const required = Number.isFinite(Number(opts.requiredCredits)) ? Number(opts.requiredCredits) : "—";
setCreditModalWarning("Krediniz yetersiz. Gerekli kredi: " + required + ". Mevcut krediniz: " + available + ". Devam etmek için kredi yükleyin.");
}else{
setCreditModalWarning("");
}
setCreditModalStatus("", "");
openModal(creditModal);
}
function loadStoredStorefrontSession(){
try{
const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
if(!raw) return null;
const stored = JSON.parse(raw);
const now = Math.floor(Date.now() / 1000);
if(
!stored?.token ||
!stored?.apiBaseUrl ||
Number(stored?.expiresAt) <= now + 45
){
sessionStorage.removeItem(SESSION_STORAGE_KEY);
return null;
}
return stored;
}catch(error){
return null;
}
}
function clearStoredStorefrontSession(){
authState.token = "";
authState.expiresAt = 0;
authState.apiBaseUrl = API_BASE_URL;
try{
sessionStorage.removeItem(SESSION_STORAGE_KEY);
sessionStorage.removeItem(STARTER_NOTICE_KEY);
}catch(error){
// Oturum depolaması temizlenemese bile sayfa güvenli şekilde misafir moda düşer.
}
}
function saveStorefrontSession(){
try{
sessionStorage.setItem(
SESSION_STORAGE_KEY,
JSON.stringify({
token: authState.token,
apiBaseUrl: authState.apiBaseUrl,
expiresAt: authState.expiresAt
})
);
}catch(error){
// sessionStorage kapalı olsa bile mevcut sayfa oturumu çalışır.
}
}
function removeHandoffFromAddress(){
try{
const url = new URL(window.location.href);
if(!url.searchParams.has(HANDOFF_QUERY_PARAM)) return;
url.searchParams.delete(HANDOFF_QUERY_PARAM);
window.history.replaceState({}, "", url.toString());
}catch(error){
// Adres temizlenemezse oturum yine çalışmaya devam eder.
}
}
function applyStorefrontSessionResponse(data, fallbackApiBaseUrl){
const now = Math.floor(Date.now() / 1000);
authState.token = String(data.token);
authState.apiBaseUrl = String(
data.apiBaseUrl || fallbackApiBaseUrl || APP_PROXY_BASE_URL
).replace(/\/+$/, "");
authState.expiresAt = Number(data.expiresAt) || now + 3600;
authState.mode = "authenticated";
authState.customer = data?.bootstrap?.customer || authState.customer;
if(data?.bootstrap?.systemSettings) applySystemSettings(data.bootstrap.systemSettings);
if(data?.bootstrap?.profile) applyCustomerProfile(data.bootstrap.profile);
else if(data?.bootstrap?.customer?.profile) applyCustomerProfile(data.bootstrap.customer.profile);
if(data?.bootstrap){
creditState.enabled = Boolean(data.bootstrap.creditSystemEnabled);
creditState.costs = Object.assign({}, creditState.costs, data.bootstrap.costs || {});
creditState.balance = data.bootstrap.customer?.creditBalance ?? creditState.balance;
creditState.starterCredits = Number(data.bootstrap.starterCredits || creditState.starterCredits || 3);
creditState.starterCreditBlockedByIp = Boolean(data.bootstrap.starterCreditBlockedByIp);
creditState.starterCreditBlockReason = data.bootstrap.starterCreditBlockReason || "";
creditState.starterCreditMessage = data.bootstrap.starterCreditMessage || "";
if(data.bootstrap.starterCreditGrantedNow){
try{
creditState.showStarterNotice = sessionStorage.getItem(STARTER_NOTICE_KEY) !== "1";
if(creditState.showStarterNotice){
sessionStorage.setItem(STARTER_NOTICE_KEY, "1");
}
}catch(error){
creditState.showStarterNotice = true;
}
}
}
saveStorefrontSession();
return authState;
}
async function exchangeHandoffCode(handoffCode){
const response = await fetch(API_BASE_URL + "/api/storefront-session/exchange", {
method:"POST",
credentials:"omit",
cache:"no-store",
headers:{
Accept:"application/json",
"Content-Type":"application/json"
},
body:JSON.stringify({code:handoffCode})
});
const data = await readJsonResponse(response);
if(!response.ok || !data?.success || !data?.token){
const error = new Error(
data?.error ||
"Tasarım sayfası müşteri oturumu oluşturulamadı."
);
error.code = data?.code || "STOREFRONT_SESSION_FAILED";
error.status = response.status;
throw error;
}
applyStorefrontSessionResponse(data, API_BASE_URL);
removeHandoffFromAddress();
return authState;
}
async function prepareStorefrontSessionViaAppProxy(){
const response = await fetchWithTimeout(APP_PROXY_SESSION_PREPARE_URL, {
method:"GET",
credentials:"include",
cache:"no-store",
headers:{Accept:"application/json"}
}, 6500);
const data = await readJsonResponse(response);
if(!response.ok || !data?.success || !data?.token){
const error = new Error(
data?.error ||
"Müşteri hesabı doğrulanamadı."
);
error.code = data?.code || "STOREFRONT_SESSION_PREPARE_FAILED";
error.status = response.status;
throw error;
}
return applyStorefrontSessionResponse(data, APP_PROXY_BASE_URL);
}
async function ensureStorefrontSession(forceRefresh){
const now = Math.floor(Date.now() / 1000);
if(!forceRefresh && authState.token && authState.expiresAt > now + 45){
return authState;
}
if(!forceRefresh && authState.request){
return authState.request;
}
authState.request = (async function(){
const pageUrl = new URL(window.location.href);
const handoffCode = String(
pageUrl.searchParams.get(HANDOFF_QUERY_PARAM) || ""
).trim();
if(handoffCode){
return exchangeHandoffCode(handoffCode);
}
return prepareStorefrontSessionViaAppProxy();
})().finally(function(){
authState.request = null;
});
return authState.request;
}
async function apiFetch(path, options){
const session = await ensureStorefrontSession(false);
const requestOptions = Object.assign({}, options || {});
const headers = new Headers(requestOptions.headers || {});
headers.set("Authorization", "Bearer " + session.token);
headers.set("Accept", "application/json");
requestOptions.headers = headers;
requestOptions.cache = requestOptions.cache || "no-store";
const targetUrl = session.apiBaseUrl + (path.startsWith("/") ? path : "/" + path);
if(String(path || "") === "/generate" || String(path || "").endsWith("/generate")){
return fetchWithTimeout(targetUrl, requestOptions, 180000);
}
return fetch(targetUrl, requestOptions);
}
function getBackendScenarioKey(){
return "scenario_2c_gpt_own_flowers";
}
function getCurrentCreditCost(){
const key = getBackendScenarioKey();
if(!key) return null;
const cost = Number(creditState.costs[key]);
return Number.isFinite(cost) ? cost : null;
}
function getScenarioCreditCostFor(scenario, mode){
const cost = Number(creditState.costs.scenario_2c_gpt_own_flowers);
return Number.isFinite(cost) ? cost : null;
}
function hasInsufficientCreditsForScenario(scenario, mode){
if(!creditState.enabled) return false;
const cost = getScenarioCreditCostFor(scenario, mode);
if(cost === null) return false;
const balance = Number(creditState.balance);
return Number.isFinite(balance) && balance < cost;
}
function setDesignerLocked(isLocked){

if(submitButton && !submitButton.dataset.processing){
submitButton.disabled = Boolean(isLocked || systemState.aiSystemPaused || shouldRequireProfileCompletion() || authState.mode === "guest");
}
}
function updateStarterCreditBanner(){
if(!starterCreditBanner) return;
const credits = Number(creditState.starterCredits || 3);
const title = starterCreditBanner.querySelector("strong");
const subtitle = starterCreditBanner.querySelector("span");
if(authState.mode === "authenticated"){
/* Kullanıcı giriş yaptıktan ve ücretsiz kredi kontrolü tamamlandıktan sonra
hediye kredi bandını kaldırıyoruz. Bu alan sadece girişsiz ziyaretçiyi
bilgilendirmek için kullanılır. */
starterCreditBanner.classList.add("is-hidden");
if(starterLoginButton) starterLoginButton.hidden = true;
return;
}
starterCreditBanner.classList.remove("is-hidden", "is-authenticated");
if(title) title.textContent = floeverAiI18n.text("Kendi vazonuzda aranjmanı görün");
if(subtitle) subtitle.textContent = floeverAiI18n.text("Vazonuzu yükleyin, çiçek ve renkleri seçin. Yeni kullanıcılar " + credits + " ücretsiz krediyle başlayabilir.");
const pill = starterCreditBanner.querySelector(".ai-starter-credit-pill");
if(pill) pill.textContent = floeverAiI18n.text("Yeni kullanıcıya " + credits + " kredi hediye");
if(starterLoginButton){
starterLoginButton.hidden = true;
}
}
function updateCreditUI(){
updateStarterCreditBanner();
const selectedCost = getCurrentCreditCost();
const hasScenario = Boolean(getBackendScenarioKey());
const hasKnownBalance =
creditState.balance !== null &&
creditState.balance !== "" &&
Number.isFinite(Number(creditState.balance));
const insufficient = creditState.enabled && hasScenario && selectedCost !== null && hasKnownBalance && Number(creditState.balance) < selectedCost;
const systemPaused = Boolean(systemState.aiSystemPaused);
const profileRequired = shouldRequireProfileCompletion();
if(creditBalanceElement){
if(!creditState.loaded){
creditBalanceElement.textContent = floeverAiI18n.text("—");
}else if(authState.mode === "guest"){
creditBalanceElement.textContent = floeverAiI18n.text("Giriş gerekli");
}else if(!creditState.enabled){
creditBalanceElement.textContent = floeverAiI18n.text("Kredi sistemi kapalı");
}else{
creditBalanceElement.textContent = floeverAiI18n.text(hasKnownBalance
? Number(creditState.balance) + " kredi"
: "—");
}
}
if(currentCostElement){
currentCostElement.textContent = floeverAiI18n.text(hasScenario && selectedCost !== null
? selectedCost + " kredi"
: "Henüz seçilmedi");
}
document.querySelectorAll("[data-credit-for]").forEach(function(element){
const key = element.getAttribute("data-credit-for");
const cost = Number(creditState.costs[key]);
element.textContent = floeverAiI18n.text(Number.isFinite(cost) ? cost + " kredi" : "—");
});
if(scenarioTwoCreditElement){
const scenarioTwoCost = Number(creditState.costs.scenario_2a_gpt_same);
scenarioTwoCreditElement.textContent = floeverAiI18n.text(Number.isFinite(scenarioTwoCost)
? scenarioTwoCost + " kredi"
: "—");
}
if(scenarioThreeCreditElement){
const scenarioThreeCost = Number(creditState.costs.scenario_2c_gpt_own_flowers);
scenarioThreeCreditElement.textContent = floeverAiI18n.text(Number.isFinite(scenarioThreeCost)
? scenarioThreeCost + " kredi"
: "—");
}
if(submitCreditElement){
if(hasScenario && selectedCost !== null){
submitCreditElement.textContent = floeverAiI18n.text(selectedCost + " kredi");
submitCreditElement.classList.add("is-visible");
}else{
submitCreditElement.textContent = floeverAiI18n.text("");
submitCreditElement.classList.remove("is-visible");
}
}
if(creditPanel){
creditPanel.classList.toggle("is-warning", insufficient);
creditPanel.classList.toggle("has-scenario", hasScenario);
creditPanel.classList.toggle("is-guest", authState.mode === "guest");
creditPanel.classList.toggle("is-authenticated", authState.mode === "authenticated");
creditPanel.classList.toggle("is-empty", hasKnownBalance && Number(creditState.balance) <= 0);
}
if(creditStatusElement){
if(!creditState.loaded){
creditStatusElement.textContent = floeverAiI18n.text("Hesap durumunuz kontrol ediliyor…");
}else if(systemPaused){
creditStatusElement.textContent = floeverAiI18n.text(systemState.aiSystemPauseMessage || "Floever AI Studio geçici olarak durduruldu.");
}else if(authState.mode === "guest"){
creditStatusElement.textContent = floeverAiI18n.text(hasScenario ? "Devam etmek için giriş yapmanız gerekir. Yeni kullanıcılar " + creditState.starterCredits + " ücretsiz krediyle başlayabilir." : "Başlamak için aşağıdan bir senaryo seçin. Giriş sonrası krediniz hesabınıza tanımlanır.");
}else if(profileRequired){
creditStatusElement.textContent = floeverAiI18n.text("Devam etmek için iletişim bilgilerinizi tamamlayın.");
}else if(!creditState.enabled){
creditStatusElement.textContent = floeverAiI18n.text("Kredi sistemi şu anda devre dışı. Tasarıma devam edebilirsiniz.");
}else if(!hasScenario && creditState.starterCreditBlockedByIp){
creditStatusElement.textContent = floeverAiI18n.text(creditState.starterCreditMessage || "Ücretsiz başlangıç kredisi bu internet bağlantısı üzerinden daha önce kullanılmış. Devam etmek için kredi satın alabilirsiniz.");
}else if(!hasScenario && creditState.showStarterNotice){
creditStatusElement.textContent = floeverAiI18n.text("Hoş geldiniz! Hesabınıza " + creditState.starterCredits + " ücretsiz kredi tanımlandı.");
}else if(!hasScenario){
creditStatusElement.textContent = floeverAiI18n.text("Kredi bilginiz burada görünür. Senaryo kredileri kartların üzerinde yazıyor.");
}else if(insufficient){
creditStatusElement.textContent = floeverAiI18n.text("Krediniz yetersiz. Gerekli: " + selectedCost + " · Mevcut: " + creditState.balance + ".");
}else{
creditStatusElement.textContent = floeverAiI18n.text("Krediniz yeterli. Tasarımı oluşturabilirsiniz.");
}
}
if(buyCreditsButton){
buyCreditsButton.textContent = floeverAiI18n.text(authState.mode === "guest"
? "Giriş Yap"
: "Kredi Satın Al");
}
if(submitButton && !submitButton.dataset.processing){
submitButton.disabled = Boolean(systemPaused || profileRequired || insufficient || authState.mode === "guest");
}
}
async function loadCreditData(){
try{
if(creditStatusElement){
creditStatusElement.textContent = floeverAiI18n.text("Güvenli müşteri oturumu hazırlanıyor…");
}
await ensureStorefrontSession(false);
const responses = await Promise.all([
apiFetch("/api/design-costs"),
apiFetch("/api/me/credits")
]);
const costsData = await readJsonResponse(responses[0]);
const creditsData = await readJsonResponse(responses[1]);
if(!responses[0].ok) throw new Error(costsData?.error || "Tasarım ücretleri alınamadı.");
if(!responses[1].ok) throw new Error(creditsData?.error || "Kredi bakiyesi alınamadı.");
authState.mode = "authenticated";
if(costsData?.systemSettings) applySystemSettings(costsData.systemSettings);
if(creditsData?.systemSettings) applySystemSettings(creditsData.systemSettings);
authState.customer = creditsData?.customer || authState.customer;
if(creditsData?.profile) applyCustomerProfile(creditsData.profile);
else if(creditsData?.customer?.profile) applyCustomerProfile(creditsData.customer.profile);
creditState.enabled = Boolean(costsData?.creditSystemEnabled && creditsData?.creditSystemEnabled);
creditState.loaded = true;
creditState.costs = Object.assign({}, creditState.costs, costsData?.costs || {});
creditState.balance = creditsData?.customer?.creditBalance ?? null;
creditState.starterCredits = Number(creditsData?.starterCredits || 3);
creditState.starterCreditBlockedByIp = Boolean(creditsData?.starterCreditBlockedByIp);
creditState.starterCreditBlockReason = creditsData?.starterCreditBlockReason || "";
creditState.starterCreditMessage = creditsData?.starterCreditMessage || "";
if(creditsData?.starterCreditGrantedNow){
try{
creditState.showStarterNotice = sessionStorage.getItem(STARTER_NOTICE_KEY) !== "1";
if(creditState.showStarterNotice){
sessionStorage.setItem(STARTER_NOTICE_KEY, "1");
}
}catch(error){
creditState.showStarterNotice = true;
}
}
setDesignerLocked(false);
updateCreditUI();
void loadPreviousDesigns(false);
if(shouldRequireProfileCompletion()) openProfileCompletionModal();
maybeShowFirstUseGuide();
}catch(error){
const isGuest =
error?.code === "STOREFRONT_HANDOFF_REQUIRED" ||
error?.code === "SHOPIFY_CUSTOMER_LOGIN_REQUIRED" ||
error?.code === "CUSTOMER_AUTH_REQUIRED" ||
error?.name === "AbortError" ||
error?.status === 401;
if(isGuest){
clearStoredStorefrontSession();
authState.mode = "guest";
authState.customer = null;
creditState.showStarterNotice = false;
creditState.starterCreditBlockedByIp = false;
creditState.starterCreditBlockReason = "";
creditState.starterCreditMessage = "";
try{
const response = await fetch(API_BASE_URL + "/api/design-costs", {
method:"GET",
credentials:"omit",
cache:"no-store",
headers:{Accept:"application/json"}
});
const data = await readJsonResponse(response);
if(response.ok){
if(data?.systemSettings) applySystemSettings(data.systemSettings);
creditState.enabled = Boolean(data?.creditSystemEnabled);
creditState.costs = Object.assign({}, creditState.costs, data?.costs || {});
}
}catch(costError){
creditState.enabled = true;
}
creditState.loaded = true;
creditState.balance = null;
setDesignerLocked(false);
updateCreditUI();
renderPreviousDesignsSlider();
maybeShowFirstUseGuide();
return;
}
authState.mode = "error";
creditState.loaded = true;
creditState.enabled = true;
creditState.balance = null;
setDesignerLocked(false);
updateCreditUI();
if(creditStatusElement){
creditStatusElement.textContent =
floeverAiI18n.text(error?.message ||
"Kredi bilgileriniz alınamadı. Lütfen daha sonra tekrar deneyin.");
}
}
}
function setFormMessage(message, tone){
if(!formMessageBox) return;
formMessageBox.textContent = floeverAiI18n.text(message || "");
formMessageBox.classList.toggle("is-visible", Boolean(message));
formMessageBox.classList.toggle("is-error", tone === "error");
}
function showSetupView(){
if(setupView) setupView.classList.remove("ai-stage-hidden");
if(resultView) resultView.classList.add("ai-stage-hidden");
window.setTimeout(function(){
if(setupView) setupView.scrollIntoView({behavior:"smooth", block:"start"});
}, 40);
}
function showResultView(){
if(setupView) setupView.classList.add("ai-stage-hidden");
if(resultView) resultView.classList.remove("ai-stage-hidden");
window.setTimeout(function(){
if(resultView) resultView.scrollIntoView({behavior:"smooth", block:"start"});
}, 40);
}
if(backToDesignerButton){
backToDesignerButton.textContent = floeverAiI18n.text("← Yeni Tasarım");
backToDesignerButton.addEventListener("click", function(){
startFreshDesignFlow({confirm:true});
});
}
function setSubmitProcessing(isProcessing){
if(!submitButton) return;
if(isProcessing){
submitButton.dataset.processing = "true";
submitButton.disabled = true;
if(submitButtonText) submitButtonText.textContent = floeverAiI18n.text("Aranjman hazırlanıyor…");
}else{
delete submitButton.dataset.processing;
if(submitButtonText) submitButtonText.textContent = floeverAiI18n.text("Aranjmanımı Tasarla");
updateCreditUI();
}
}
function showElement(element, displayType){
if(!element) return;
const requestedDisplay = displayType || "block";
const mobileLayout = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
if(mobileLayout && (element.id === "arrangementModeBox") && requestedDisplay === "grid"){
element.style.display = "block";
return;
}
element.style.display = requestedDisplay;
}
function hideElement(element){
if(element) element.style.display = "none";
}
function clearCheckedInputs(container){
if(!container) return;
container.querySelectorAll('input[type="checkbox"]').forEach(function(input){
input.checked = false;
});
}
function resetSelects(container){
if(!container) return;
container.querySelectorAll('select').forEach(function(select){
select.value = "";
});
}
function updateUploadFilename(input, fileNameElement){
if(!input || !fileNameElement) return;
const box = input.closest('.upload-box');
if(input.files && input.files.length){
box.classList.add('has-file');
if(input.files.length === 1){
fileNameElement.textContent = floeverAiI18n.text('✓ ' + input.files[0].name);
}else{
fileNameElement.textContent = floeverAiI18n.text('✓ ' + input.files.length + ' görsel seçildi');
}
}else{
box.classList.remove('has-file');
fileNameElement.textContent = floeverAiI18n.text('');
}
}
function bindUpload(inputId, fileNameId){
const input = document.getElementById(inputId);
const fileName = document.getElementById(fileNameId);
if(!input || !fileName) return;
input.addEventListener('change', function(){
updateUploadFilename(input, fileName);
});
}
function setReferenceUploadAsArrangement(){
if(arrangementUploadLabel) arrangementUploadLabel.innerHTML = floeverAiI18n.html('Örnek Aranjman <span>*</span>');
if(arrangementUploadIcon) arrangementUploadIcon.textContent = floeverAiI18n.text('💐');
if(arrangementUploadTitle) arrangementUploadTitle.textContent = floeverAiI18n.text('Örnek aranjman fotoğrafını yükleyin');
if(arrangementUploadSubtitle) arrangementUploadSubtitle.textContent = floeverAiI18n.text('JPG, PNG, WEBP — Max 10 MB');
if(arrangementImage) arrangementImage.removeAttribute('multiple');
}
function setReferenceUploadAsFlowers(){
if(arrangementUploadLabel) arrangementUploadLabel.innerHTML = floeverAiI18n.html('Çiçek Fotoğrafları <span>*</span>');
if(arrangementUploadIcon) arrangementUploadIcon.textContent = floeverAiI18n.text('🌸');
if(arrangementUploadTitle) arrangementUploadTitle.textContent = floeverAiI18n.text('Çiçek fotoğraflarını yükleyin');
if(arrangementUploadSubtitle) arrangementUploadSubtitle.textContent = floeverAiI18n.text('Birden fazla görsel seçebilirsiniz — Max 10 MB');
if(arrangementImage) arrangementImage.setAttribute('multiple', 'multiple');
}
function resetArrangementInput(){
if(!arrangementImage) return;
arrangementImage.value = "";
if(arrangementFilename) arrangementFilename.textContent = floeverAiI18n.text("");
const box = arrangementImage.closest('.upload-box');
if(box) box.classList.remove('has-file');
}
function updateReferenceModeUI(){
updateCreditUI();
}
const MAX_LIBRARY_FLOWERS = 3;
function selectedLibraryFlowers(){
return flowerLibraryItems.filter(function(item){ return selectedLibraryFlowerIds.has(String(item.id)); }).map(function(item){
const countInput = document.querySelector('[data-library-count="' + String(item.id).replace(/"/g,'\\"') + '"]');
return {
id:String(item.id),
name:item.name,
imageUrl:item.imageUrl,
color:item.color || '',
category:item.category || '',
variantId:item.variantId || '',
productUrl:item.productUrl || '',
priceLabel:item.priceLabel || '',
count:(countInput && countInput.value ? countInput.value : '')
};
});
}
function syncSelectedLibraryFlowers(){
if(selectedLibraryFlowersInput){
selectedLibraryFlowersInput.value = JSON.stringify(selectedLibraryFlowers().map(function(item){ return {id:item.id,count:item.count}; }));
}
}
function renderFlowerLibrary(){
if(!flowerLibraryGrid || !flowerLibraryStatus) return;
if(!flowerLibraryItems.length){
flowerLibraryGrid.innerHTML = floeverAiI18n.html('');
flowerLibraryStatus.textContent = floeverAiI18n.text('Henüz seçilebilir çiçek eklenmemiş. Floever ekibi panelden çiçek kütüphanesini oluşturduktan sonra bu senaryo kullanılabilir.');
return;
}
flowerLibraryStatus.textContent = floeverAiI18n.text('Aranjmanda kullanmak istediğiniz Floever çiçeklerini seçin.');
flowerLibraryGrid.innerHTML = floeverAiI18n.html(flowerLibraryItems.map(function(item){
const id = String(item.id || '');
const selected = selectedLibraryFlowerIds.has(id);
const meta = [item.color, item.category, item.priceLabel].filter(Boolean).join(' · ');
return `
<button type="button" class="ai-flower-option ${selected ? 'is-selected' : ''}" data-library-flower="${escapeHtml(id)}">
<img src="${escapeHtml(item.imageUrl || '')}" alt="${escapeHtml(item.name || 'Çiçek')}">
<span>
<strong>${escapeHtml(item.name || 'Çiçek')}</strong>
<span>${escapeHtml(meta || item.notes || 'Floever çiçeği')}</span>
<input class="ai-flower-count" data-library-count="${escapeHtml(id)}" type="number" min="1" max="99" placeholder="Adet" value="${escapeHtml(item.count || '')}" onclick="event.stopPropagation()">
</span>
</button>`;
}).join(''));
flowerLibraryGrid.querySelectorAll('[data-library-flower]').forEach(function(button){
button.addEventListener('click', function(){
const id = button.getAttribute('data-library-flower');
if(selectedLibraryFlowerIds.has(id)){
selectedLibraryFlowerIds.delete(id);
}else{
if(selectedLibraryFlowerIds.size >= MAX_LIBRARY_FLOWERS){
setFormMessage('En fazla ' + MAX_LIBRARY_FLOWERS + ' çiçek seçebilirsiniz.', 'error');
return;
}
selectedLibraryFlowerIds.add(id);
}
syncSelectedLibraryFlowers();
renderFlowerLibrary();
updateCreditUI();
});
});
flowerLibraryGrid.querySelectorAll('[data-library-count]').forEach(function(input){
input.addEventListener('change', syncSelectedLibraryFlowers);
input.addEventListener('input', syncSelectedLibraryFlowers);
});
syncSelectedLibraryFlowers();
}
async function loadFlowerLibraryForCustomer(){
if(!flowerLibraryGrid) return;
try{
const response = await fetch(String(API_BASE_URL).replace(/\/+$/, '') + '/api/flower-library', {cache:'no-store'});
const data = await readJsonResponse(response) || {};
if(!response.ok) throw new Error(data.error || 'Çiçek kütüphanesi yüklenemedi.');
flowerLibraryItems = Array.isArray(data.flowers) ? data.flowers : [];
renderFlowerLibrary();
}catch(error){
flowerLibraryItems = [];
if(flowerLibraryStatus) flowerLibraryStatus.textContent = floeverAiI18n.text(error?.message || 'Çiçek kütüphanesi yüklenemedi.');
renderFlowerLibrary();
}
}
function resetOwnFlowersSection(){
selectedLibraryFlowerIds.clear();
if(aiSupportMode) aiSupportMode.value = 'off';
syncSelectedLibraryFlowers();
renderFlowerLibrary();
}
function collectSelectedLibraryFlowers(){
return selectedLibraryFlowers();
}
bindUpload('vaseImage','vaseFilename');
bindUpload('arrangementImage','arrangementFilename');
hideElement(arrangementModeBox);
hideElement(ownFlowersSection);
hideElement(flowerColorSection);
hideElement(styleAreaSection);
resetOwnFlowersSection();
setDesignerLocked(true);
if(arrangementMode){
arrangementMode.addEventListener("change", function(){
resetArrangementInput();
updateReferenceModeUI();
});
}


if(profileForm){
profileForm.addEventListener("submit", function(event){
event.preventDefault();
saveCustomerProfileForm();
});
}
if(authCloseButton){
authCloseButton.addEventListener("click", function(){ closeModal(authModal); });
}
if(creditModalCloseButton){
creditModalCloseButton.addEventListener("click", function(){ closeModal(creditModal); });
}
if(buyCreditsButton){
buyCreditsButton.addEventListener("click", openCreditPurchaseModal);
}
if(starterLoginButton){
starterLoginButton.addEventListener("click", function(){
if(authState.mode === "authenticated"){
openCreditPurchaseModal();
return;
}
openAuthPrompt("", "login");
});
}
async function refreshCreditBalance(button){
if(button) button.disabled = true;
setCreditModalStatus("Bakiyeniz kontrol ediliyor…", "");
try{
await loadCreditData();
setCreditModalStatus("Bakiyeniz güncellendi: " + (creditState.balance ?? "—") + " kredi.", "success");
}catch(error){
setCreditModalStatus(error?.message || "Bakiye yenilenemedi.", "error");
}finally{
if(button) button.disabled = false;
}
}
if(refreshCreditsButton){
refreshCreditsButton.addEventListener("click", function(){
refreshCreditBalance(refreshCreditsButton);
});
}
if(creditModalRefreshButton){
creditModalRefreshButton.addEventListener("click", function(){
refreshCreditBalance(creditModalRefreshButton);
});
}
creditModal?.querySelectorAll(".ai-credit-package-btn[href]").forEach(function(link){
link.addEventListener("click", function(){
setCreditModalStatus("Shopify güvenli ödeme ekranına yönlendiriliyorsunuz…", "");
});
});
[guideModal, authModal, creditModal, profileModal].forEach(function(modal){
modal?.addEventListener("click", function(event){
if(event.target === modal) closeModal(modal);
});
});
document.addEventListener("click", function(event){
const btn=event.target&&event.target.closest?event.target.closest("#aiBuyCredits"):null;
if(!btn)return;
event.preventDefault();
event.stopPropagation();
if(event.stopImmediatePropagation)event.stopImmediatePropagation();
openCreditPurchaseModal({reason:"manual"});
},true);
document.addEventListener("keydown", function(event){
if(event.key !== "Escape") return;
if(creditModal && !creditModal.hidden) closeModal(creditModal);
else if(authModal && !authModal.hidden) closeModal(authModal);
else if(guideModal && !guideModal.hidden) closeModal(guideModal);
});
renderInlineGuide();
loadFlowerLibraryForCustomer();
loadCreditData();
scenarioCards.forEach(function(card){
card.addEventListener("click", async function(){
const scenario = card.getAttribute("data-scenario");
if(authState.mode !== "authenticated"){
try{
await ensureStorefrontSession(false);
authState.mode = "authenticated";
if(!creditState.loaded){
await loadCreditData();
}
}catch(error){
clearStoredStorefrontSession();
authState.mode = "guest";
authState.customer = null;
creditState.balance = null;
creditState.showStarterNotice = false;
updateCreditUI();
openAuthPrompt(scenario);
return;
}
}
if(systemState.aiSystemPaused){
setFormMessage(systemState.aiSystemPauseMessage || "Floever AI Studio geçici olarak durduruldu.", "error");
updateCreditUI();
return;
}
if(shouldRequireProfileCompletion()){
openProfileCompletionModal();
updateCreditUI();
return;
}
const scenarioCost = getScenarioCreditCostFor(scenario, "same");
if(hasInsufficientCreditsForScenario(scenario, "same")){
openCreditPurchaseModal({
reason:"insufficient",
requiredCredits:scenarioCost,
availableCredits:creditState.balance
});
updateCreditUI();
return;
}
activateScenarioCard(card, true);
});
});
function downloadGeneratedImage(imageUrl){
if(!imageUrl) return;
const fileName = 'floever-ai-aranjman-' + Date.now() + '.png';
if(imageUrl.startsWith('data:image')){
const link = document.createElement('a');
link.href = imageUrl;
link.download = fileName;
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
return;
}
fetch(imageUrl)
.then(function(response){ return response.blob(); })
.then(function(blob){
const objectUrl = URL.createObjectURL(blob);
const link = document.createElement('a');
link.href = objectUrl;
link.download = fileName;
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
URL.revokeObjectURL(objectUrl);
})
.catch(function(){
window.open(imageUrl, '_blank');
});
}
function isMobileDevice(){
return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "") || window.innerWidth <= 768;
}
function attemptMobileAutoSave(imageUrl){
if(!imageUrl || !isMobileDevice()) return;
window.setTimeout(function(){
try{
downloadGeneratedImage(imageUrl);
}catch(error){
const mobileSaveNote = document.getElementById("aiMobileSaveNote");
if(mobileSaveNote){
mobileSaveNote.textContent = floeverAiI18n.text("Görsel hazır. Telefonunuza kaydetmek için Galeriye Kaydet / İndir butonuna dokunun.");
}
}
}, 800);
}
function setFollowupStatus(element, message, tone){
if(!element) return;
element.textContent = floeverAiI18n.text(message || "");
element.classList.remove("is-success", "is-error");
if(tone === "success") element.classList.add("is-success");
if(tone === "error") element.classList.add("is-error");
}
function initializeResultFollowup(jobId, followupToken){
if(!jobId) return;
async function followupFetch(path, options){
if(!followupToken){
return apiFetch(path, options);
}
const requestOptions = Object.assign({}, options || {});
const headers = new Headers(requestOptions.headers || {});
headers.set("X-Floever-Design-Followup", followupToken);
headers.set("Accept", "application/json");
requestOptions.headers = headers;
requestOptions.cache = requestOptions.cache || "no-store";
return fetch(
String(authState.apiBaseUrl || API_BASE_URL).replace(/\/+$/, "") +
(path.startsWith("/") ? path : "/" + path),
requestOptions
);
}
const reactionButtons = Array.from(resultBox.querySelectorAll(".ai-reaction-btn"));
const feedbackStatus = document.getElementById("aiFeedbackStatus");
const requestSubmit = document.getElementById("aiArrangementRequestSubmit");
const requestStatus = document.getElementById("aiArrangementRequestStatus");
let selectedRating = 0;
let feedbackSaved = false;
function paintReaction(){
reactionButtons.forEach(function(button){
const value = Number(button.getAttribute("data-rating"));
const active = value === selectedRating;
button.classList.toggle("is-active", active);
button.setAttribute("aria-pressed", active ? "true" : "false");
});
}
async function saveQuickFeedback(rating){
if(!rating || feedbackSaved) return;
selectedRating = rating;
paintReaction();
reactionButtons.forEach(function(button){ button.disabled = true; });
setFollowupStatus(feedbackStatus, "Değerlendirmeniz kaydediliyor…", "");
try{
const response = await followupFetch(
"/api/me/designs/" + encodeURIComponent(jobId) + "/feedback",
{
method:"POST",
headers:{"Content-Type":"application/json"},
body:JSON.stringify({
rating:selectedRating,
tags:selectedRating >= 4 ? ["Beğendim"] : ["Beğenmedim"],
comment:""
})
}
);
const data = await readJsonResponse(response) || {};
if(!response.ok){
throw new Error(data.error || "Değerlendirmeniz kaydedilemedi.");
}
feedbackSaved = true;
setFollowupStatus(
feedbackStatus,
selectedRating >= 4
? "Teşekkürler, beğendiğiniz kaydedildi."
: "Teşekkürler, geri bildiriminiz kaydedildi.",
"success"
);
}catch(error){
feedbackSaved = false;
reactionButtons.forEach(function(button){ button.disabled = false; });
setFollowupStatus(
feedbackStatus,
error?.message || "Değerlendirmeniz kaydedilemedi.",
"error"
);
}
}
reactionButtons.forEach(function(button){
button.addEventListener("click", function(){
saveQuickFeedback(Number(button.getAttribute("data-rating")) || 0);
});
});
if(requestSubmit){
requestSubmit.addEventListener("click", async function(){
requestSubmit.disabled = true;
requestSubmit.textContent = floeverAiI18n.text("Talebiniz Gönderiliyor…");
setFollowupStatus(requestStatus, "", "");
try{
const response = await followupFetch(
"/api/me/designs/" + encodeURIComponent(jobId) + "/arrangement-request",
{
method:"POST",
headers:{"Content-Type":"application/json"},
body:JSON.stringify({
note:"Bu AI tasarımını gerçek Floever aranjmanı olarak hazırlatmak istiyorum."
})
}
);
const data = await readJsonResponse(response) || {};
if(!response.ok){
throw new Error(data.error || "Aranjman talebiniz oluşturulamadı.");
}
setFollowupStatus(
requestStatus,
data.message || "Aranjman talebiniz alındı. Floever ekibi sizinle iletişime geçecek.",
"success"
);
requestSubmit.textContent = floeverAiI18n.text("Aranjman Talebi Alındı");
}catch(error){
requestSubmit.disabled = false;
requestSubmit.textContent = floeverAiI18n.text("Aranjman Talebi Gönder");
setFollowupStatus(
requestStatus,
error?.message || "Aranjman talebiniz gönderilemedi.",
"error"
);
}
});
}
}
function getPurchasableFlowers(materials){
const flowers = materials && Array.isArray(materials.userFlowers) ? materials.userFlowers : [];
return flowers.filter(function(item){
return item && item.variantId && Number(item.cartQuantity || item.count || 1) > 0;
}).map(function(item){
return {
id:String(item.variantId),
quantity:Math.max(1, Math.min(99, Number(item.cartQuantity || item.count || 1) || 1)),
name:item.name || "Çiçek"
};
});
}
function renderCartPurchaseHtml(materials){
const purchasable = getPurchasableFlowers(materials);
if(!purchasable.length) return "";
const countText = purchasable.length === 1 ? "1 ürün" : purchasable.length + " ürün";
return `
<div class="ai-cart-purchase-box" data-ai-cart-box>
<div class="ai-cart-purchase-title">Seçtiğiniz çiçekleri satın alın</div>
<p class="ai-cart-purchase-text">Bu tasarımda kullanılan Floever çiçeklerini adetleriyle birlikte sepete ekleyebilirsiniz. Aranjman görseli önizlemedir; gerçek sonuç ürün stok ve ölçülerine göre hazırlanır.</p>
<div class="ai-cart-purchase-actions">
<button type="button" class="ai-cart-add-btn" id="aiAddSelectedFlowersToCart">Seçili çiçekleri sepete ekle</button>
<a class="ai-cart-open-link" id="aiOpenCartLink" href="${SHOPIFY_CART_URL}" target="_top">Sepete git</a>
</div>
<div class="ai-cart-purchase-status" id="aiCartPurchaseStatus" aria-live="polite">${escapeHtml(countText)} sepete eklenmeye hazır.</div>
</div>
`;
}
async function addScenarioFlowersToCart(materials){
const status = document.getElementById("aiCartPurchaseStatus");
const button = document.getElementById("aiAddSelectedFlowersToCart");
const cartLink = document.getElementById("aiOpenCartLink");
const items = getPurchasableFlowers(materials);
if(!items.length){
if(status){ status.textContent = floeverAiI18n.text("Sepete eklenebilecek Shopify ürünü bulunamadı. Panelde çiçeklerin Variant ID alanını kontrol edin."); status.className = "ai-cart-purchase-status is-error"; }
return;
}
if(button){ button.disabled = true; button.textContent = floeverAiI18n.text("Sepete ekleniyor…"); }
if(status){ status.textContent = floeverAiI18n.text("Seçili çiçekler sepete ekleniyor…"); status.className = "ai-cart-purchase-status"; }
try{
const response = await fetch(SHOPIFY_CART_ADD_URL, {
method:"POST",
headers:{"Content-Type":"application/json","Accept":"application/json"},
credentials:"same-origin",
body:JSON.stringify({
items:items.map(function(item){ return {
id:item.id,
quantity:item.quantity,
properties:{
"Floever AI Studio":"Seçili aranjman çiçeği"
}
}; })
})
});
const data = await response.json().catch(function(){ return {}; });
if(!response.ok){
throw new Error(data.description || data.message || "Ürünler sepete eklenemedi.");
}
if(status){ status.textContent = floeverAiI18n.text("Seçili çiçekler sepete eklendi."); status.className = "ai-cart-purchase-status is-success"; }
if(cartLink){ cartLink.classList.add("is-visible"); }
if(button){ button.textContent = floeverAiI18n.text("Sepete eklendi"); }
}catch(error){
if(status){ status.textContent = floeverAiI18n.text(error?.message || "Sepete ekleme sırasında hata oluştu."); status.className = "ai-cart-purchase-status is-error"; }
if(button){ button.disabled = false; button.textContent = floeverAiI18n.text("Tekrar sepete ekle"); }
}
}
function renderScenarioMaterialsHtml(materials){
if(!materials || (!Array.isArray(materials.userFlowers) && !Array.isArray(materials.aiAdditions))) return "";
const userFlowers = Array.isArray(materials.userFlowers) ? materials.userFlowers : [];
const aiAdditions = Array.isArray(materials.aiAdditions) ? materials.aiAdditions : [];
const userList = userFlowers.length
? userFlowers.map(function(item){
const countText = item.count ? " — " + escapeHtml(item.count) + " adet" : "";
const priceText = item.priceLabel ? " · " + escapeHtml(item.priceLabel) : "";
return `<li>${escapeHtml(item.name || "Çiçek")}${countText}${priceText}</li>`;
}).join("")
: `<li>Çiçek listesi kaydedilemedi.</li>`;
const aiList = aiAdditions.length
? aiAdditions.map(function(item){ return `<li>${escapeHtml(item)}</li>`; }).join("")
: `<li>AI eklemesi yok veya belirtilmedi.</li>`;
const supportLabel = materials.aiSupportModeLabel || materials.aiSupportMode || "—";
return `
<div class="ai-materials-summary">
<div class="ai-materials-kicker">Kullanılan Materyaller</div>
<div class="ai-materials-columns">
<div><strong>Seçtiğiniz Floever çiçekleri</strong><ul>${userList}</ul></div>
<div><strong>AI destek eklemeleri</strong><ul>${aiList}</ul></div>
</div>
<p>AI destek modu: ${escapeHtml(supportLabel)}</p>
</div>
`;
}
const configEls = {
root: document.getElementById("aiConfigurator"),
footer: document.querySelector(".ai-config-footer"),
prev: document.getElementById("configPrevButton"),
next: document.getElementById("configNextButton"),
generate: document.getElementById("configGenerateButton"),
status: document.getElementById("configStatus"),
vaseGrid: document.getElementById("configVaseGrid"),
vaseStatus: document.getElementById("configVaseStatus"),
flowerGrid: document.getElementById("configFlowerGrid"),
flowerStatus: document.getElementById("configFlowerStatus"),
stepSummary2: document.getElementById("configStepSummary2"),
stepSummary3: document.getElementById("configStepSummary3"),
flowerFilterToggle: document.getElementById("configFlowerFilterToggle"),
flowerFilterPanel: document.getElementById("configFlowerFilterPanel"),
flowerSearch: document.getElementById("configFlowerSearch"),
flowerTypeFilter: document.getElementById("configFlowerTypeFilter"),
flowerColorFilter: document.getElementById("configFlowerColorFilter"),
flowerPriceFilter: document.getElementById("configFlowerPriceFilter"),
flowerFilterReset: document.getElementById("configFlowerFilterReset"),
ownVaseInput: document.getElementById("configOwnVaseInput"),
ownVaseFilename: document.getElementById("configOwnVaseFilename"),
floeverVasePanel: document.getElementById("configFloeverVasePanel"),
ownVasePanel: document.getElementById("configOwnVasePanel"),
summary: document.getElementById("configSummary"),
mobileStickyVase: document.getElementById("configMobileStickyVase"),
style: document.getElementById("configStyle"),
aiSupport: document.getElementById("configAiSupport"),
note: document.getElementById("configNote"),
welcome: document.getElementById("aiWelcomePanel"),
welcomeStart: document.getElementById("aiWelcomeStart")
};
const configState = {
step: 1,
vaseMode: "floever",
vaseSourceChosen: false,
ownVaseFile: null,
activeShareCode: "",
shareUnavailableItems: [],
sharedPreviewOnly: false,
vaseChangeGenerating: false,
vaseChangeBackup: null,
vases: [],
flowers: [],
selectedVaseId: "",
selectedFlowers: new Map(),
flowerFilters: {
search: "",
type: "",
color: "",
price: ""
},
filtersOpen: false,
ownVasePreviewUrl: "",
specialWaterApplication: false,
lastJobId: "",
lastImage: "",
retryUsed: false,
compositionChangesUsed: 0,
retryGenerating: false,
backgroundJobId: "",
backgroundJobStatus: "",
backgroundIsRetry: false,
lastResultData: null,
originalResultData: null,
originalJobId: "",
beautifyGenerating: false,
beautifyMode: "",
beautifyRecommendationIds: [],
selectedCompositionTemplateId: "",
compositionRecommendations: [],
compositionRecommendationsLoading: false,
compositionRecommendationsError: "",
compositionRecommendationKey: "",
resultCurrentCompositionTemplateId: "",
previousDesigns: [],
previousDesignsLoading: false,
previousDesignsError: "",
restoringState: false
};

let welcomeDismissedForCurrentPage = false;
let sharedOwnVaseHydrationPromise = null;
function hasShareCodeInCurrentUrl(){
try{ return Boolean(new URL(window.location.href).searchParams.get("floever_share")); }catch(error){ return false; }
}
function hasMeaningfulConfiguratorState(){
return Boolean(
configState.step > 1 ||
configState.vaseSourceChosen ||
configState.selectedVaseId ||
configState.selectedFlowers.size ||
(configEls.note && String(configEls.note.value || "").trim()) ||
configState.lastJobId ||
configState.lastImage ||
configState.lastResultData ||
configState.backgroundJobId ||
configState.activeShareCode
);
}
function hasWelcomeStartedInSession(){
return welcomeDismissedForCurrentPage;
}
function rememberWelcomeStarted(){
welcomeDismissedForCurrentPage = true;
}
function setWelcomeScreenVisible(visible, options){
const opts = options || {};
const show = Boolean(visible && configEls.welcome);
if(opts.remember) rememberWelcomeStarted();
if(configEls.root) configEls.root.classList.toggle("is-welcome", show);
const page = document.querySelector(".ai-designer-page");
if(page) page.classList.toggle("is-welcome-screen", show);
if(configEls.welcome){
configEls.welcome.hidden = !show;
configEls.welcome.setAttribute("aria-hidden", show ? "false" : "true");
}
Array.prototype.forEach.call(document.querySelectorAll("[data-config-step-jump]"), function(button){
button.setAttribute("aria-disabled", show ? "true" : "false");
});
}
function shouldShowWelcomeScreen(){
return Boolean(configEls.welcome) && !hasShareCodeInCurrentUrl() && !hasWelcomeStartedInSession();
}
function launchWelcomeEmojiRain(){
try{
const existing = document.getElementById("aiEmojiRain");
if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
const layer = document.createElement("div");
layer.id = "aiEmojiRain";
layer.className = "ai-emoji-rain";
const emojis = ["✨","🌸","💐","🌷","🪻","🌿","🤍","⭐"];
const count = window.matchMedia && window.matchMedia("(max-width: 760px)").matches ? 28 : 42;
for(let i=0;i<count;i+=1){
const item = document.createElement("span");
item.className = "ai-emoji-rain__item";
item.textContent = floeverAiI18n.text(emojis[Math.floor(Math.random()*emojis.length)]);
item.style.left = (Math.random()*100).toFixed(2) + "vw";
item.style.fontSize = (18 + Math.random()*18).toFixed(0) + "px";
item.style.animationDuration = (1800 + Math.random()*1300).toFixed(0) + "ms";
item.style.animationDelay = (Math.random()*450).toFixed(0) + "ms";
item.style.setProperty("--drift", (Math.random()*140 - 70).toFixed(0) + "px");
item.style.setProperty("--rotate", (Math.random()*260 - 130).toFixed(0) + "deg");
layer.appendChild(item);
}
document.body.appendChild(layer);
window.setTimeout(function(){
if(layer && layer.parentNode) layer.parentNode.removeChild(layer);
}, 3600);
}catch(error){}
}
async function openConfiguratorFromWelcome(){
try{
if(authState.mode === "loading") await ensureStorefrontSession(false);
}catch(error){}
if(authState.mode !== "authenticated"){
openAuthPrompt("own_stems", "login");
return;
}
launchWelcomeEmojiRain();
setWelcomeScreenVisible(false,{remember:true});
showSetupView();
setConfigStep(Math.max(1,Number(configState.step || 1)));
window.requestAnimationFrame(function(){
const activeStep = document.querySelector('[data-config-step="' + configState.step + '"]');
if(activeStep && activeStep.scrollIntoView) activeStep.scrollIntoView({behavior:"smooth",block:"start"});
});
}
function applyConfiguratorOpeningView(){
/* Sayfa her yeni açıldığında önce karşılama ekranı gösterilir.
   Eski localStorage/server kaydı karşılama ekranını artık atlamaz. */
if(shouldShowWelcomeScreen()){
setWelcomeScreenVisible(true);
return;
}
if(hasCompletedResultSnapshot()){
setWelcomeScreenVisible(false);
renderRestoredCompletedResult();
return;
}
if(configState.backgroundJobId && configState.backgroundJobStatus === "processing"){
setWelcomeScreenVisible(false);
renderBackgroundProcessingPlaceholder();
return;
}
setWelcomeScreenVisible(false);
setConfigStep(configState.step || 1,{instant:true});
}

const CONFIGURATOR_STATE_KEY = "floever_ai_configurator_state_v7";
let configuratorStateSaveTimer = null;
let configuratorResetEpoch = 0;
function buildConfiguratorStateSnapshot(){
return {
version: 7,
step: configState.step,
vaseMode: configState.vaseMode,
vaseSourceChosen: Boolean(configState.vaseSourceChosen),
activeShareCode: configState.activeShareCode || "",
shareUnavailableItems: Array.isArray(configState.shareUnavailableItems) ? configState.shareUnavailableItems.slice(0,20) : [],
sharedPreviewOnly: Boolean(configState.sharedPreviewOnly),
selectedVaseId: configState.selectedVaseId,
selectedFlowers: selectedConfigFlowers(),
style: getSelectedArrangementStyle(),
note: configEls.note ? configEls.note.value : "",
specialWaterApplication: Boolean(configState.specialWaterApplication),
lastJobId: configState.lastJobId || "",
lastImage: configState.lastImage || "",
retryUsed: Boolean(configState.retryUsed),
compositionChangesUsed: Math.max(0, Math.min(2, Number(configState.compositionChangesUsed || 0))),
lastResultData: configState.lastResultData || null,
originalResultData: configState.originalResultData || null,
originalJobId: configState.originalJobId || "",
beautifyMode: configState.beautifyMode || "",
beautifyRecommendationIds: Array.isArray(configState.beautifyRecommendationIds) ? configState.beautifyRecommendationIds.slice(0,10) : [],
selectedCompositionTemplateId: configState.selectedCompositionTemplateId || "",
resultCurrentCompositionTemplateId: configState.resultCurrentCompositionTemplateId || "",
backgroundJobId: configState.backgroundJobId || "",
backgroundJobStatus: configState.backgroundJobStatus || "",
backgroundIsRetry: Boolean(configState.backgroundIsRetry),
updatedAt: new Date().toISOString()
};
}
function applyConfiguratorStateSnapshot(snapshot){
if(!snapshot || typeof snapshot !== "object") return false;
configState.restoringState = true;
try{
configState.step = Math.max(1, Math.min(4, Number(snapshot.step || 1)));
configState.vaseMode = snapshot.vaseMode === "own" ? "own" : "floever";
configState.vaseSourceChosen = snapshot.vaseSourceChosen !== undefined
? Boolean(snapshot.vaseSourceChosen)
: Boolean(snapshot.selectedVaseId || snapshot.vaseMode === "own");
configState.activeShareCode = String(snapshot.activeShareCode || "");
configState.shareUnavailableItems = Array.isArray(snapshot.shareUnavailableItems) ? snapshot.shareUnavailableItems.slice(0,20) : [];
configState.sharedPreviewOnly = Boolean(snapshot.sharedPreviewOnly);
configState.ownVaseFile = null;
configState.selectedVaseId = String(snapshot.selectedVaseId || "");
configState.selectedFlowers = new Map();
(Array.isArray(snapshot.selectedFlowers) ? snapshot.selectedFlowers : []).forEach(function(item){
const id = String(item && item.id || "");
const count = Math.max(1, Math.min(99, Number(item && item.count || 1)));
if(id) configState.selectedFlowers.set(id, count);
});
if(configEls.style) configEls.style.value = snapshot.style || "AI Seçimi";
if(configEls.note) configEls.note.value = snapshot.note || "";
configState.specialWaterApplication = Boolean(snapshot.specialWaterApplication);
configState.lastJobId = String(snapshot.lastJobId || "");
configState.lastImage = String(snapshot.lastImage || (snapshot.lastResultData && snapshot.lastResultData.image) || "");
configState.retryUsed = Boolean(snapshot.retryUsed);
configState.compositionChangesUsed = Math.max(0, Math.min(2, Number(snapshot.compositionChangesUsed || snapshot.lastResultData?.beautify?.iteration || 0)));
configState.lastResultData = snapshot.lastResultData && snapshot.lastResultData.image ? snapshot.lastResultData : null;
configState.originalResultData = snapshot.originalResultData && snapshot.originalResultData.image ? snapshot.originalResultData : null;
configState.originalJobId = String(snapshot.originalJobId || "");
configState.beautifyMode = String(snapshot.beautifyMode || "");
configState.beautifyRecommendationIds = Array.isArray(snapshot.beautifyRecommendationIds) ? snapshot.beautifyRecommendationIds.map(String).filter(Boolean).slice(0,10) : [];
configState.selectedCompositionTemplateId = String(snapshot.selectedCompositionTemplateId || "");
configState.resultCurrentCompositionTemplateId = String(snapshot.resultCurrentCompositionTemplateId || (snapshot.lastResultData && snapshot.lastResultData.compositionPlan && snapshot.lastResultData.compositionPlan.templateId) || "");
configState.compositionRecommendations = [];
configState.compositionRecommendationsLoading = false;
configState.compositionRecommendationsError = "";
configState.compositionRecommendationKey = "";
configState.backgroundJobId = String(snapshot.backgroundJobId || "");
configState.backgroundJobStatus = String(snapshot.backgroundJobStatus || "");
configState.backgroundIsRetry = Boolean(snapshot.backgroundIsRetry);
return true;
}finally{
configState.restoringState = false;
}
}
function saveConfiguratorStateLocal(){
try{
if(window.localStorage) window.localStorage.setItem(CONFIGURATOR_STATE_KEY, JSON.stringify(buildConfiguratorStateSnapshot()));
}catch(error){}
}
function scheduleConfiguratorStateSave(){
if(configState.restoringState) return;
const saveEpoch = configuratorResetEpoch;
saveConfiguratorStateLocal();
if(configuratorStateSaveTimer) window.clearTimeout(configuratorStateSaveTimer);
configuratorStateSaveTimer = window.setTimeout(function(){
if(saveEpoch !== configuratorResetEpoch) return;
if(!authState.token) return;
apiFetch("/api/configurator-state", {
method:"POST",
headers:{"Content-Type":"application/json"},
body:JSON.stringify({state:buildConfiguratorStateSnapshot()})
}).catch(function(){});
}, 650);
}
function restoreConfiguratorStateLocal(){
try{
const raw = window.localStorage && window.localStorage.getItem(CONFIGURATOR_STATE_KEY);
if(!raw) return false;
const restored = applyConfiguratorStateSnapshot(JSON.parse(raw));
if(restored && configState.backgroundJobStatus === "completed"){
clearConfiguratorCompletedResultState({clearResultBox:false, save:false});
}
return restored;
}catch(error){ return false; }
}
async function restoreConfiguratorStateFromServer(){
const restoreEpoch = configuratorResetEpoch;
try{
if(!authState.token) await ensureStorefrontSession(false);
const response = await apiFetch("/api/configurator-state", {method:"GET"});
const data = await readJsonResponse(response) || {};
if(restoreEpoch !== configuratorResetEpoch) return false;
if(!response.ok || !data.state) return false;
let localState = null;
try{
const raw = window.localStorage && window.localStorage.getItem(CONFIGURATOR_STATE_KEY);
if(raw) localState = JSON.parse(raw);
}catch(error){}
const serverTime = Date.parse(data.state.updatedAt || "") || 0;
const localTime = Date.parse(localState?.updatedAt || "") || 0;
if(serverTime >= localTime){
applyConfiguratorStateSnapshot(data.state);
if(configState.backgroundJobStatus === "completed"){
clearConfiguratorCompletedResultState({clearResultBox:false, save:false});
}
saveConfiguratorStateLocal();
return true;
}
return false;
}catch(error){ return false; }
}
function clearConfiguratorBackgroundJob(){
configState.backgroundJobId = "";
configState.backgroundJobStatus = "";
configState.backgroundIsRetry = false;
scheduleConfiguratorStateSave();
}

function clearConfiguratorBrowserSelectionState(){
["localStorage", "sessionStorage"].forEach(function(storageName){
try{
const storage = window[storageName];
if(!storage) return;
storage.removeItem(CONFIGURATOR_STATE_KEY);
storage.removeItem(PENDING_SCENARIO_KEY);
}catch(error){}
});
}

async function clearConfiguratorStateFromServer(){
try{
if(!authState.token) await ensureStorefrontSession(false);
const response = await apiFetch("/api/configurator-state", {method:"DELETE"});
if(!response.ok){
const data = await readJsonResponse(response) || {};
throw new Error(data.error || "Sunucudaki seçim kaydı temizlenemedi.");
}
return true;
}catch(error){
try{ console.warn("[Floever] Konfigüratör sunucu kaydı temizlenemedi:", error?.message || error); }catch(logError){}
return false;
}
}

function resetConfiguratorCompletely(options){
const opts = options || {};
configuratorResetEpoch += 1;
if(configuratorStateSaveTimer){
window.clearTimeout(configuratorStateSaveTimer);
configuratorStateSaveTimer = null;
}

configState.restoringState = true;
try{
if(configState.ownVasePreviewUrl && window.URL && URL.revokeObjectURL){
try{ URL.revokeObjectURL(configState.ownVasePreviewUrl); }catch(error){}
}

configState.step = 1;
configState.vaseMode = "floever";
configState.vaseSourceChosen = false;
configState.ownVaseFile = null;
configState.activeShareCode = "";
configState.shareUnavailableItems = [];
configState.sharedPreviewOnly = false;
configState.vaseChangeGenerating = false;
configState.vaseChangeBackup = null;
configState.selectedVaseId = "";
configState.selectedFlowers = new Map();
configState.flowerFilters = {search:"", type:"", color:"", price:""};
configState.filtersOpen = false;
configState.ownVasePreviewUrl = "";
configState.specialWaterApplication = false;
configState.lastJobId = "";
configState.lastImage = "";
configState.activeShareCode = "";
configState.shareUnavailableItems = [];
configState.sharedPreviewOnly = false;
configState.retryUsed = false;
configState.compositionChangesUsed = 0;
configState.retryGenerating = false;
configState.backgroundJobId = "";
configState.backgroundJobStatus = "";
configState.backgroundIsRetry = false;
configState.lastResultData = null;
configState.originalResultData = null;
configState.originalJobId = "";
configState.beautifyGenerating = false;
configState.beautifyMode = "";
configState.beautifyRecommendationIds = [];
configState.selectedCompositionTemplateId = "";
configState.compositionRecommendations = [];
configState.compositionRecommendationsLoading = false;
configState.compositionRecommendationsError = "";
configState.compositionRecommendationKey = "";
configState.resultCurrentCompositionTemplateId = "";

if(form && typeof form.reset === "function") form.reset();
if(selectedScenario) selectedScenario.value = "own_stems";
const legacyVaseInput = document.getElementById("vaseImage");
const legacyVaseFilename = document.getElementById("vaseFilename");
if(legacyVaseInput) legacyVaseInput.value = "";
if(legacyVaseFilename) legacyVaseFilename.textContent = floeverAiI18n.text("");
resetArrangementInput();
resetOwnFlowersSection();
clearCheckedInputs(flowerColorSection);
resetSelects(styleAreaSection);

if(configEls.style) configEls.style.value = "AI Seçimi";
if(configEls.note) configEls.note.value = "";
if(configEls.ownVaseInput) configEls.ownVaseInput.value = "";
if(configEls.ownVaseFilename) configEls.ownVaseFilename.textContent = floeverAiI18n.text("");
if(configEls.flowerSearch) configEls.flowerSearch.value = "";
if(configEls.flowerTypeFilter) configEls.flowerTypeFilter.value = "";
if(configEls.flowerColorFilter) configEls.flowerColorFilter.value = "";
if(configEls.flowerPriceFilter) configEls.flowerPriceFilter.value = "";
if(configEls.flowerFilterPanel) configEls.flowerFilterPanel.hidden = true;
if(configEls.flowerFilterToggle){
configEls.flowerFilterToggle.classList.remove("is-active");
configEls.flowerFilterToggle.textContent = floeverAiI18n.text("Filtrele");
}

Array.prototype.forEach.call(document.querySelectorAll("[data-vase-mode]"), function(button){
const isFloever = button.getAttribute("data-vase-mode") === "floever";
button.classList.toggle("is-active", isFloever);
});
if(configEls.floeverVasePanel) configEls.floeverVasePanel.hidden = true;
if(configEls.ownVasePanel) configEls.ownVasePanel.hidden = true;
syncVaseSourceDecisionUi();

if(resultBox) resultBox.innerHTML = floeverAiI18n.html("");
setFormMessage("", "");
setConfigStatus("", "");
syncStyleCards();
renderConfigVases();
populateFlowerFilters();
renderConfigFlowers();
renderConfigSummary();
setConfigStep(1, {instant:true});
if(opts.showSetup !== false) showSetupView();
}finally{
configState.restoringState = false;
}

clearConfiguratorBrowserSelectionState();
clearPendingScenario();
void clearConfiguratorStateFromServer();
}

function clearConfiguratorCompletedResultState(options){
const opts = options || {};
configState.lastJobId = "";
configState.lastImage = "";
configState.activeShareCode = "";
configState.shareUnavailableItems = [];
configState.sharedPreviewOnly = false;
configState.vaseChangeGenerating = false;
configState.vaseChangeBackup = null;
configState.retryUsed = false;
configState.compositionChangesUsed = 0;
configState.retryGenerating = false;
configState.backgroundJobId = "";
configState.backgroundJobStatus = "";
configState.backgroundIsRetry = false;
configState.lastResultData = null;
configState.originalResultData = null;
configState.originalJobId = "";
configState.beautifyGenerating = false;
configState.beautifyMode = "";
configState.beautifyRecommendationIds = [];
configState.selectedCompositionTemplateId = "";
configState.resultCurrentCompositionTemplateId = "";
configState.compositionRecommendations = [];
configState.compositionRecommendationKey = "";
if(resultBox && opts.clearResultBox !== false) resultBox.innerHTML = floeverAiI18n.html("");
try{
if(window.localStorage){
const raw = window.localStorage.getItem(CONFIGURATOR_STATE_KEY);
if(raw){
const state = JSON.parse(raw);
state.lastJobId = "";
state.lastImage = "";
state.activeShareCode = "";
state.shareUnavailableItems = [];
state.sharedPreviewOnly = false;
state.retryUsed = false;
state.compositionChangesUsed = 0;
state.lastResultData = null;
state.originalResultData = null;
state.originalJobId = "";
state.beautifyMode = "";
state.beautifyRecommendationIds = [];
state.backgroundJobId = "";
state.backgroundJobStatus = "";
state.backgroundIsRetry = false;
state.updatedAt = new Date().toISOString();
window.localStorage.setItem(CONFIGURATOR_STATE_KEY, JSON.stringify(state));
}
}
}catch(error){}
if(opts.save !== false) scheduleConfiguratorStateSave();
}
function hasCompletedResultSnapshot(){
/*
 * Normal sayfa açılışında eski tamamlanmış tasarımı otomatik geri getirme.
 * Böylece müşteri 0'dan yeni tasarım sürecine girdiğinde sürekli önceki sonuçtan devam etmez.
 * Processing job hâlâ ayrı olarak takip edilir.
 */
return false;
}
function renderRestoredCompletedResult(){
if(!hasCompletedResultSnapshot()) return false;
configState.step = 4;
showResultView();
renderConfiguredResult(configState.lastResultData, configState.lastJobId || "");
return true;
}
function floeverWaitGameMarkup(){
return `<div class="ai-wait-game" data-ai-wait-game>
  <div class="ai-wait-game-head">
    <div><span>Mini oyun</span><strong>20 çiçek yakala, %5 indirim kazan</strong></div>
    <div class="ai-wait-game-stats"><div class="ai-wait-game-score">Yakalanan <b data-ai-wait-score>0</b>/20</div><div class="ai-wait-game-level">Seviye <b data-ai-wait-level>1</b></div></div>
  </div>
  <div class="ai-wait-game-progress"><span data-ai-wait-progress></span></div>
  <div class="ai-wait-game-field" data-ai-wait-field role="application" aria-label="Hareket eden çiçeğe dokunarak puan toplayın">
    <button type="button" class="ai-wait-game-flower" data-ai-wait-flower aria-label="Çiçeği yakala">🌸</button>
  </div>
  <div class="ai-wait-game-reward" data-ai-wait-reward aria-live="polite"></div>
</div>`;
}
function startFloeverWaitGame(root){
try{
if(window.__floeverWaitGameCleanup){ window.__floeverWaitGameCleanup(); window.__floeverWaitGameCleanup = null; }
if(!root) return function(){};
const field = root.querySelector("[data-ai-wait-field]");
const flower = root.querySelector("[data-ai-wait-flower]");
const scoreNode = root.querySelector("[data-ai-wait-score]");
const levelNode = root.querySelector("[data-ai-wait-level]");
const progressNode = root.querySelector("[data-ai-wait-progress]");
const rewardNode = root.querySelector("[data-ai-wait-reward]");
if(!field || !flower) return function(){};
let score = 0;
let level = 1;
let stopped = false;
let moveTimer = null;
let rewardClaimed = false;
const flowers = ["🌸","🌷","🪻","🌼","✨","🌿"];
function currentDelay(){ return Math.max(180, 760 - ((level - 1) * 105)); }
function currentSize(){ return Math.max(24, 44 - ((level - 1) * 3.2)); }
function moveFlower(){
if(stopped || !root.isConnected){ cleanup(); return; }
const fieldRect = field.getBoundingClientRect();
const size = currentSize();
flower.style.width = size + "px";
flower.style.height = size + "px";
flower.style.fontSize = Math.max(18,size * .52) + "px";
const maxX = Math.max(8, fieldRect.width - size - 14);
const maxY = Math.max(8, fieldRect.height - size - 14);
flower.style.transform = "translate3d(" + Math.floor(7 + Math.random()*maxX) + "px," + Math.floor(7 + Math.random()*maxY) + "px,0) rotate(" + Math.floor(Math.random()*70-35) + "deg)";
flower.textContent = floeverAiI18n.text(flowers[Math.floor(Math.random()*flowers.length)]);
window.clearTimeout(moveTimer);
moveTimer = window.setTimeout(moveFlower,currentDelay());
}
function catchFlower(event){
event.preventDefault();
event.stopPropagation();
score += 1;
const nextLevel = Math.min(8,1 + Math.floor(score / 3));
if(nextLevel !== level){ level = nextLevel; if(levelNode) levelNode.textContent = floeverAiI18n.text(String(level)); }
if(scoreNode) scoreNode.textContent = floeverAiI18n.text(String(Math.min(score,20)));
if(progressNode) progressNode.style.width = Math.min(100,(score/20)*100) + "%";
if(score >= 20 && !rewardClaimed){
rewardClaimed = true;
flower.disabled = true;
if(rewardNode) rewardNode.textContent = floeverAiI18n.text("Tebrikler! %5 indirim hazırlanıyor…");
apiFetch("/api/game-reward",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({score:score})}).then(function(response){
if(!response.ok) return response.json().then(function(data){ throw new Error(data.error || "İndirim oluşturulamadı."); });
return response.json();
}).then(function(data){
const reward={token:String(data.token||""),percent:Number(data.percent||5),expiresAt:Number(data.expiresAt||0)};
try{ localStorage.setItem("floever_ai_game_reward_v1",JSON.stringify(reward)); }catch(error){}
window.FLOEVER_GAME_REWARD=reward;
if(rewardNode) rewardNode.innerHTML = floeverAiI18n.html('<strong>%5 indirim kazandınız!</strong><span>Sipariş ekranında otomatik uygulanacak.</span>');
}).catch(function(error){ if(rewardNode) rewardNode.textContent=floeverAiI18n.text(error.message || "İndirim oluşturulamadı."); });
}
flower.classList.remove("is-caught");
void flower.offsetWidth;
flower.classList.add("is-caught");
moveFlower();
}
flower.addEventListener("click", catchFlower);
window.requestAnimationFrame(moveFlower);
function cleanup(){
if(stopped) return;
stopped = true;
window.clearTimeout(moveTimer);
flower.removeEventListener("click", catchFlower);
if(window.__floeverWaitGameCleanup === cleanup) window.__floeverWaitGameCleanup = null;
}
window.__floeverWaitGameCleanup = cleanup;
return cleanup;
}catch(error){ return function(){}; }
}
function renderBackgroundProcessingPlaceholder(){
if(!configState.backgroundJobId || configState.backgroundJobStatus !== "processing") return false;
showResultView();
resultBox.innerHTML = floeverAiI18n.html(`<div class="ai-loading-card ai-loading-card-with-facts">
  <div class="ai-loading-title">${configState.beautifyMode ? "Aranjmanınız güzelleştiriliyor…" : configState.backgroundIsRetry ? "Yeni görünüm hazırlanıyor…" : "Aranjmanınız hazırlanıyor…"}</div>
  <div class="ai-loading-progress"><span></span></div>
  <div class="ai-loading-fact-rotator" aria-live="polite" aria-label="Kısa bekleme notu">
    <div class="ai-loading-fact-heading">Tasarımınız hazırlanıyor</div>
    <span>Birazdan sonucu burada göreceksiniz.</span>
  </div>
  ${floeverWaitGameMarkup()}
</div>`);
startFloeverWaitGame(resultBox.querySelector("[data-ai-wait-game]"));
return true;
}
function waitMs(ms){ return new Promise(function(resolve){ window.setTimeout(resolve, ms); }); }
function buildPersistedResultData(data){
if(!data || !data.image) return null;
return {
  success: Boolean(data.success !== false),
  scenario: data.scenario || "own_stems",
  image: data.image || "",
  originalImage: data.originalImage || "",
  arrangementEstimate: data.arrangementEstimate || null,
  compositionPlan: data.compositionPlan || null,
  revision: data.revision || null,
  vaseChange: data.vaseChange || null,
  beautify: data.beautify || null,
  retry: data.retry || null,
  scenarioMaterials: data.scenarioMaterials || null,
  pricingSnapshot: data.pricingSnapshot || (data.requestMetadata && data.requestMetadata.pricingSnapshot) || null,
  requestMetadata: data.requestMetadata ? {
    normalizedStyle:data.requestMetadata.normalizedStyle || "",
    styleInput:data.requestMetadata.styleInput || "",
    compositionLibrary:data.requestMetadata.compositionLibrary || null,
    compositionPlan:data.requestMetadata.compositionPlan || data.compositionPlan || null,
    selectedVase:data.requestMetadata.selectedVase || null,
    selectedStockFlowers:Array.isArray(data.requestMetadata.selectedStockFlowers) ? data.requestMetadata.selectedStockFlowers : [],
    vaseSource:data.requestMetadata.vaseSource || "",
    note:data.requestMetadata.note || "",
    arrangementEstimate:data.requestMetadata.arrangementEstimate || data.arrangementEstimate || null,
    pricingSnapshot:data.requestMetadata.pricingSnapshot || data.pricingSnapshot || null,
    isBeautifyDesign:Boolean(data.requestMetadata.isBeautifyDesign),
    isVaseChangeDesign:Boolean(data.requestMetadata.isVaseChangeDesign),
    revisionType:data.requestMetadata.revisionType || data.revision?.type || "",
    revisionIteration:Math.max(0, Number(data.requestMetadata.revisionIteration || data.revision?.iteration || data.requestMetadata.compositionIteration || data.beautify?.iteration || 0)),
    compositionIteration:Math.max(0, Number(data.requestMetadata.compositionIteration || data.revision?.iteration || data.beautify?.iteration || 0)),
    vaseChangeSourceJobId:data.requestMetadata.vaseChangeSourceJobId || "",
    derivedFromDesignJobId:data.requestMetadata.derivedFromDesignJobId || ""
  } : null,
  creditSystem: data.creditSystem ? {
    enabled: Boolean(data.creditSystem.enabled),
    jobId: data.creditSystem.jobId || "",
    retryUsed: Boolean(data.creditSystem.retryUsed),
    creditBalance: Number.isFinite(Number(data.creditSystem.creditBalance)) ? Number(data.creditSystem.creditBalance) : null
  } : null
};
}
function parseConfigMoney(value){
if(typeof value === "number" && Number.isFinite(value)) return value;
const raw = String(value || "").replace(/TL|TRY|₺/gi, "").replace(/\s+/g, "").replace(/[^0-9,.-]/g, "");
if(!raw) return 0;
const lastComma = raw.lastIndexOf(",");
const lastDot = raw.lastIndexOf(".");
let normalized = raw;
if(lastComma > lastDot) normalized = raw.replace(/\./g, "").replace(",", ".");
else normalized = raw.replace(/,/g, "");
const parsed = Number.parseFloat(normalized);
return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}
function formatTry(value){
const n = Number(value || 0);
try{ return new Intl.NumberFormat("tr-TR", {style:"currency", currency:"TRY", maximumFractionDigits:0}).format(n); }
catch(e){ return Math.round(n) + " TL"; }
}
function selectedConfigFlowers(){
return Array.from(configState.selectedFlowers.entries()).map(function(entry){ return {id:entry[0], count:entry[1]}; });
}
function selectedConfigVase(){
return configState.vases.find(function(v){ return String(v.id) === String(configState.selectedVaseId); }) || null;
}

function getSelectedArrangementStyle(){
return configEls.style?.value || "AI Seçimi";
}
function styleCardFallbackVisualKey(value){
const key = compositionStyleVisualKey(value);
if(key === "modern") return "loose";
if(key === "vertical") return "vertical";
if(key === "horizontal") return "horizontal";
if(key === "top_form") return "top_form";
if(key === "natural") return "natural_oval";
if(key === "exotic") return "fan";
return "balanced";
}

function replaceBrokenStyleCardImage(img, card){
if(!img || img.dataset.floeverFallbackApplied === "true") return;
img.dataset.floeverFallbackApplied = "true";
const value = card && card.getAttribute("data-config-style-choice") || "AI Seçimi";
const holder = document.createElement("div");
holder.className = "ai-style-card-svg-fallback";
holder.style.cssText = "width:100%;min-height:145px;display:flex;align-items:center;justify-content:center;overflow:hidden;";
holder.innerHTML = floeverAiI18n.html(renderCompositionVisualSvg(styleCardFallbackVisualKey(value)));
img.replaceWith(holder);
}

function installStyleCardImageFallbacks(){
Array.prototype.forEach.call(document.querySelectorAll("[data-config-style-choice]"), function(card){
  const img = card.querySelector("img");
  if(!img || img.dataset.floeverFallbackBound === "true") return;
  img.dataset.floeverFallbackBound = "true";
  img.addEventListener("error", function(){ replaceBrokenStyleCardImage(img, card); }, {once:true});
  if(img.complete && Number(img.naturalWidth || 0) === 0){
    replaceBrokenStyleCardImage(img, card);
  }
});
}

function syncStyleCards(){
const selectedStyle = getSelectedArrangementStyle();
Array.prototype.forEach.call(document.querySelectorAll("[data-config-style-choice]"), function(card){
const isSelected = card.getAttribute("data-config-style-choice") === selectedStyle;
card.classList.toggle("is-selected", isSelected);
card.setAttribute("aria-pressed", isSelected ? "true" : "false");
});
installStyleCardImageFallbacks();
}
function getConfigVasePreviewImage(){
const vase = selectedConfigVase();
if(configState.vaseMode === "floever" && vase && vase.imageUrl) return vase.imageUrl;
if(configState.vaseMode === "own" && configState.ownVasePreviewUrl) return configState.ownVasePreviewUrl;
return "";
}
function getConfigFlowerById(id){
return configState.flowers.find(function(f){ return String(f.id) === String(id); }) || null;
}

function renderMobileStickyVase(){
// v79: Üstte çıkan mobil "Seçilen vazo" kutusu kaldırıldı.
// Alt taraftaki normal özet kartları (Seçilen vazo ve toplam) kalır.
if(configEls.mobileStickyVase){
configEls.mobileStickyVase.hidden = true;
configEls.mobileStickyVase.innerHTML = floeverAiI18n.html("");
}
}

const SPECIAL_WATER_APPLICATION_PRICE = 150;
function getSpecialWaterApplicationPrice(){
return SPECIAL_WATER_APPLICATION_PRICE;
}
function calculateConfigTotal(){
let total = 0;
const vase = selectedConfigVase();
if(configState.vaseMode === "floever" && vase) total += parseConfigMoney(vase.priceAmount || vase.priceLabel);
selectedConfigFlowers().forEach(function(item){
const flower = getConfigFlowerById(item.id);
if(flower) total += parseConfigMoney(flower.priceAmount || flower.priceLabel) * Number(item.count || 1);
});
if(configState.specialWaterApplication) total += getSpecialWaterApplicationPrice();
return total;
}
function calculateConfigFlowerSubtotal(){
return selectedConfigFlowers().reduce(function(total, item){
const flower = getConfigFlowerById(item.id);
if(!flower) return total;
return total + (parseConfigMoney(flower.priceAmount || flower.priceLabel) * Number(item.count || 1));
}, 0);
}
function setConfigStatus(message, tone){
if(!configEls.status) return;
configEls.status.textContent = floeverAiI18n.text(message || "");
configEls.status.className = "ai-config-status" + (tone ? " is-" + tone : "");
}
function isMobileConfigurator(){
return Boolean(window.matchMedia && window.matchMedia("(max-width: 760px)").matches);
}
function scrollConfiguratorToCurrentStep(options){
options = options || {};
const mobile = isMobileConfigurator();

/* Mobilde bütün adımlarda mevcut davranışı koru.
   Masaüstünde özellikle Çiçekler → Tarz geçişinde kullanıcı çiçek listesinin
   aşağısında kaldığı için konfigüratörün başına geri taşı. */
if(!mobile && configState.step !== 3) return;

const configurator = document.getElementById("aiConfigurator");
if(!configurator) return;
const activeStep = document.querySelector('[data-config-step="' + configState.step + '"]');
const target = mobile ? (activeStep || configurator) : configurator;
const headerOffset = mobile ? 10 : 18;
const top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerOffset);
const behavior = options.instant ? "auto" : "smooth";
window.scrollTo({ top, behavior });
}
function setConfigStep(step, options){
configState.step = Math.max(1, Math.min(4, Number(step) || 1));
Array.prototype.forEach.call(document.querySelectorAll("[data-config-step]"), function(el){ el.classList.toggle("is-active", Number(el.getAttribute("data-config-step")) === configState.step); });
Array.prototype.forEach.call(document.querySelectorAll("[data-config-step-jump]"), function(el){ el.classList.toggle("is-active", Number(el.getAttribute("data-config-step-jump")) === configState.step); });
if(configEls.footer){
configEls.footer.classList.remove("is-step-1","is-step-2","is-step-3","is-step-4");
configEls.footer.classList.add("is-step-" + configState.step);
}
if(configEls.prev){
configEls.prev.hidden = configState.step === 1;
configEls.prev.style.display = configState.step === 1 ? "none" : "inline-flex";
if(configState.step === 2) configEls.prev.innerHTML = floeverAiI18n.html("← Vazo Seçimi");
else if(configState.step === 3) configEls.prev.innerHTML = floeverAiI18n.html("← Çiçek Seçimi");
else configEls.prev.innerHTML = floeverAiI18n.html("← Geri");
}
if(configEls.next){
const hideNext = configState.step === 4;
configEls.next.hidden = hideNext;
configEls.next.style.display = hideNext ? "none" : "inline-flex";
if(!hideNext){
if(configState.step === 1){
configEls.next.innerHTML = floeverAiI18n.html('<span>Çiçek Seçimi</span> →');
}else if(configState.step === 2){
configEls.next.innerHTML = floeverAiI18n.html('<span>Tarz Seçimi</span> →');
}else if(configState.step === 3){
configEls.next.innerHTML = floeverAiI18n.html('<span>Aranjmanımı Tasarla</span> ✦');
}else{
configEls.next.innerHTML = floeverAiI18n.html('<span>Devam</span> →');
}
}
}
renderConfigSummary();
if(configState.step === 3) refreshStyleAdvice();
setConfigStatus("", "");
if(!(configEls.root && configEls.root.classList.contains("is-welcome"))){
window.requestAnimationFrame(function(){
window.requestAnimationFrame(function(){
scrollConfiguratorToCurrentStep(options);
});
});
}
scheduleConfiguratorStateSave();
}
function validateConfigStep(step){
if(step === 1){
if(!configState.vaseSourceChosen) return "Önce aranjmanın hangi vazoda hazırlanacağını seçin.";
if(configState.vaseMode === "floever" && !configState.selectedVaseId) return "Lütfen bir Floever vazosu seçin.";
if(configState.vaseMode === "own" && !(configState.ownVaseFile || configEls.ownVaseInput?.files?.length)) return "Lütfen kendi vazo fotoğrafınızı yükleyin.";
}
if(step === 2 && selectedConfigFlowers().length === 0) return "Lütfen en az bir tek dal çiçek seçin.";

return "";
}

function normalizeConfigDimensionLabel(value){
const raw = String(value || "").replace(/\s+/g, " ").trim();
if(!raw) return "";
let clean = raw
.replace(/(\d)\s*[x×*]\s*(\d)/g, "$1 × $2")
.replace(/\s+cm\b/gi, " cm")
.replace(/\bCm\b/g, "cm");
if(/\d/.test(clean) && !/\bcm\b/i.test(clean) && /[×x*]|en|boy|yük|yuk|derin|çap|cap|width|height|depth|diameter/i.test(clean)){
clean += " cm";
}
return clean;
}
function getConfigProductDimensionLabel(product){
if(!product) return "";
const directParts = [];
const width = product.widthCm || product.width_cm || product.enCm || product.en_cm || product.width;
const depth = product.depthCm || product.depth_cm || product.derinlikCm || product.derinlik_cm || product.boyCm || product.boy_cm || product.depth;
const height = product.heightCm || product.height_cm || product.yukseklikCm || product.yukseklik_cm || product.height;
if(width || depth || height){
if(width) directParts.push("En " + width + " cm");
if(depth) directParts.push("Derinlik " + depth + " cm");
if(height) directParts.push("Yükseklik " + height + " cm");
return normalizeConfigDimensionLabel(directParts.join(" · "));
}
const candidates = [
product.dimensions,
product.dimension,
product.measurements,
product.measurement,
product.size,
product.optionSummary,
product.variantTitle
].filter(Boolean);
for(let i = 0; i < candidates.length; i += 1){
const candidate = String(candidates[i] || "").trim();
if(!candidate || /default title/i.test(candidate)) continue;
const looksLikeDimension = /\d+(?:[,.]\d+)?\s*(?:cm|santim|mm)\b/i.test(candidate)
  || /\d+(?:[,.]\d+)?\s*(?:x|×|\*)\s*\d+(?:[,.]\d+)?/i.test(candidate)
  || /(en|boy|yükseklik|yukseklik|derinlik|çap|cap|width|height|depth|diameter)\s*[:=]?\s*\d/i.test(candidate);
if(looksLikeDimension) return normalizeConfigDimensionLabel(candidate);
}
return "";
}

const productGalleryIndexes = new Map();
function getProductCardImages(product){
const values = [];
if(product && Array.isArray(product.imageUrls)) values.push.apply(values, product.imageUrls);
if(product && product.imageUrl) values.unshift(product.imageUrl);
return Array.from(new Set(values.map(function(value){ return String(value || "").trim(); }).filter(Boolean))).slice(0,2);
}
function productGalleryKey(type, product){ return String(type || "product") + ":" + String(product && product.id || product && product.variantId || product && product.name || ""); }
function renderProductCardImageGallery(product,type,index){
const images = getProductCardImages(product);
const key = productGalleryKey(type,product);
const selectedIndex = images.length > 1 ? Math.max(0,Math.min(images.length-1,Number(productGalleryIndexes.get(key)||0))) : 0;
const imageHtml = images.map(function(url,imageIndex){
return `<img class="ai-card-gallery-image ${imageIndex===selectedIndex ? "is-active" : ""}" src="${escapeHtml(url)}" alt="${escapeHtml(product && product.name || "Ürün")}${imageIndex ? " ikinci görsel" : ""}" width="420" height="420" loading="${index < 8 && imageIndex===0 ? "eager" : "lazy"}" decoding="async">`;
}).join("");
const controls = images.length > 1
? `<button type="button" class="ai-card-gallery-toggle" data-card-gallery-key="${escapeHtml(key)}" aria-label="Ürünün diğer görselini göster"><span class="ai-card-gallery-icon" aria-hidden="true">▣</span><span data-card-gallery-count>${selectedIndex+1}/${images.length}</span></button><span class="ai-card-gallery-dots" aria-hidden="true">${images.map(function(_,dotIndex){ return `<i class="${dotIndex===selectedIndex ? "is-active" : ""}"></i>`; }).join("")}</span>`
: "";
return {imagesHtml:imageHtml,controlsHtml:controls,key:key};
}
function updateProductGallery(root,key,nextIndex){
if(!root) return;
const images = Array.prototype.slice.call(root.querySelectorAll(".ai-card-gallery-image"));
if(images.length < 2) return;
const next = ((Number(nextIndex)||0) % images.length + images.length) % images.length;
productGalleryIndexes.set(key,next);
images.forEach(function(image,imageIndex){ image.classList.toggle("is-active",imageIndex===next); });
const scope = root.closest(".ai-config-product-card, .ai-vase-change-option") || root.parentElement || root;
Array.prototype.forEach.call(scope.querySelectorAll(".ai-card-gallery-dots i"),function(dot,dotIndex){ dot.classList.toggle("is-active",dotIndex===next); });
const count = scope.querySelector("[data-card-gallery-count]");
if(count) count.textContent = floeverAiI18n.text(String(next+1) + "/" + String(images.length));
}
function bindProductCardGalleries(container){
if(!container) return;
Array.prototype.forEach.call(container.querySelectorAll("[data-card-gallery-key]"),function(control){
if(control.classList.contains("ai-card-gallery-toggle")){
control.addEventListener("click",function(event){
event.preventDefault();
event.stopPropagation();
const scope = control.closest(".ai-config-product-card, .ai-vase-change-option");
const gallery = scope ? scope.querySelector(".ai-card-gallery[data-card-gallery-key]") : null;
if(!gallery) return;
const key = control.getAttribute("data-card-gallery-key") || gallery.getAttribute("data-card-gallery-key") || "";
const images = gallery.querySelectorAll(".ai-card-gallery-image");
if(images.length < 2) return;
updateProductGallery(gallery,key,Number(productGalleryIndexes.get(key)||0)+1);
});
}
});
Array.prototype.forEach.call(container.querySelectorAll(".ai-card-gallery[data-card-gallery-key]"),function(gallery){
if(gallery.dataset.swipeBound === "true") return;
gallery.dataset.swipeBound = "true";
let startX = 0;
let startY = 0;
let startedAt = 0;
gallery.addEventListener("touchstart",function(event){
const touch = event.touches && event.touches[0];
if(!touch) return;
startX = touch.clientX;
startY = touch.clientY;
startedAt = Date.now();
},{passive:true});
gallery.addEventListener("touchend",function(event){
const touch = event.changedTouches && event.changedTouches[0];
if(!touch) return;
const dx = touch.clientX - startX;
const dy = touch.clientY - startY;
const elapsed = Date.now() - startedAt;
if(elapsed > 900 || Math.abs(dx) < 34 || Math.abs(dx) < Math.abs(dy)*1.15) return;
const key = gallery.getAttribute("data-card-gallery-key") || "";
const images = gallery.querySelectorAll(".ai-card-gallery-image");
if(images.length < 2) return;
gallery.dataset.swipedUntil = String(Date.now()+450);
const current = Number(productGalleryIndexes.get(key)||0);
updateProductGallery(gallery,key,current + (dx < 0 ? 1 : -1));
},{passive:true});
gallery.addEventListener("click",function(event){
if(Number(gallery.dataset.swipedUntil||0) > Date.now()){
event.preventDefault();
event.stopPropagation();
}
},true);
});
}
function renderModalVaseImage(vase){
const images = getProductCardImages(vase);
const key = productGalleryKey("vase-modal",vase);
const selectedIndex = images.length > 1 ? Math.max(0,Math.min(images.length-1,Number(productGalleryIndexes.get(key)||0))) : 0;
return `<span class="ai-vase-change-image ai-card-gallery ${images.length>1 ? "has-second-image" : ""}" data-card-gallery-key="${escapeHtml(key)}">${images.map(function(url,index){ return `<img class="ai-card-gallery-image ${index===selectedIndex ? "is-active" : ""} ${index===0 ? "is-primary" : "is-secondary"}" src="${escapeHtml(url)}" alt="${escapeHtml(vase.name || "Vazo")}${index ? " ikinci görsel" : ""}">`; }).join("")}${images.length>1 ? `<span class="ai-card-gallery-dots" aria-hidden="true">${images.map(function(_,dotIndex){ return `<i class="${dotIndex===selectedIndex ? "is-active" : ""}"></i>`; }).join("")}</span>` : ""}</span>`;
}

function renderConfigVases(){
if(!configEls.vaseGrid) return;
if(!configState.vases.length){
configEls.vaseGrid.innerHTML = floeverAiI18n.html("");
configEls.vaseGrid.classList.remove("is-single","is-duo");
if(configEls.vaseStatus){ configEls.vaseStatus.hidden = false; configEls.vaseStatus.textContent = floeverAiI18n.text("Henüz vazo eklenmedi."); }
return;
}
if(configEls.vaseStatus){ configEls.vaseStatus.textContent = floeverAiI18n.text(""); configEls.vaseStatus.hidden = true; }
configEls.vaseGrid.classList.toggle("is-single", configState.vases.length === 1);
configEls.vaseGrid.classList.toggle("is-duo", configState.vases.length === 2);
configEls.vaseGrid.innerHTML = floeverAiI18n.html(configState.vases.map(function(vase, index){
const selected = String(vase.id) === String(configState.selectedVaseId);
const price = vase.priceLabel || (vase.priceAmount ? formatTry(vase.priceAmount) : "Fiyat yok");
const category = vase.category || vase.material || "Vazo";
const dimensionLabel = getConfigProductDimensionLabel(vase);
const gallery = renderProductCardImageGallery(vase,"vase",index);
return `
<article class="ai-config-product-card ai-config-product-card-clean ai-vase-product-card ${selected ? "is-selected" : ""}">
<button type="button" class="ai-config-product-select" data-config-vase="${escapeHtml(vase.id)}" aria-pressed="${selected ? "true" : "false"}">
<div class="ai-config-product-image ai-card-gallery" data-card-gallery-key="${escapeHtml(gallery.key)}">${gallery.imagesHtml}</div>
<div class="ai-config-product-body">
<div class="ai-config-product-kind">${escapeHtml(category)}</div>
<div class="ai-config-product-title">${escapeHtml(vase.name)}</div>
${dimensionLabel ? `<div class="ai-config-product-dimensions">${escapeHtml(dimensionLabel)}</div>` : ""}
<div class="ai-config-product-price">${escapeHtml(price)}</div>
</div>
</button>
${gallery.controlsHtml}
</article>`;
}).join(""));
bindProductCardGalleries(configEls.vaseGrid);
Array.prototype.forEach.call(configEls.vaseGrid.querySelectorAll("[data-config-vase]"), function(btn){
btn.addEventListener("click", function(){
configState.selectedVaseId = btn.getAttribute("data-config-vase") || "";
configState.vaseMode = "floever";
configState.vaseSourceChosen = true;
invalidateCompositionRecommendations();
syncVaseSourceDecisionUi();
renderConfigVases();
renderConfigSummary();
scheduleConfiguratorStateSave();
});
});
}
function normalizeTrText(value){
return String(value || "")
.toLocaleLowerCase("tr-TR")
.replace(/ı/g, "i")
.replace(/ğ/g, "g")
.replace(/ü/g, "u")
.replace(/ş/g, "s")
.replace(/ö/g, "o")
.replace(/ç/g, "c");
}
function flowerSearchSource(flower){
return normalizeTrText([
flower.name,
flower.category,
flower.color,
flower.material,
flower.productType,
Array.isArray(flower.tags) ? flower.tags.join(" ") : "",
flower.optionSummary,
flower.dimensions
].filter(Boolean).join(" "));
}
const FLOWER_KIND_FILTERS = [
{ value: "ortanca", label: "Ortanca" },
{ value: "orkide", label: "Orkide" },
{ value: "mimoza", label: "Mimoza" },
{ value: "gul", label: "Gül" },
{ value: "sakayik", label: "Şakayık" },
{ value: "lale", label: "Lale" },
{ value: "sumbul", label: "Sümbül" },
{ value: "papatya", label: "Papatya" },
{ value: "yesillik", label: "Yeşillik / Ara Malzeme" }
];
const FLOWER_COLOR_FILTERS = [
{ value: "beyaz", label: "Beyaz / Krem", aliases: ["beyaz", "krem", "ekru", "white", "cream"] },
{ value: "pembe", label: "Pembe", aliases: ["pembe", "pink"] },
{ value: "sari", label: "Sarı", aliases: ["sari", "sarı", "yellow"] },
{ value: "yesil", label: "Yeşil", aliases: ["yesil", "yeşil", "green"] },
{ value: "mor", label: "Mor / Lila", aliases: ["mor", "lila", "lavanta", "purple", "lilac"] },
{ value: "mavi", label: "Mavi", aliases: ["mavi", "blue"] },
{ value: "kirmizi", label: "Kırmızı", aliases: ["kirmizi", "kırmızı", "red", "bordo"] },
{ value: "turuncu", label: "Turuncu", aliases: ["turuncu", "orange"] }
];
function populateFlowerFilters(){
if(configEls.flowerFilterPanel) configEls.flowerFilterPanel.hidden = !configState.flowers.length || !configState.filtersOpen;
if(configEls.flowerTypeFilter){
const sourceText = configState.flowers.map(flowerSearchSource).join(" ");
const current = configEls.flowerTypeFilter.value || "";
const options = ['<option value="">Çiçek</option>'].concat(
FLOWER_KIND_FILTERS
.filter(function(item){ return sourceText.indexOf(item.value) !== -1 || item.value === "yesillik"; })
.map(function(item){ return `<option value="${item.value}">${item.label}</option>`; })
);
configEls.flowerTypeFilter.innerHTML = floeverAiI18n.html(options.join(""));
configEls.flowerTypeFilter.value = current;
}
if(configEls.flowerColorFilter){
const sourceText = configState.flowers.map(flowerSearchSource).join(" ");
const current = configEls.flowerColorFilter.value || "";
const options = ['<option value="">Renk</option>'].concat(
FLOWER_COLOR_FILTERS
.filter(function(item){ return item.aliases.some(function(alias){ return sourceText.indexOf(normalizeTrText(alias)) !== -1; }); })
.map(function(item){ return `<option value="${item.value}">${item.label}</option>`; })
);
configEls.flowerColorFilter.innerHTML = floeverAiI18n.html(options.join(""));
configEls.flowerColorFilter.value = current;
}
}
function flowerMatchesFilters(flower){
const filters = configState.flowerFilters || {};
const source = flowerSearchSource(flower);
if(filters.search && source.indexOf(normalizeTrText(filters.search)) === -1) return false;
if(filters.type){
if(filters.type === "yesillik"){
const typeText = normalizeTrText(flower.itemType || flower.aiItemType || flower.category || flower.productType || "");
if(typeText.indexOf("greenery") === -1 && typeText.indexOf("yesillik") === -1 && typeText.indexOf("ara") === -1 && source.indexOf("yaprak") === -1 && source.indexOf("dal") === -1) return false;
}else if(source.indexOf(filters.type) === -1){
return false;
}
}
if(filters.color){
const colorConfig = FLOWER_COLOR_FILTERS.find(function(item){ return item.value === filters.color; });
if(colorConfig && !colorConfig.aliases.some(function(alias){ return source.indexOf(normalizeTrText(alias)) !== -1; })) return false;
}
if(filters.price){
const price = parseConfigMoney(flower.priceAmount || flower.priceLabel);
if(filters.price === "0-250" && !(price >= 0 && price <= 250)) return false;
if(filters.price === "250-500" && !(price > 250 && price <= 500)) return false;
if(filters.price === "500-1000" && !(price > 500 && price <= 1000)) return false;
if(filters.price === "1000+" && !(price > 1000)) return false;
}
return true;
}
function getCustomerFacingFlowerKindLabel(value){
const raw = String(value || "").trim();
const token = normalizeTrText(raw);

if(!token) return "";

if(
token.indexOf("grafik kure") !== -1 ||
token.indexOf("kure cicegi") !== -1 ||
token.indexOf("kuresel") !== -1
) return "Küresel Doku";

if(
token.indexOf("egzotik premium odak") !== -1 ||
token.indexOf("premium odak") !== -1 ||
token.indexOf("egzotik odak") !== -1 ||
token.indexOf("graphic focal") !== -1 ||
token.indexOf("focal point") !== -1
) return "Odak Çiçeği";

if(
token.indexOf("premium buyuk") !== -1 ||
token.indexOf("buyuk cicek") !== -1 ||
token.indexOf("ana hacim") !== -1 ||
token.indexOf("focal mass") !== -1 ||
token.indexOf("main focal") !== -1
) return "Ana Çiçek";

if(
token.indexOf("dalli cicek") !== -1 ||
token.indexOf("dal cicek") !== -1 ||
token.indexOf("line movement") !== -1 ||
token.indexOf("cizgisel") !== -1
) return "Dallı Form";

if(
token.indexOf("ince doku") !== -1 ||
token.indexOf("soft texture") !== -1
) return "İnce Doku";

if(
token.indexOf("salkim doku") !== -1 ||
token.indexOf("salkim") !== -1
) return "Salkım Doku";

if(
token.indexOf("kuru cizgi") !== -1 ||
token.indexOf("kuru doku") !== -1 ||
token.indexOf("dry texture") !== -1
) return "Kuru Doku";

if(
token.indexOf("grafik doku") !== -1 ||
token.indexOf("texture filler") !== -1 ||
token.indexOf("doku tamamlayici") !== -1
) return "Grafik Doku";

if(
token.indexOf("yesillik") !== -1 ||
token.indexOf("greenery") !== -1 ||
token.indexOf("yaprak") !== -1 ||
token.indexOf("foliage") !== -1
) return "Yeşillik";

if(
token.indexOf("ara malzeme") !== -1 ||
token.indexOf("ara doku") !== -1 ||
token.indexOf("dolgu") !== -1 ||
token.indexOf("filler") !== -1
) return "Ara Doku";

if(token.indexOf("orkide") !== -1) return "Orkide";
if(token.indexOf("lale") !== -1) return "Lale";
if(token.indexOf("ortanca") !== -1) return "Ortanca";
if(token.indexOf("sakayik") !== -1) return "Şakayık";
if(token.indexOf("gul") !== -1) return "Gül";
if(token.indexOf("mimoza") !== -1) return "Mimoza";
if(token.indexOf("sumbul") !== -1) return "Sümbül";
if(token.indexOf("papatya") !== -1) return "Papatya";

return raw;
}

function getConfigFlowerKindLabel(flower){
const source = flowerSearchSource(flower);
const rawKind =
flower.category ||
flower.aiCategory ||
flower.productType ||
flower.itemType ||
flower.aiItemType ||
flower.type ||
flower.material ||
"";

const customerLabel = getCustomerFacingFlowerKindLabel(rawKind);
if(customerLabel) return customerLabel;

const rawType = normalizeTrText(rawKind);
if(rawType.indexOf("greenery") !== -1 || rawType.indexOf("yesillik") !== -1 || rawType.indexOf("ara") !== -1 || source.indexOf("yaprak") !== -1) return "Yeşillik";

for(let i = 0; i < FLOWER_KIND_FILTERS.length; i += 1){
const item = FLOWER_KIND_FILTERS[i];
if(item.value !== "yesillik" && source.indexOf(item.value) !== -1) return item.label;
}

if(rawType.indexOf("ana") !== -1) return "Ana Çiçek";
return "Ana Çiçek";
}

function normalizeRecommendationToken(value){
return normalizeTrText(value).replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}
function recommendationArray(value){
if(Array.isArray(value)) return value.map(normalizeRecommendationToken).filter(Boolean);
return String(value || "").split(/[;,|\n]+/).map(normalizeRecommendationToken).filter(Boolean);
}
function uniqueRecommendationTokens(values){
const seen = new Set();
const out = [];
(values || []).forEach(function(value){
const token = normalizeRecommendationToken(value);
if(token && !seen.has(token)){ seen.add(token); out.push(token); }
});
return out;
}
const AI_COLOR_PROFILES = {
white:{label:"Beyaz", temperature:"neutral", group:"light", harmonies:["white","cream","green","blue","purple","pink","earth","yellow"]},
cream:{label:"Krem", temperature:"warm_neutral", group:"light", harmonies:["white","cream","beige","earth","green","pink","yellow","brown"]},
beige:{label:"Bej", temperature:"warm_neutral", group:"earth", harmonies:["cream","beige","earth","brown","green","white","yellow"]},
pink:{label:"Pembe", temperature:"warm_soft", group:"romantic", harmonies:["pink","cream","white","purple","green","burgundy","beige"]},
red:{label:"Kırmızı", temperature:"warm", group:"strong", harmonies:["red","burgundy","pink","green","white","cream"]},
burgundy:{label:"Bordo", temperature:"warm_deep", group:"strong", harmonies:["burgundy","red","pink","cream","green","purple"]},
purple:{label:"Mor", temperature:"cool", group:"deep", harmonies:["purple","pink","blue","white","cream","green"]},
blue:{label:"Mavi", temperature:"cool", group:"cool", harmonies:["blue","white","purple","green","cream"]},
yellow:{label:"Sarı", temperature:"warm", group:"bright", harmonies:["yellow","white","cream","green","beige","orange"]},
orange:{label:"Turuncu", temperature:"warm", group:"bright", harmonies:["orange","yellow","cream","beige","brown","green"]},
green:{label:"Yeşil", temperature:"natural", group:"foliage", harmonies:["green","white","cream","pink","yellow","purple","earth","beige","blue","red","burgundy"]},
brown:{label:"Kahverengi", temperature:"earth", group:"earth", harmonies:["brown","beige","cream","green","orange","yellow","white"]},
earth:{label:"Toprak", temperature:"earth", group:"earth", harmonies:["earth","beige","cream","brown","green","orange","yellow"]},
black:{label:"Siyah", temperature:"neutral", group:"dark", harmonies:["black","white","cream","green","red","burgundy"]}
};
function inferColorTokensFromText(value){
const source = normalizeTrText(value || "");
const tokens = [];
function add(key){ if(tokens.indexOf(key) === -1) tokens.push(key); }
if(/beyaz|white|ekru/.test(source)) add("white");
if(/krem|cream|ivory|fildisi|fil_disi/.test(source)) add("cream");
if(/bej|beige|sampanya|champagne/.test(source)) add("beige");
if(/pembe|pink|pudra|somon/.test(source)) add("pink");
if(/kirmizi|kırmızı|red/.test(source)) add("red");
if(/bordo|burgundy|sarap/.test(source)) add("burgundy");
if(/mor|lila|lavanta|purple|violet/.test(source)) add("purple");
if(/mavi|blue|lacivert/.test(source)) add("blue");
if(/sari|sarı|yellow|hardal/.test(source)) add("yellow");
if(/turuncu|orange|somon/.test(source)) add("orange");
if(/yesil|yeşil|green|yaprak/.test(source)) add("green");
if(/kahve|kahverengi|brown/.test(source)) add("brown");
if(/toprak|earth|naturel|natural|dogal|doğal/.test(source)) add("earth");
if(/siyah|black/.test(source)) add("black");
return tokens;
}
function getFlowerColorTokens(flower){
if(!flower) return [];
return uniqueRecommendationTokens([].concat(
recommendationArray(flower.colorFamily || flower.aiColorFamily),
recommendationArray(flower.colorTemperature || flower.aiColorTemperature),
recommendationArray(flower.paletteTags || flower.aiPaletteTags),
inferColorTokensFromText(flower.color || ""),
inferColorTokensFromText(flower.name || ""),
inferColorTokensFromText(flower.category || "")
)).filter(function(token){ return AI_COLOR_PROFILES[token]; });
}
function colorTokenLabel(token){ return AI_COLOR_PROFILES[token]?.label || token; }
function colorHarmonyScore(selectedColorTokens, candidateColorTokens){
if(!selectedColorTokens.length || !candidateColorTokens.length) return {score:0,label:"Renk bilgisi eksik"};
let best = {score:-10,label:"Nötr uyum"};
selectedColorTokens.forEach(function(selected){
const profile = AI_COLOR_PROFILES[selected];
candidateColorTokens.forEach(function(candidate){
let score = 0;
let label = "Renk uyumu";
if(candidate === selected){ score = 34; label = "Ton sür ton uyum"; }
else if(profile && profile.harmonies && profile.harmonies.indexOf(candidate) !== -1){ score = 28; label = colorTokenLabel(selected) + " ile uyumlu renk"; }
else if(candidate === "green"){ score = 22; label = "Doğal yeşil denge"; }
else if(["white","cream","beige"].indexOf(candidate) !== -1){ score = 18; label = "Nötr yumuşatma"; }
else { score = -8; label = "Renk uyumu zayıf"; }
if(score > best.score) best = {score:score,label:label};
});
});
return best.score < 0 ? {score:0,label:best.label} : best;
}
function getFlowerRecommendationTags(flower){
if(!flower) return [];
return uniqueRecommendationTokens([].concat(
recommendationArray(flower.recommendationTags || flower.aiRecommendationTags),
recommendationArray(flower.category),
recommendationArray(flower.color),
recommendationArray(flower.designRole || flower.aiDesignRole),
recommendationArray(flower.secondaryRole || flower.aiSecondaryRole),
recommendationArray(flower.formType || flower.aiFormType),
recommendationArray(flower.movementLevel || flower.aiMovementLevel),
recommendationArray(flower.textureLevel || flower.aiTextureLevel),
recommendationArray(flower.visualWeight || flower.aiVisualWeight),
recommendationArray(flower.productType),
recommendationArray(flower.itemType || flower.aiItemType),
recommendationArray(flower.family || flower.aiFamily),
recommendationArray(flower.pairingRole || flower.aiPairingRole),
recommendationArray(flower.styleTags || flower.aiStyleTags),
recommendationArray(flower.paletteTags || flower.aiPaletteTags),
getFlowerColorTokens(flower),
Array.isArray(flower.tags) ? flower.tags : []
));
}
function getFlowerWantedRecommendationTags(flower){
if(!flower) return [];
return uniqueRecommendationTokens([].concat(
recommendationArray(flower.recommendedWithTags || flower.aiRecommendedWithTags),
recommendationArray(flower.pairingNeedTags || flower.aiPairingNeedTags)
)).filter(function(token){
return token !== "vase" && token !== "vazo" && token !== "vase_base";
});
}
function getFlowerDirectRecommendationIds(flower){
const raw = [].concat(
Array.isArray(flower && flower.recommendedWithIds) ? flower.recommendedWithIds : [],
Array.isArray(flower && flower.aiRecommendedWithIds) ? flower.aiRecommendedWithIds : []
);
return raw.map(function(item){ return String(item || "").trim(); }).filter(Boolean);
}
function getFlowerIdentityTokens(flower){
return uniqueRecommendationTokens([
flower && flower.id,
flower && flower.variantId,
flower && flower.shopifyProductId,
flower && flower.handle,
flower && flower.name
]).concat([String(flower && flower.id || ""), String(flower && flower.variantId || ""), String(flower && flower.handle || "")].filter(Boolean));
}
function selectedConfigFlowerObjects(){
return selectedConfigFlowers().map(function(item){
const flower = getConfigFlowerById(item.id);
return flower ? Object.assign({}, flower, {selectedCount:item.count}) : null;
}).filter(Boolean);
}
function canonicalRecommendationRole(value){
const token = normalizeRecommendationToken(value);
if(!token) return "support";
if(/greenery|greenery_base|greenery_support|support_foliage|foliage|yesillik|yaprak/.test(token)) return "greenery";
if(/texture_filler|filler_flower|support_filler|airy_accent|dolgu|ara_doku|ince_doku|salkim_doku|grafik_doku/.test(token)) return "filler";
if(/line_movement|line_flower|movement_flower|vertical_texture|upright_line|branching_line|cascading_line|horizontal|vertical|cizgisel|hareket/.test(token)) return "line";
if(/premium_focal|focal_mass|main_focal|graphic_focal|focal_point|ana_cicek|ana_hacim|odak/.test(token)) return "focal";
if(/secondary_flower|secondary_focal|supporting_flower|ikincil/.test(token)) return "secondary";
return "support";
}
function flowerRoleGroups(flower){
if(!flower) return ["support"];
const groups = uniqueRecommendationTokens([
flower.designRole || flower.aiDesignRole,
flower.secondaryRole || flower.aiSecondaryRole,
flower.pairingRole || flower.aiPairingRole,
flower.itemType || flower.aiItemType,
flower.category
]).map(canonicalRecommendationRole).filter(Boolean);
const unique = [];
groups.forEach(function(group){ if(unique.indexOf(group) === -1) unique.push(group); });
return unique.length ? unique : ["support"];
}
function flowerRoleGroup(flower){
return flowerRoleGroups(flower)[0] || "support";
}
function roleGroupLabel(role){
if(role === "greenery") return "Yeşillik / doğal bağlayıcı";
if(role === "line") return "Hareket veren çizgisel ürün";
if(role === "filler") return "Dolgu / doku tamamlayıcı";
if(role === "focal") return "Ana odak çiçeği";
if(role === "secondary") return "İkincil çiçek";
return "Tamamlayıcı ürün";
}
function selectedRoleSummary(selectedObjects){
const roles = {focal:0, secondary:0, greenery:0, filler:0, line:0, support:0};
(selectedObjects || []).forEach(function(flower){
const groups = flowerRoleGroups(flower);
const count = Math.max(1, Number(flower.selectedCount || 1));
groups.forEach(function(role, index){
roles[role] += index === 0 ? count : Math.min(1.5, count * 0.5);
});
});
return roles;
}
function selectedFlowerFamilySet(selectedObjects){
const families = new Set();
(selectedObjects || []).forEach(function(flower){
const family = normalizeRecommendationToken(flower && (flower.family || flower.aiFamily || flower.name || ""));
if(family) families.add(family);
});
return families;
}
function selectedFlowerFormSet(selectedObjects){
const forms = new Set();
(selectedObjects || []).forEach(function(flower){
recommendationArray(flower && (flower.formType || flower.aiFormType || "")).forEach(function(form){ forms.add(form); });
});
return forms;
}
function numericAiField(flower, keys, fallback){
for(let i = 0; i < keys.length; i += 1){
const value = Number(flower && flower[keys[i]]);
if(Number.isFinite(value)) return value;
}
return Number(fallback || 0);
}
function normalizeAiLevel(value){
const token = normalizeRecommendationToken(value);
if(["very_high","high","strong","yuksek"].indexOf(token) !== -1) return 3;
if(["medium_high","medium","balanced","orta"].indexOf(token) !== -1) return 2;
if(["low","light","soft","dusuk"].indexOf(token) !== -1) return 1;
return 0;
}
const ARRANGEMENT_STYLE_PROFILES = {
top_form:{
label:"Top Form",
wanted:["top_form","round","rounded","dome","compact_dome","oval_mass","round_mass","dense_round_mass","focal_mass","balanced","symmetry","soft_symmetry"],
avoid:["upright_line","branching_line","cascading_line","directional","architectural","strong_movement","negative_space","asymmetric_vertical"],
preferredRoles:["focal","secondary","filler"]
},
modern_design:{
label:"Modern Tasarımsal",
wanted:["modern","sculptural","architectural","asymmetry","asymmetric","line_movement","upright_line","branching_line","cascading_line","negative_space","graphic","premium_focal"],
avoid:["dense_filler","heavy_greenery","romantic_mass","round_bouquet"],
preferredRoles:["focal","line"]
},
exotic:{
label:"Egzotik",
wanted:["exotic","tropical","sculptural","bold","premium_focal","line_movement","architectural","strong_contrast","protea","antoryum","orchid","orkide"],
avoid:["generic_filler","soft_romantic","dense_round_mass"],
preferredRoles:["focal","line"]
},
natural_elegant:{
label:"Doğal ve Zarif",
wanted:["natural","organic","airy","soft_transition","balanced","branching_line","airy_cluster","texture_filler","greenery_base","soft_palette"],
avoid:["very_graphic","hard_contrast","over_sculptural"],
preferredRoles:["secondary","filler","greenery","line"]
}
};
function getSelectedGeometryKey(){
const style = normalizeRecommendationToken(getSelectedArrangementStyle && getSelectedArrangementStyle() || "");
if(!style || style === "ai_secimi" || style === "ai_selection") return "ai_selection";
if(style.indexOf("top_form") !== -1 || style.indexOf("topform") !== -1 || style.indexOf("oval") !== -1 || style.indexOf("yuvarlak") !== -1 || style.indexOf("kuresel") !== -1) return "top_form";
if(style.indexOf("yatay") !== -1 || style.indexOf("horizontal") !== -1 || style.indexOf("konsol") !== -1) return "horizontal";
if(style.indexOf("sarkik") !== -1 || style.indexOf("cascade") !== -1 || style.indexOf("cascading") !== -1) return "cascade";
if(style.indexOf("uzun") !== -1 || style.indexOf("dikey") !== -1 || style.indexOf("vertical") !== -1 || style.indexOf("heykelsi") !== -1) return "tall_vertical";
if(style.indexOf("daginik") !== -1 || style.indexOf("asimetrik") !== -1 || style.indexOf("asymmetric") !== -1 || style.indexOf("loose") !== -1) return "loose_asymmetric";
return "";
}
function getSelectedStyleProfileKey(){
const style = normalizeRecommendationToken(getSelectedArrangementStyle && getSelectedArrangementStyle() || "");
const geometryKey = getSelectedGeometryKey();
if(geometryKey === "top_form") return "top_form";
if(geometryKey === "tall_vertical" || geometryKey === "horizontal" || geometryKey === "loose_asymmetric") return "modern_design";
if(geometryKey === "cascade") return "natural_elegant";
if(!style || style === "ai_secimi" || style === "ai_selection") return "";
if(style.indexOf("modern") !== -1 || style.indexOf("tasarimsal") !== -1) return "modern_design";
if(style.indexOf("egzotik") !== -1 || style.indexOf("exotic") !== -1) return "exotic";
if(style.indexOf("dogal") !== -1 || style.indexOf("zarif") !== -1 || style.indexOf("natural") !== -1) return "natural_elegant";
return "";
}
function getStyleWantedTags(){
const key = getSelectedStyleProfileKey();
return key && ARRANGEMENT_STYLE_PROFILES[key] ? ARRANGEMENT_STYLE_PROFILES[key].wanted.slice() : [];
}
function styleAffinityForFlower(flower, styleKey){
const profile = ARRANGEMENT_STYLE_PROFILES[styleKey];
if(!profile || !flower) return 0;
const tags = new Set(getFlowerRecommendationTags(flower));
let score = 0;
profile.wanted.forEach(function(token){ if(tags.has(normalizeRecommendationToken(token))) score += 6; });
profile.avoid.forEach(function(token){ if(tags.has(normalizeRecommendationToken(token))) score -= 10; });
const groups = flowerRoleGroups(flower);
profile.preferredRoles.forEach(function(role){ if(groups.indexOf(role) !== -1) score += 8; });
const movement = normalizeAiLevel(flower.movementLevel || flower.aiMovementLevel);
const texture = normalizeAiLevel(flower.textureLevel || flower.aiTextureLevel);
const family = normalizeRecommendationToken(flower.family || flower.aiFamily || flower.name || "");
if(styleKey === "top_form"){
if(groups.indexOf("focal") !== -1 || groups.indexOf("secondary") !== -1) score += 12;
if(groups.indexOf("filler") !== -1) score += 8;
if(movement >= 3 || groups.indexOf("line") !== -1) score -= 10;
if(["ortanca","hydrangea","gul","rose","sakayik","peony"].some(function(token){ return family.indexOf(token) !== -1; })) score += 8;
}
if(styleKey === "modern_design"){
if(movement >= 2) score += 8;
if(groups.indexOf("filler") !== -1 && texture >= 3) score -= 8;
if(groups.indexOf("greenery") !== -1) score -= 4;
}
if(styleKey === "exotic"){
if(["protea","antoryum","anthurium","orkide","orchid","strelitzia","cennet_kusu"].some(function(token){ return family.indexOf(token) !== -1 || tags.has(token); })) score += 24;
if(movement >= 2) score += 6;
}
if(styleKey === "natural_elegant"){
if(groups.indexOf("filler") !== -1 || groups.indexOf("greenery") !== -1) score += 10;
if(texture >= 2) score += 6;
if(movement === 2) score += 4;
}
return Math.max(-45, Math.min(65, score));
}
function selectedColorHarmonyQuality(selectedObjects){
const source = (selectedObjects || []).filter(Boolean);
if(source.length < 2) return 8;
let good = 0;
let total = 0;
for(let i = 0; i < source.length; i += 1){
for(let j = i + 1; j < source.length; j += 1){
const info = colorHarmonyScore(getFlowerColorTokens(source[i]), getFlowerColorTokens(source[j]));
if(info.score >= 16) good += 1;
total += 1;
}
}
if(!total) return 7;
const ratio = good / total;
if(ratio >= 0.8) return 12;
if(ratio >= 0.55) return 9;
if(ratio >= 0.3) return 5;
return 1;
}
function analyzeArrangementCompletion(selectedObjects){
const source = (selectedObjects || []).filter(Boolean);
const roles = selectedRoleSummary(source);
const totalStems = selectedFlowerTotalCount(source);
const familyCount = selectedFlowerFamilySet(source).size;
const roleKinds = ["focal","secondary","line","filler","greenery"].filter(function(role){ return roles[role] > 0; }).length;
const hasAnchor = roles.focal > 0 || roles.secondary >= 2;
let score = 0;
if(roles.focal > 0) score += 28;
else if(roles.secondary > 0) score += 18;
else if(roles.line > 0) score += 10;
if(roles.line > 0 || roles.secondary > 0) score += 24;
if(roles.filler > 0) score += 14;
if(roles.greenery > 0) score += 7;
if(familyCount >= 2) score += 12;
if(familyCount >= 3) score += 5;
if(totalStems >= 4) score += 10;
if(totalStems >= 7) score += 4;
if(roleKinds >= 3) score += 5;
score += selectedColorHarmonyQuality(source);
score = Math.max(0, Math.min(100, Math.round(score)));
const missingRoles = [];
if(!hasAnchor) missingRoles.push("focal");
if(roles.line <= 0 && roles.secondary <= 0) missingRoles.push("line");
if(roles.filler <= 0 && roleKinds < 3) missingRoles.push("filler");
if(roles.greenery <= 0 && totalStems >= 6) missingRoles.push("greenery");
const isComplete = Boolean(source.length && score >= 72 && hasAnchor && familyCount >= 2 && totalStems >= 4 && (roles.line > 0 || roles.filler > 0 || roles.secondary > 0));
return {
roles:roles,
totalStems:totalStems,
productCount:source.length,
familyCount:familyCount,
roleKinds:roleKinds,
score:score,
missingRoles:missingRoles,
isComplete:isComplete
};
}
function analyzeStyleCompatibility(selectedObjects, styleKey){
const source = (selectedObjects || []).filter(Boolean);
if(!styleKey || !ARRANGEMENT_STYLE_PROFILES[styleKey]) return {score:null,status:"neutral",message:"Tarz seçildiğinde ürün uyumu yeniden değerlendirilecek."};
if(!source.length) return {score:0,status:"weak",message:"Önce aranjmanda kullanılacak çiçekleri seçin."};
let weighted = 0;
let weightTotal = 0;
source.forEach(function(flower){
const count = Math.max(1, Number(flower.selectedCount || 1));
weighted += styleAffinityForFlower(flower, styleKey) * Math.min(count, 3);
weightTotal += Math.min(count, 3);
});
const analysis = analyzeArrangementCompletion(source);
let score = 50 + (weightTotal ? weighted / weightTotal : 0);
if(styleKey === "top_form"){
if(analysis.roles.focal > 0 || analysis.roles.secondary >= 2) score += 10;
if(analysis.roles.filler > 0) score += 6;
if(analysis.roles.line > 2) score -= 12;
}
if(styleKey === "modern_design"){
if(analysis.roles.line > 0) score += 8;
if(analysis.roles.filler > 3) score -= 10;
if(analysis.roles.greenery > 3) score -= 8;
}
if(styleKey === "exotic"){
if(analysis.roles.focal > 0 && analysis.roles.line > 0) score += 10;
}
if(styleKey === "natural_elegant"){
if(analysis.roles.filler > 0) score += 8;
if(analysis.roles.greenery > 0) score += 6;
}
score = Math.max(0, Math.min(100, Math.round(score)));
if(score >= 78) return {score:score,status:"strong",message:"Seçtiğiniz ürünler bu tarz için güçlü bir uyum gösteriyor."};
if(score >= 56) return {score:score,status:"adaptable",message:"Seçiminiz bu tarza uyarlanabilir; aşağıdaki dokunuşlar sonucu güçlendirebilir."};
return {score:score,status:"weak",message:"Bu tarz için kompozisyonu güçlendirecek bir ürün rolü eksik görünüyor."};
}

function buildArrangementCompositionPlan(){
const selectedObjects = selectedConfigFlowerObjects();
const analysis = analyzeArrangementCompletion(selectedObjects);
const styleKey = getSelectedStyleProfileKey();
const geometryKey = getSelectedGeometryKey();
const styleProfile = styleKey ? ARRANGEMENT_STYLE_PROFILES[styleKey] : null;
const compatibility = analyzeStyleCompatibility(selectedObjects, styleKey);
const targets = {
top_form:{
density:"medium_high",
symmetry:"soft_radial_symmetry",
negativeSpace:"low_controlled",
movement:"contained_within_dome",
greeneryLevel:"low_tucked_inside",
textureLevel:"layered_compact",
grouping:"interlocked_rounded_clusters",
silhouette:"compact_rounded_dome",
heightVariation:"very_low",
focalDirection:"centered_360_degree_dome",
geometryLock:"top_form_strict"
},
tall_vertical:{
density:"medium_low",
symmetry:"asymmetric_vertical",
negativeSpace:"medium_high",
movement:"strong_upward",
greeneryLevel:"low",
textureLevel:"controlled",
grouping:"low_anchor_with_vertical_lines",
silhouette:"strict_tall_narrow_vertical",
heightVariation:"very_strong",
focalDirection:"low_focal_to_high_axis",
geometryLock:"tall_vertical_strict"
},
horizontal:{
density:"medium",
symmetry:"balanced_horizontal_asymmetry",
negativeSpace:"medium",
movement:"left_right_extension",
greeneryLevel:"low_medium",
textureLevel:"controlled_layered",
grouping:"central_anchor_with_two_wings",
silhouette:"strict_low_wide_horizontal",
heightVariation:"low",
focalDirection:"center_to_left_right",
geometryLock:"horizontal_strict"
},
loose_asymmetric:{
density:"medium_low",
symmetry:"controlled_irregular_asymmetry",
negativeSpace:"medium_high",
movement:"multi_directional_coherent",
greeneryLevel:"low_medium",
textureLevel:"selective",
grouping:"unequal_connected_clusters",
silhouette:"strict_loose_asymmetric",
heightVariation:"medium_strong",
focalDirection:"off_center_with_counterbalance",
geometryLock:"loose_asymmetric_strict"
},
cascade:{
density:"medium",
symmetry:"asymmetric",
negativeSpace:"medium",
movement:"clear_downward_cascade",
greeneryLevel:"medium",
textureLevel:"soft_layered",
grouping:"upper_anchor_with_lower_flow",
silhouette:"strict_cascading",
heightVariation:"medium",
focalDirection:"upper_anchor_to_lower_side",
geometryLock:"cascade_strict"
},
modern_design:{
density:"medium_low",
symmetry:"asymmetric",
negativeSpace:"high",
movement:"strong_directional",
greeneryLevel:"low",
textureLevel:"controlled",
grouping:"intentional_clusters",
silhouette:"sculptural_architectural",
heightVariation:"strong",
focalDirection:"single_clear_focal_zone"
},
exotic:{
density:"medium",
symmetry:"asymmetric",
negativeSpace:"medium",
movement:"strong_expressive",
greeneryLevel:"low_medium",
textureLevel:"controlled_bold",
grouping:"sculptural_groups",
silhouette:"bold_tropical_inspired",
heightVariation:"strong",
focalDirection:"hero_focal_with_line_movement"
},
natural_elegant:{
density:"medium",
symmetry:"organic_asymmetry",
negativeSpace:"medium",
movement:"soft_organic",
greeneryLevel:"medium",
textureLevel:"soft_layered",
grouping:"natural_layered_clusters",
silhouette:"graceful_balanced",
heightVariation:"soft_medium",
focalDirection:"balanced_soft_focal"
},
ai_selection:{
density:"balanced",
symmetry:"adaptive",
negativeSpace:"balanced",
movement:"adaptive",
greeneryLevel:"adaptive",
textureLevel:"adaptive",
grouping:"florist_hierarchy",
silhouette:"best_fit_for_selected_products",
heightVariation:"adaptive",
focalDirection:"best_fit"
}
};
const selectedTarget = targets[geometryKey] || targets[styleKey] || targets.ai_selection;
const products = selectedObjects.map(function(flower){
return {
id:String(flower.id || ""),
name:String(flower.name || ""),
quantity:Math.max(1, Number(flower.selectedCount || 1)),
family:String(flower.family || flower.aiFamily || ""),
primaryRole:String(flower.designRole || flower.aiDesignRole || ""),
secondaryRole:String(flower.secondaryRole || flower.aiSecondaryRole || ""),
formType:String(flower.formType || flower.aiFormType || ""),
movementLevel:String(flower.movementLevel || flower.aiMovementLevel || ""),
textureLevel:String(flower.textureLevel || flower.aiTextureLevel || ""),
visualWeight:String(flower.visualWeight || flower.aiVisualWeight || ""),
colorFamily:String(flower.colorFamily || flower.aiColorFamily || ""),
paletteTags:recommendationArray(flower.paletteTags || flower.aiPaletteTags).slice(0,8)
};
});
return {
schemaVersion:"3.0",
engine:"arrangement_completion",
vaseUsedForRecommendation:false,
styleKey:geometryKey || styleKey || "ai_selection",
styleFamilyKey:styleKey || "ai_selection",
geometryKey:geometryKey || "",
styleLabel:getSelectedArrangementStyle(),
selectedTemplateId:configState.selectedCompositionTemplateId || "",
selectedTemplateName:(configState.compositionRecommendations.find(function(item){ return String(item.id) === String(configState.selectedCompositionTemplateId); }) || {}).name || "",
compositionCandidates:configState.compositionRecommendations.slice(0,3).map(function(item){ return {id:item.id,name:item.name}; }),
compositionScore:analysis.score,
styleCompatibilityScore:compatibility.score,
styleCompatibilityStatus:compatibility.status,
isCompositionComplete:Boolean(analysis.isComplete),
missingRoles:analysis.missingRoles.slice(),
roleSummary:Object.assign({}, analysis.roles),
totalPhysicalStems:analysis.totalStems,
familyCount:analysis.familyCount,
target:selectedTarget,
products:products
};
}

function roleGapScore(analysis, candidateRoles){
const roles = analysis.roles || analysis;
let best = 0;
(candidateRoles || []).forEach(function(candidateRole){
let score = 0;
if(candidateRole === "focal" && roles.focal <= 0 && roles.secondary < 2) score = 72;
else if(candidateRole === "secondary" && roles.secondary <= 0) score = roles.focal > 0 ? 42 : 30;
else if(candidateRole === "line" && roles.line <= 0) score = 48;
else if(candidateRole === "filler" && roles.filler <= 0) score = 40;
else if(candidateRole === "greenery" && roles.greenery <= 0) score = analysis.totalStems >= 5 ? 24 : 14;
if(score > best) best = score;
});
return best;
}
function selectedFlowerTotalCount(selectedObjects){
return (selectedObjects || []).reduce(function(total, flower){
return total + Math.max(1, Number(flower && flower.selectedCount || 1));
}, 0);
}
function flowerProfileStatus(flower){
return normalizeRecommendationToken(flower && (flower.profileStatus || flower.aiProfileStatus || ""));
}
function isFlowerUnavailableForRecommendation(flower){
if(!flower) return true;
if(!flower.imageUrl) return true;
if(!flower.id && !flower.name) return true;
if(flowerProfileStatus(flower) === "blocked") return true;
if(flower.availableForSale === false || flower.active === false) return true;
/* stockQuantity=0 tek başına ürünü gizlemez; Shopify satış uygunluğu esas alınır. */
return false;
}
function recommendationRoleQuotas(analysis){
if(analysis.isComplete) return {overall:0, focal:0, secondary:0, greenery:0, filler:0, line:0, support:0};
if(analysis.productCount <= 1) return {overall:3, focal:1, secondary:1, greenery:1, filler:1, line:1, support:1};
if(analysis.productCount <= 3) return {overall:2, focal:1, secondary:1, greenery:1, filler:1, line:1, support:1};
return {overall:1, focal:1, secondary:1, greenery:1, filler:1, line:1, support:1};
}
function canRecommendRole(candidateRole, analysis, direct){
if(direct) return true;
const roles = analysis.roles;
if(candidateRole === "focal" && (roles.focal > 0 || analysis.productCount >= 3)) return false;
if(candidateRole === "greenery" && roles.greenery >= 3) return false;
if(candidateRole === "filler" && roles.filler >= 4) return false;
if(candidateRole === "line" && roles.line >= 4) return false;
return true;
}
function applyRecommendationRoleQuotas(scored, quotas){
const counts = {focal:0, secondary:0, greenery:0, filler:0, line:0, support:0};
const picked = [];
const families = new Set();
for(let i = 0; i < scored.length; i += 1){
const item = scored[i];
const role = item.meta && item.meta.role || "support";
const family = normalizeRecommendationToken(item.flower && (item.flower.family || item.flower.aiFamily || item.flower.name || ""));
const allowed = Number(quotas[role] ?? quotas.support ?? 0);
if(allowed <= 0 || counts[role] >= allowed) continue;
if(family && families.has(family) && picked.length < Math.max(1, Number(quotas.overall || 1) - 1)) continue;
picked.push(item);
counts[role] += 1;
if(family) families.add(family);
if(picked.length >= Number(quotas.overall || 3)) break;
}
return picked;
}
function recommendationConflictPenalty(candidate, selectedObjects){
const candidateTags = new Set(getFlowerRecommendationTags(candidate));
const candidateConflicts = recommendationArray(candidate && (candidate.conflictTags || candidate.aiConflictTags));
let conflict = false;
(selectedObjects || []).forEach(function(selected){
if(conflict) return;
const selectedTags = new Set(getFlowerRecommendationTags(selected));
const selectedConflicts = recommendationArray(selected && (selected.conflictTags || selected.aiConflictTags));
if(candidateConflicts.some(function(tag){ return selectedTags.has(tag); })) conflict = true;
if(selectedConflicts.some(function(tag){ return candidateTags.has(tag); })) conflict = true;
});
return conflict ? -110 : 0;
}
function recommendedQuantityForFlower(flower, analysis){
const min = Math.max(1, Math.round(numericAiField(flower, ["minQuantity","aiMinQuantity"], 1)));
const maxRaw = Math.round(numericAiField(flower, ["maxQuantity","aiMaxQuantity"], 0));
const max = Math.max(min, maxRaw || 6);
let value = Math.round(numericAiField(flower, ["defaultQuantity","aiDefaultQuantity"], 0));
const role = flowerRoleGroup(flower);
if(!value){
if(role === "focal") value = 1;
else if(role === "secondary" || role === "line") value = 2;
else if(role === "filler" || role === "greenery") value = 2;
else value = 1;
}
const styleKey = getSelectedStyleProfileKey();
if(styleKey === "modern_design" && (role === "filler" || role === "greenery")) value = Math.min(value, 1);
if(analysis && analysis.totalStems >= 10) value = Math.min(value, Math.max(1, min));
const stock = Number(flower && flower.stockQuantity);
if(Number.isFinite(stock) && stock > 0) value = Math.min(value, stock);
return Math.max(min, Math.min(max, value));
}
function recommendationReasonForFlower(flower, scoreMeta){
if(scoreMeta){
const parts = [];
if(scoreMeta.colorScore >= 24) parts.push("Renk paletinizle güçlü uyum sağlar");
else if(scoreMeta.colorScore >= 16) parts.push("Renk paletinizi destekler");
if(scoreMeta.roleGap){
if(scoreMeta.role === "greenery") parts.push("doğal geçiş ihtiyacını tamamlar");
else if(scoreMeta.role === "filler") parts.push("eksik doku ve bağlantıyı tamamlar");
else if(scoreMeta.role === "line") parts.push("yükseklik ve hareket kazandırır");
else if(scoreMeta.role === "focal") parts.push("aranjmana gerekli ana odağı ekler");
else if(scoreMeta.role === "secondary") parts.push("ana çiçeği dengeli biçimde destekler");
else parts.push("form dengesini destekler");
}
if(scoreMeta.styleScore >= 18) parts.push("seçilen tarza uygundur");
if(scoreMeta.direct) parts.push("bu seçimle özel eşleşir");
if(parts.length) return parts.join(", ") + ".";
}
if(flower && (flower.recommendationNote || flower.aiRecommendationNote)) return flower.recommendationNote || flower.aiRecommendationNote;
const kind = getConfigFlowerKindLabel(flower).toLocaleLowerCase("tr-TR");
if(kind.indexOf("yeşillik") !== -1 || kind.indexOf("yesillik") !== -1) return "Doğal geçiş ve denge sağlar.";
if(kind.indexOf("doku") !== -1) return "Doku ve form dengesini destekler.";
return "Renk ve form açısından seçiminizi destekler.";
}
function pickDiverseResultRecommendations(sorted, maxCount){
const target = Math.max(1, Number(maxCount || 4));
const picked = [];
const roleCounts = {focal:0, greenery:0, filler:0, line:0, support:0};

(sorted || []).forEach(function(item){
if(picked.length >= target) return;
const role = item && item.meta && item.meta.role || "support";
if(item.score < 26) return;
if(role !== "support" && roleCounts[role] >= 1) return;
picked.push(item);
roleCounts[role] += 1;
});

if(picked.length < Math.min(target, 3)){
(sorted || []).forEach(function(item){
if(picked.length >= target) return;
if(item.score < 20) return;
if(picked.some(function(existing){ return String(existing.flower.id) === String(item.flower.id); })) return;
picked.push(item);
});
}
return picked;
}

function getStarterConfigFlowers(limit){
const max = Math.max(1, Number(limit || 4));
return (configState.flowers || [])
.filter(function(flower){ return !isFlowerUnavailableForRecommendation(flower); })
.map(function(flower){
const roles = flowerRoleGroups(flower);
let score = Math.min(Number(flower.recommendationPriority || flower.aiRecommendationPriority || 0) || 0, 20);
if(roles.indexOf("focal") !== -1) score += 55;
else if(roles.indexOf("secondary") !== -1) score += 38;
else if(roles.indexOf("line") !== -1) score += 24;
else score -= 10;
const weight = normalizeRecommendationToken(flower.visualWeight || flower.aiVisualWeight || "");
if(weight === "large" || weight === "heavy") score += 8;
return {flower:flower,score:score,meta:{role:flowerRoleGroup(flower),starter:true,suggestedQuantity:recommendedQuantityForFlower(flower, null),colorScore:0,styleScore:0}};
})
.filter(function(item){ return item.score > 0; })
.sort(function(a,b){
if(b.score !== a.score) return b.score - a.score;
return String(a.flower.name || "").localeCompare(String(b.flower.name || ""), "tr");
})
.slice(0,max);
}
function getRecommendedConfigFlowers(limit, mode){
const recommendationMode = mode === "result" ? "result" : mode === "style" ? "style" : "card";
const selectedObjects = selectedConfigFlowerObjects();
if(!selectedObjects.length) return recommendationMode === "card" ? getStarterConfigFlowers(limit || 4) : [];
const analysis = analyzeArrangementCompletion(selectedObjects);
const styleKey = getSelectedStyleProfileKey();
const styleCompatibility = analyzeStyleCompatibility(selectedObjects, styleKey);
if(recommendationMode === "card" && analysis.isComplete) return [];
if(recommendationMode === "result" && analysis.isComplete) return [];
if(recommendationMode === "style" && analysis.isComplete && styleCompatibility.score !== null && styleCompatibility.score >= 78) return [];
const selectedIds = new Set(selectedConfigFlowers().map(function(item){ return String(item.id); }));
const selectedFamilies = selectedFlowerFamilySet(selectedObjects);
const selectedForms = selectedFlowerFormSet(selectedObjects);
const wanted = new Set();
const directIds = new Set();
const selectedColorTokens = uniqueRecommendationTokens([].concat.apply([], selectedObjects.map(getFlowerColorTokens)));
selectedObjects.forEach(function(flower){
getFlowerWantedRecommendationTags(flower).forEach(function(token){ wanted.add(token); });
getFlowerDirectRecommendationIds(flower).forEach(function(token){
if(token) directIds.add(String(token));
const normalized = normalizeRecommendationToken(token);
if(normalized) directIds.add(normalized);
});
});
const scored = [];
(configState.flowers || []).forEach(function(flower){
if(!flower || selectedIds.has(String(flower.id)) || isFlowerUnavailableForRecommendation(flower)) return;
const tags = getFlowerRecommendationTags(flower);
const identity = getFlowerIdentityTokens(flower);
const candidateRoles = flowerRoleGroups(flower);
const candidateRole = candidateRoles[0] || "support";
let score = Math.min(Number(flower.recommendationPriority || flower.aiRecommendationPriority || 0) || 0, 18);
let overlap = 0;
let direct = false;
tags.forEach(function(token){ if(wanted.has(token)) overlap += 1; });
score += Math.min(overlap * 7, 28);
if(identity.some(function(token){ return directIds.has(String(token)) || directIds.has(normalizeRecommendationToken(token)); })){
score += 55;
direct = true;
}
if(!canRecommendRole(candidateRole, analysis, direct)) return;
const gap = roleGapScore(analysis, candidateRoles);
if(gap) score += gap;
const colorInfo = colorHarmonyScore(selectedColorTokens, getFlowerColorTokens(flower));
score += Math.min(colorInfo.score || 0, 32);
const family = normalizeRecommendationToken(flower.family || flower.aiFamily || flower.name || "");
if(family && selectedFamilies.has(family)) score -= direct ? 4 : 24;
else if(family) score += 14;
const forms = recommendationArray(flower.formType || flower.aiFormType || "");
if(forms.some(function(form){ return !selectedForms.has(form); })) score += 10;
const styleScore = styleKey ? styleAffinityForFlower(flower, styleKey) : 0;
if(styleKey) score += recommendationMode === "style" ? Math.round(styleScore * 1.15) : Math.round(styleScore * 0.65);
const movement = normalizeAiLevel(flower.movementLevel || flower.aiMovementLevel);
const texture = normalizeAiLevel(flower.textureLevel || flower.aiTextureLevel);
if(analysis.roles.line <= 0 && movement >= 2) score += 12;
if(analysis.roles.filler <= 0 && texture >= 2 && candidateRoles.indexOf("filler") !== -1) score += 10;
if(analysis.roles[candidateRole] > 0 && !gap && !direct) score -= 18;
score += recommendationConflictPenalty(flower, selectedObjects);
if(recommendationMode === "style" && styleScore <= 0 && !gap) score -= 18;
if(score > 8){
scored.push({
flower:flower,
score:score,
meta:{
direct:direct,
roleGap:Boolean(gap),
overlap:overlap,
role:candidateRole,
colorScore:colorInfo.score || 0,
colorLabel:colorInfo.label || "",
styleScore:styleScore,
suggestedQuantity:recommendedQuantityForFlower(flower, analysis)
}
});
}
});
scored.sort(function(a,b){
if(b.score !== a.score) return b.score - a.score;
return String(a.flower.name || "").localeCompare(String(b.flower.name || ""), "tr");
});
let maxCount = Math.max(1, Number(limit || 3));
if(recommendationMode === "card") maxCount = Math.min(maxCount, Number(recommendationRoleQuotas(analysis).overall || 0));
if(recommendationMode === "result" || recommendationMode === "style") maxCount = Math.min(maxCount, 2);
if(maxCount <= 0) return [];
const quotas = recommendationRoleQuotas(Object.assign({}, analysis, {isComplete:false}));
quotas.overall = maxCount;
return applyRecommendationRoleQuotas(scored, quotas).slice(0, maxCount);
}

function getResultRecommendationLimit(){
const analysis = analyzeArrangementCompletion(selectedConfigFlowerObjects());
if(analysis.isComplete) return 0;
if(analysis.productCount <= 1) return 3;
return 2;
}
function resultRecommendationFallbackScore(flower, selectedObjects){
const analysis = analyzeArrangementCompletion(selectedObjects || []);
const colorInfo = colorHarmonyScore(
uniqueRecommendationTokens([].concat.apply([], (selectedObjects || []).map(getFlowerColorTokens))),
getFlowerColorTokens(flower)
);
const roles = flowerRoleGroups(flower);
return {
score: roleGapScore(analysis, roles) + Math.min(colorInfo.score || 0, 30),
meta:{role:roles[0] || "support",roleGap:true,colorScore:colorInfo.score || 0,colorLabel:colorInfo.label || "",suggestedQuantity:recommendedQuantityForFlower(flower, analysis),fallback:true}
};
}
function forceResultRecommendations(limit){
const analysis = analyzeArrangementCompletion(selectedConfigFlowerObjects());
if(analysis.isComplete) return [];
return getRecommendedConfigFlowers(limit || getResultRecommendationLimit(), "result");
}

function selectedRecommendationColorText(selectedObjects){
const colors = uniqueRecommendationTokens([].concat.apply([], selectedObjects.map(getFlowerColorTokens))).slice(0,4);
return colors.length ? colors.map(colorTokenLabel).join(" + ") : "seçili çiçeğin renk tonu";
}
function renderFlowerRecommendationGuideHtml(){
const selectedObjects = selectedConfigFlowerObjects();
if(!selectedObjects.length){
const starterSlider = renderRecommendationSliderHtml("flower");
return `<section class="ai-recommendation-box ai-recommendation-guide"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Başlangıç</span><div class="ai-recommendation-title">Ana çiçeğinizi seçin</div></div><p class="ai-recommendation-hint">Aşağıdaki ürünlerden biriyle başlayın. Her seçimden sonra sistem aranjmanda eksik kalan rolü yeniden hesaplar.</p></div></section>${starterSlider}`;
}
const analysis = analyzeArrangementCompletion(selectedObjects);
if(analysis.isComplete){
return `<section class="ai-recommendation-box ai-recommendation-guide is-complete"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Aranjman dengesi</span><div class="ai-recommendation-title">Seçiminiz tasarıma geçmeye hazır</div></div><p class="ai-recommendation-hint">Kompozisyon puanı ${analysis.score}/100. ${analysis.familyCount} farklı çiçek ailesi ve ${analysis.totalStems} fiziksel dal seçildi. Tarz aşamasında seçim yeniden değerlendirilecek.</p></div></section>`;
}
const missing = analysis.missingRoles.map(roleGroupLabel).join(" · ") || "Tamamlayıcı form";
const slider = renderRecommendationSliderHtml("flower");
return `<section class="ai-recommendation-box ai-recommendation-guide"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Aranjmanı tamamla</span><div class="ai-recommendation-title">Sıradaki en doğru dokunuş</div></div><p class="ai-recommendation-hint">Kompozisyon puanı ${analysis.score}/100 · Eksik: ${escapeHtml(missing)}. Öneriler bütün seçiminize göre hesaplandı.</p></div></section>${slider}`;
}
function renderRecommendationSliderHtml(context){
const mode = context === "style" ? "style" : context === "result" ? "result" : "card";
const limit = mode === "card" ? 4 : 2;
const items = getRecommendedConfigFlowers(limit, mode);
if(!items.length) return "";
const title = mode === "style" ? "Tarza uygun dokunuşlar" : mode === "result" ? "Eksik kompozisyon dokunuşları" : "Önerilen çiçekler";
const hint = mode === "style"
? "Seçtiğiniz tarzın form, hareket ve yoğunluk diline göre sıralandı."
: mode === "result"
? "Yalnızca kompozisyonda eksik bir rol kaldığında gösterilir."
: "Eksik rol, renk paleti, ürün formu ve önerilen adet birlikte değerlendirildi.";
const sliderId = "recommend-track-" + escapeHtml(context || "flower");
return `<section class="ai-recommendation-box ai-recommendation-slider ai-recommendation-slider-clean" data-recommendation-context="${escapeHtml(context || "flower")}">
<div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">Önerilenler</span><div class="ai-recommendation-title">${escapeHtml(title)}</div></div><p class="ai-recommendation-hint">${escapeHtml(hint)}</p></div>
<div class="ai-recommendation-slider-shell">
<button type="button" class="ai-recommendation-nav ai-recommendation-nav-prev" data-recommend-scroll="prev" data-recommend-target="${sliderId}" aria-label="Önceki öneriler">‹</button>
<div class="ai-recommendation-track" id="${sliderId}">${items.map(function(item, index){
const flower = item.flower;
const price = flower.priceLabel || (flower.priceAmount ? formatTry(flower.priceAmount) : "Fiyat yok");
const note = recommendationReasonForFlower(flower, item.meta);
const quantity = Math.max(1, Number(item.meta && item.meta.suggestedQuantity || 1));
return `<article class="ai-recommendation-card ai-recommendation-card-clean">
<div class="ai-recommendation-rank">${index + 1}</div>
<div class="ai-recommendation-card-image"><img src="${escapeHtml(flower.imageUrl)}" alt="${escapeHtml(flower.name)}" loading="lazy" decoding="async"></div>
<div class="ai-recommendation-card-body">
<span class="ai-recommendation-kind">${escapeHtml(getConfigFlowerKindLabel(flower))}</span>
<div class="ai-recommendation-name">${escapeHtml(flower.name)}</div>
<div class="ai-recommendation-note">${escapeHtml(note)}</div>
<div class="ai-recommendation-price">${escapeHtml(price)} / adet</div>
<button type="button" class="ai-recommendation-add" data-recommend-add="${escapeHtml(flower.id)}" data-recommend-quantity="${quantity}" data-recommend-context="${escapeHtml(context || "flower")}">${quantity} adet ekle</button>
</div>
</article>`;
}).join("")}</div>
<button type="button" class="ai-recommendation-nav ai-recommendation-nav-next" data-recommend-scroll="next" data-recommend-target="${sliderId}" aria-label="Sonraki öneriler">›</button>
</div>
</section>`;
}
function ensureStyleAdviceBox(){
let box = document.getElementById("configStyleAdvice");
if(box) return box;
box = document.createElement("div");
box.id = "configStyleAdvice";
box.className = "ai-composition-picker-mount";

/* V117: The current Shopify section does not always contain the legacy
   #styleAreaSection wrapper. Mount the composition picker using the live
   style-card / note / footer structure instead of silently failing. */
const noteContainer = configEls.note
  ? (configEls.note.closest(".ai-config-field, .ai-field, .field, label") || configEls.note.parentElement)
  : null;
if(noteContainer && noteContainer.parentNode){
  noteContainer.parentNode.insertBefore(box, noteContainer);
  return box;
}

const firstStyleCard = document.querySelector("[data-config-style-choice]");
const styleGrid = firstStyleCard && firstStyleCard.parentElement;
if(styleGrid && styleGrid.parentNode){
  styleGrid.parentNode.insertBefore(box, styleGrid.nextSibling);
  return box;
}

if(styleAreaSection){
  styleAreaSection.appendChild(box);
  return box;
}

if(configEls.footer && configEls.footer.parentNode){
  configEls.footer.parentNode.insertBefore(box, configEls.footer);
  return box;
}

if(configEls.root){
  configEls.root.appendChild(box);
  return box;
}
return null;
}
function renderStyleAdviceHtml(){
const selectedObjects = selectedConfigFlowerObjects();
const styleKey = getSelectedStyleProfileKey();
if(!styleKey) return `<section class="ai-recommendation-box ai-recommendation-guide"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">AI Seçimi</span><div class="ai-recommendation-title">Floever en uygun formu belirlesin</div></div><p class="ai-recommendation-hint">İlk tasarım hazırlanacak; ardından bu tasarıma uygun üç kompozisyon alternatifi sonuç ekranında gösterilecek.</p></div></section>`;
const compatibility = analyzeStyleCompatibility(selectedObjects, styleKey);
const label = getSelectedArrangementStyle() || ARRANGEMENT_STYLE_PROFILES[styleKey].label;
const slider = renderRecommendationSliderHtml("style");
return `<section class="ai-recommendation-box ai-recommendation-guide ${compatibility.status === "strong" ? "is-complete" : ""}"><div class="ai-recommendation-head ai-recommendation-head-clean"><div><span class="ai-recommendation-kicker">${escapeHtml(label)}</span><div class="ai-recommendation-title">Seçtiğiniz tarz</div></div><p class="ai-recommendation-hint">${escapeHtml(compatibility.message)} İlk tasarımdan sonra üç kompozisyon alternatifi sunulacak.</p></div></section>${slider}`;
}
function ensureImmediateCompositionChoice(){
if(!selectedConfigFlowers().length) return;
if(configState.compositionRecommendationsLoading) return;
if(!configState.compositionRecommendations.length){
  configState.compositionRecommendations = fallbackCompositionRecommendations().map(normalizeCompositionRecommendation).slice(0,3);
}
if(!configState.selectedCompositionTemplateId && configState.compositionRecommendations[0]){
  configState.selectedCompositionTemplateId = String(configState.compositionRecommendations[0].id || "");
}
}

function refreshStyleAdvice(){
const box = document.getElementById("configStyleAdvice");
if(box){
box.innerHTML = floeverAiI18n.html("");
box.hidden = true;
}
}
function ensureFlowerRecommendationsBox(){
let box = document.getElementById("configFlowerRecommendations");
if(!box && configEls.flowerGrid && configEls.flowerGrid.parentNode){
box = document.createElement("div");
box.id = "configFlowerRecommendations";
configEls.flowerGrid.parentNode.insertBefore(box, configEls.flowerGrid);
}
return box;
}
function updateRecommendationDependentResultUi(){
const editList = document.getElementById("configResultEditList");
if(editList) editList.innerHTML = floeverAiI18n.html(renderResultEditList());
updateConfiguredResultPricing();
refreshResultRecommendations();
}
function bindRecommendationAddButtons(root){
Array.prototype.forEach.call((root || document).querySelectorAll("[data-recommend-add]"), function(btn){
if(btn.dataset.recommendBound === "true") return;
btn.dataset.recommendBound = "true";
btn.addEventListener("click", function(){
const id = String(btn.getAttribute("data-recommend-add") || "");
const context = String(btn.getAttribute("data-recommend-context") || "");
const flower = getConfigFlowerById(id);
if(!id || !flower) return;
const addQuantity = Math.max(1, Number(btn.getAttribute("data-recommend-quantity") || 1));
const current = Number(configState.selectedFlowers.get(id) || 0);
const maxProfile = Math.max(1, numericAiField(flower, ["maxQuantity","aiMaxQuantity"], 99) || 99);
const stock = Number(flower.stockQuantity);
const stockLimit = Number.isFinite(stock) && stock > 0 ? stock : 99;
const next = Math.min(99, maxProfile, stockLimit, current + addQuantity);
configState.selectedFlowers.set(id, Math.max(1, next));
invalidateCompositionRecommendations();
renderConfigFlowers();
renderConfigSummary();
updateConfiguredResultPricing();
refreshStyleAdvice();
if(context === "result"){
showConfiguredResultPanel("edit");
updateRecommendationDependentResultUi();
}
scheduleConfiguratorStateSave();
});
});
}
function bindRecommendationSliders(root){
Array.prototype.forEach.call((root || document).querySelectorAll('[data-recommend-scroll]'), function(btn){
if(btn.dataset.sliderBound === 'true') return;
btn.dataset.sliderBound = 'true';
btn.addEventListener('click', function(){
const targetId = btn.getAttribute('data-recommend-target');
const track = targetId ? document.getElementById(targetId) : null;
if(!track) return;
const direction = btn.getAttribute('data-recommend-scroll') === 'prev' ? -1 : 1;
const amount = Math.max(220, Math.floor(track.clientWidth * 0.8));
track.scrollBy({ left: direction * amount, behavior: 'smooth' });
});
});
}

function refreshFlowerRecommendations(){
const box = ensureFlowerRecommendationsBox();
if(box){
const html = renderFlowerRecommendationGuideHtml();
box.innerHTML = floeverAiI18n.html(html);
box.hidden = !html;
if(html){ bindRecommendationAddButtons(box); bindRecommendationSliders(box); }
}
refreshStyleAdvice();
}
function refreshResultRecommendations(){
["configResultPostDesignRecommendations","configResultRecommendations"].forEach(function(id){
const box = document.getElementById(id);
if(!box) return;
const html = renderRecommendationSliderHtml("result");
box.innerHTML = floeverAiI18n.html(html);
box.hidden = !html;
if(html){ bindRecommendationAddButtons(box); bindRecommendationSliders(box); }
});
}

function buildVisibleFlowerRecommendationFallback(visibleFlowers, selectedObjects, limit){
const max = Math.max(1, Number(limit || 1));
const selectedIds = new Set(selectedConfigFlowers().map(function(item){ return String(item.id); }));
const roles = selectedRoleSummary(selectedObjects || []);
const selectedTotal = selectedFlowerTotalCount(selectedObjects || []);
if(!selectedObjects || !selectedObjects.length || selectedObjects.length >= 6) return [];

function fallbackScore(flower){
const role = flowerRoleGroup(flower);
let score = 0;

/* Odak çiçekleri çok kontrollü tut. */
if(role === "focal"){
if(roles.focal > 0 || selectedTotal >= 2) return -999;
score += 8;
}

if(role === "greenery"){
score += roles.greenery ? 4 : 70;
}
else if(role === "filler"){
score += roles.filler ? 8 : 64;
}
else if(role === "line"){
score += roles.line ? 6 : 52;
}
else if(role === "support"){
score += 24;
}

/* Seçimde odak varsa tamamlayıcılar daha anlamlı. */
if(roles.focal && (role === "greenery" || role === "filler" || role === "line")) score += 14;

/* Aynı rol çok tekrar etmesin. */
if(selectedTotal >= 2 && roles[role] > 0 && role !== "support") score -= 32;

/* Renk uyumu varsa ekstra puan. */
const selectedColorTokens = uniqueRecommendationTokens([].concat.apply([], (selectedObjects || []).map(getFlowerColorTokens)));
const colorInfo = colorHarmonyScore(selectedColorTokens, getFlowerColorTokens(flower));
score += Math.min(colorInfo.score || 0, 20);

/* Admin panel önceliği hâlâ destekleyici olsun, ama ezmesin. */
score += Math.min(Number(flower.recommendationPriority || flower.aiRecommendationPriority || 0) || 0, 20);

return score;
}

return (visibleFlowers || [])
.filter(function(flower){
if(!flower || selectedIds.has(String(flower.id))) return false;
if(isFlowerUnavailableForRecommendation(flower)) return false;
return true;
})
.map(function(flower){
const role = flowerRoleGroup(flower);
return {
flower: flower,
score: fallbackScore(flower),
meta: {
direct:false,
roleGap:true,
overlap:0,
role:role,
colorScore:0,
colorLabel:"",
styleScore:0,
fallback:true
}
};
})
.filter(function(item){ return item.score > 0; })
.sort(function(a,b){
if(b.score !== a.score) return b.score - a.score;
return String(a.flower.name || "").localeCompare(String(b.flower.name || ""), "tr");
})
.slice(0, max);
}

function renderConfigFlowers(){
if(!configEls.flowerGrid) return;
const recommendationBox = ensureFlowerRecommendationsBox();
if(!configState.flowers.length){
if(recommendationBox){ recommendationBox.innerHTML = floeverAiI18n.html(""); recommendationBox.hidden = true; }
configEls.flowerGrid.innerHTML = floeverAiI18n.html("");
configEls.flowerGrid.classList.remove("is-single","is-duo");
if(configEls.flowerStatus){ configEls.flowerStatus.hidden = false; configEls.flowerStatus.textContent = floeverAiI18n.text("Henüz çiçek eklenmedi."); }
return;
}
const visibleFlowers = configState.flowers.filter(flowerMatchesFilters).slice().sort(function(a,b){ return String(a && a.name || "").localeCompare(String(b && b.name || ""), "tr", {sensitivity:"base", numeric:true}); });
if(configEls.flowerStatus) configEls.flowerStatus.textContent = floeverAiI18n.text("");
refreshFlowerRecommendations();
const selectedObjectsForCardRecommendations = selectedConfigFlowerObjects();
const cardArrangementAnalysis = analyzeArrangementCompletion(selectedObjectsForCardRecommendations);
const cardRecommendationLimit = cardArrangementAnalysis.productCount <= 1 ? 3 : cardArrangementAnalysis.productCount <= 3 ? 2 : 1;
let recommendedItemsForCards = selectedObjectsForCardRecommendations.length && !cardArrangementAnalysis.isComplete
? getRecommendedConfigFlowers(cardRecommendationLimit, "card")
: [];
const recommendedInfoMap = new Map(recommendedItemsForCards.map(function(item, index){ return [String(item.flower.id), { rank:index + 1, reason: recommendationReasonForFlower(item.flower, item.meta || {}) }]; }));
configEls.flowerGrid.classList.toggle("is-single", visibleFlowers.length === 1);
configEls.flowerGrid.classList.toggle("is-duo", visibleFlowers.length === 2);
if(!visibleFlowers.length){
configEls.flowerGrid.innerHTML = floeverAiI18n.html('<div class="ai-message">Bu filtrelere uygun çiçek bulunamadı.</div>');
return;
}
configEls.flowerGrid.innerHTML = floeverAiI18n.html(visibleFlowers.map(function(flower, index){
const qty = configState.selectedFlowers.get(String(flower.id)) || 0;
const selected = qty > 0;
const price = flower.priceLabel || (flower.priceAmount ? formatTry(flower.priceAmount) : "Fiyat yok");
const kind = getConfigFlowerKindLabel(flower);
const recommendationInfo = recommendedInfoMap.get(String(flower.id));
const recommendationBadge = (!selected && recommendationInfo) ? `<div class="ai-config-recommend-tab" title="${escapeHtml(recommendationInfo.reason || "Seçiminize göre önerildi")}">Uyumlu</div>` : "";
return `
<article class="ai-config-product-card ai-config-product-card-clean ${selected ? "is-selected" : ""} ${recommendationInfo && !selected ? "is-recommended" : ""}">
${recommendationBadge}
<button type="button" class="ai-config-product-select" data-config-flower-toggle="${escapeHtml(flower.id)}" aria-pressed="${selected ? "true" : "false"}">
<div class="ai-config-product-image"><img src="${escapeHtml(flower.imageUrl)}" alt="${escapeHtml(flower.name)}" loading="${index < 8 ? "eager" : "lazy"}" decoding="async"></div>
<div class="ai-config-product-body">
<div class="ai-config-product-kind">${escapeHtml(kind)}</div>
<div class="ai-config-product-title">${escapeHtml(flower.name)}</div>
<div class="ai-config-product-price">${escapeHtml(price)} <small>/ adet</small></div>
</div>
</button>
<div class="ai-config-qty-row ai-config-qty-clean">
<span>Adet</span>
<div class="ai-config-stepper">
<button type="button" data-config-flower-minus="${escapeHtml(flower.id)}" aria-label="Adet azalt">−</button>
<input type="number" min="0" max="99" value="${qty}" data-config-flower-qty="${escapeHtml(flower.id)}" inputmode="numeric">
<button type="button" data-config-flower-plus="${escapeHtml(flower.id)}" aria-label="Adet artır">+</button>
</div>
</div>
</article>`;
}).join(""));
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-toggle]"), function(btn){
btn.addEventListener("click", function(){
const id = String(btn.getAttribute("data-config-flower-toggle") || "");
const current = configState.selectedFlowers.get(id) || 0;
if(current > 0) configState.selectedFlowers.delete(id);
else configState.selectedFlowers.set(id, 1);
invalidateCompositionRecommendations();
renderConfigFlowers();
renderConfigSummary();
});
});
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-minus]"), function(btn){
btn.addEventListener("click", function(){
const id = String(btn.getAttribute("data-config-flower-minus") || "");
const current = Number(configState.selectedFlowers.get(id) || 0);
const next = Math.max(0, current - 1);
if(next > 0) configState.selectedFlowers.set(id, next);
else configState.selectedFlowers.delete(id);
invalidateCompositionRecommendations();
renderConfigFlowers();
renderConfigSummary();
updateConfiguredResultPricing();
});
});
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-plus]"), function(btn){
btn.addEventListener("click", function(){
const id = String(btn.getAttribute("data-config-flower-plus") || "");
const current = Number(configState.selectedFlowers.get(id) || 0);
configState.selectedFlowers.set(id, Math.min(99, current + 1));
invalidateCompositionRecommendations();
renderConfigFlowers();
renderConfigSummary();
updateConfiguredResultPricing();
});
});
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-qty]"), function(input){
input.addEventListener("change", function(){
const id = String(input.getAttribute("data-config-flower-qty") || "");
const qty = Math.max(0, Math.min(99, Number(input.value || 0)));
if(qty > 0) configState.selectedFlowers.set(id, qty);
else configState.selectedFlowers.delete(id);
invalidateCompositionRecommendations();
renderConfigFlowers();
renderConfigSummary();
updateConfiguredResultPricing();
});
});
}
function buildConfigMiniSummaryHtml(context){
const vase = selectedConfigVase();
const vaseName = configState.vaseMode === "floever" && vase ? vase.name : "Kendi vazonuz";
const vasePriceValue = configState.vaseMode === "floever" && vase ? parseConfigMoney(vase.priceAmount || vase.priceLabel) : 0;
const vaseImage = getConfigVasePreviewImage();
const vaseThumbHtml = vaseImage ? `<img src="${escapeHtml(vaseImage)}" alt="${escapeHtml(vaseName)}">` : `<span aria-hidden="true">🏺</span>`;
const flowerItems = selectedConfigFlowers()
.map(function(item){
const flower = getConfigFlowerById(item.id);
if(!flower) return "";
const unit = parseConfigMoney(flower.priceAmount || flower.priceLabel);
return `<div class="ai-mini-summary-line"><span>${escapeHtml(flower.name)} × ${item.count}</span><strong>${formatTry(unit * item.count)}</strong></div>`;
})
.filter(Boolean)
.join("");
const total = calculateConfigTotal();
const flowerSubtotal = calculateConfigFlowerSubtotal();
const title = context === "style" ? "Seçilen ürünler" : "Seçilen vazo ve toplam";
const detailRows = context === "style"
? `${flowerItems || `<div class="ai-mini-summary-line"><span>Henüz çiçek seçilmedi</span><strong>—</strong></div>`}`
: `<div class="ai-mini-summary-line"><span>Çiçekler ara toplamı</span><strong>${formatTry(flowerSubtotal)}</strong></div>`;
return `
<div class="ai-mini-summary-card ai-mini-summary-card-with-image">
<div class="ai-mini-summary-layout">
<div class="ai-mini-vase-thumb">${vaseThumbHtml}</div>
<div class="ai-mini-summary-content">
<div class="ai-mini-summary-head"><span>${title}</span><strong>${formatTry(total)}</strong></div>
<div class="ai-mini-summary-line"><span>${escapeHtml(vaseName)}</span><strong>${configState.vaseMode === "floever" ? formatTry(vasePriceValue) : "—"}</strong></div>
${detailRows}
</div>
</div>
</div>`;
}
function renderStepMiniSummaries(){
if(configEls.stepSummary2) configEls.stepSummary2.innerHTML = floeverAiI18n.html(buildConfigMiniSummaryHtml("flowers"));
if(configEls.stepSummary3) configEls.stepSummary3.innerHTML = floeverAiI18n.html(buildConfigMiniSummaryHtml("style"));
}
function renderConfigSummary(){
renderStepMiniSummaries();
renderMobileStickyVase();
if(!configEls.summary) return;
const vase = selectedConfigVase();
const flowerRows = selectedConfigFlowers().map(function(item){
const flower = getConfigFlowerById(item.id);
if(!flower) return "";
const unit = parseConfigMoney(flower.priceAmount || flower.priceLabel);
return `
<div class="ai-review-line">
<span>${escapeHtml(flower.name)} <em>× ${item.count}</em></span>
<strong>${formatTry(unit * item.count)}</strong>
</div>`;
}).filter(Boolean).join("");
const vaseName = configState.vaseMode === "floever" && vase ? vase.name : "Kendi vazonuz";
const vasePrice = configState.vaseMode === "floever" && vase ? formatTry(parseConfigMoney(vase.priceAmount || vase.priceLabel)) : "Vazo fiyatı eklenmez";
const styleText = escapeHtml(getSelectedArrangementStyle());
configEls.summary.innerHTML = floeverAiI18n.html(`
<div class="ai-review-card">
<div class="ai-review-header">
<div>
<span class="ai-config-kicker">Seçim Özeti</span>
<h3>Aranjmanınız için seçilenler</h3>
</div>
<div class="ai-review-total">
<span>Tahmini toplam</span>
<strong>${formatTry(calculateConfigTotal())}</strong>
</div>
</div>
<div class="ai-review-grid">
<div class="ai-review-box ai-review-vase-box">
<div class="ai-review-vase-thumb">${getConfigVasePreviewImage() ? `<img src="${escapeHtml(getConfigVasePreviewImage())}" alt="${escapeHtml(vaseName)}">` : `<span aria-hidden="true">🏺</span>`}</div>
<div>
<span>Vazo</span>
<strong>${escapeHtml(vaseName)}</strong>
<em>${escapeHtml(vasePrice)}</em>
</div>
</div>
<div class="ai-review-box">
<span>Tarz</span>
<strong>${styleText}</strong>
<em>Ek not varsa tasarıma dahil edilir</em>
</div>
</div>
<div class="ai-review-lines">
<span>Çiçekler</span>
${flowerRows || '<div class="ai-review-line"><span>Henüz çiçek seçilmedi.</span><strong>—</strong></div>'}
</div>
</div>`);
scheduleConfiguratorStateSave();
}
const CONFIG_LIBRARY_CACHE_TTL = 6 * 60 * 60 * 1000;
const CONFIG_LIBRARY_COMBINED_CACHE_KEY = "floeverAiConfiguratorLibraryV54";
const CONFIG_LIBRARY_OLD_VASE_CACHE_KEY = "floeverAiVasesV54";
const CONFIG_LIBRARY_OLD_FLOWER_CACHE_KEY = "floeverAiFlowersV54";

function getConfigLibraryCacheStorage(){
try{
if(window.localStorage) return window.localStorage;
}catch(error){}
try{
if(window.sessionStorage) return window.sessionStorage;
}catch(error){}
return null;
}
function readConfigLibraryCache(key){
try{
const storage = getConfigLibraryCacheStorage();
if(!storage) return null;
const raw = storage.getItem(key);
if(!raw) return null;
const parsed = JSON.parse(raw);
if(!parsed || !parsed.time || Date.now() - parsed.time > CONFIG_LIBRARY_CACHE_TTL) return null;
return parsed.data || null;
}catch(e){ return null; }
}
function writeConfigLibraryCache(key, data){
try{
const storage = getConfigLibraryCacheStorage();
if(storage) storage.setItem(key, JSON.stringify({time:Date.now(), data:data}));
}catch(e){}
}
function clearConfigLibraryCache(){
try{
const storage = getConfigLibraryCacheStorage();
if(!storage) return;
[
CONFIG_LIBRARY_COMBINED_CACHE_KEY,
CONFIG_LIBRARY_OLD_VASE_CACHE_KEY,
CONFIG_LIBRARY_OLD_FLOWER_CACHE_KEY
].forEach(function(key){ storage.removeItem(key); });
}catch(error){}
}
async function fetchConfigLibraryJson(url, timeoutMs){
const response = await fetchWithTimeout(url, {
method:"GET",
cache:"no-store",
keepalive:false,
headers:{Accept:"application/json"}
}, timeoutMs || 18000);
const data = await readJsonResponse(response) || {};
if(!response.ok) throw new Error(data.error || data.message || "Ürün kütüphanesi yüklenemedi.");
return data;
}
async function loadConfigLibraryPart(part){
const root = String(API_BASE_URL).replace(/\/+$/, "");
const isVase = part === "vase";
const url = root + (isVase ? "/api/vase-library" : "/api/flower-library");
const data = await fetchConfigLibraryJson(url, 18000);
if(isVase){
configState.vases = Array.isArray(data.vases) ? data.vases : [];
writeConfigLibraryCache(CONFIG_LIBRARY_OLD_VASE_CACHE_KEY, {vases:configState.vases});
renderConfigVases();
}else{
configState.flowers = Array.isArray(data.flowers) ? data.flowers : [];
writeConfigLibraryCache(CONFIG_LIBRARY_OLD_FLOWER_CACHE_KEY, {flowers:configState.flowers});
populateFlowerFilters();
renderConfigFlowers();
}
renderConfigSummary();
return data;
}
async function fetchCombinedConfiguratorLibrary(){
const root = String(API_BASE_URL).replace(/\/+$/, "");
try{
const combined = await fetchConfigLibraryJson(root + "/api/configurator-library", 18000);
if(Array.isArray(combined.vases) || Array.isArray(combined.flowers)){
return {
vases:Array.isArray(combined.vases) ? combined.vases : [],
flowers:Array.isArray(combined.flowers) ? combined.flowers : [],
source:combined.source || "combined"
};
}
}catch(error){
// Yeni endpoint yoksa veya geçici hata verirse eski iki endpoint ile devam ederiz.
}
const vasePromise = fetchConfigLibraryJson(root + "/api/vase-library", 18000);
const flowerPromise = fetchConfigLibraryJson(root + "/api/flower-library", 18000);
const results = await Promise.allSettled([vasePromise, flowerPromise]);
const vaseData = results[0].status === "fulfilled" ? results[0].value : null;
const flowerData = results[1].status === "fulfilled" ? results[1].value : null;
if(!vaseData && !flowerData){
const firstError = results.find(function(item){ return item.status === "rejected"; });
throw firstError && firstError.reason ? firstError.reason : new Error("Ürün kütüphanesi yüklenemedi.");
}
return {
vases:vaseData && Array.isArray(vaseData.vases) ? vaseData.vases : [],
flowers:flowerData && Array.isArray(flowerData.flowers) ? flowerData.flowers : [],
source:"split"
};
}
async function loadConfiguratorLibraries(){
const cachedCombined = readConfigLibraryCache(CONFIG_LIBRARY_COMBINED_CACHE_KEY);
const cachedVases = cachedCombined && Array.isArray(cachedCombined.vases)
? {vases:cachedCombined.vases}
: readConfigLibraryCache(CONFIG_LIBRARY_OLD_VASE_CACHE_KEY);
const cachedFlowers = cachedCombined && Array.isArray(cachedCombined.flowers)
? {flowers:cachedCombined.flowers}
: readConfigLibraryCache(CONFIG_LIBRARY_OLD_FLOWER_CACHE_KEY);

if(cachedVases && Array.isArray(cachedVases.vases)){
configState.vases = cachedVases.vases;
renderConfigVases();
}else if(configEls.vaseStatus){
configEls.vaseStatus.hidden = false;
configEls.vaseStatus.textContent = floeverAiI18n.text("Vazolar yükleniyor…");
}

if(cachedFlowers && Array.isArray(cachedFlowers.flowers)){
configState.flowers = cachedFlowers.flowers;
populateFlowerFilters();
renderConfigFlowers();
}else if(configEls.flowerStatus){
configEls.flowerStatus.hidden = false;
configEls.flowerStatus.textContent = floeverAiI18n.text("Çiçekler yükleniyor…");
}

renderConfigSummary();

try{
const library = await fetchCombinedConfiguratorLibrary();

if(Array.isArray(library.vases)){
configState.vases = library.vases;
writeConfigLibraryCache(CONFIG_LIBRARY_OLD_VASE_CACHE_KEY, {vases:configState.vases});
renderConfigVases();
}

if(Array.isArray(library.flowers)){
configState.flowers = library.flowers;
writeConfigLibraryCache(CONFIG_LIBRARY_OLD_FLOWER_CACHE_KEY, {flowers:configState.flowers});
populateFlowerFilters();
renderConfigFlowers();
}

writeConfigLibraryCache(CONFIG_LIBRARY_COMBINED_CACHE_KEY, {
vases:configState.vases,
flowers:configState.flowers
});

renderConfigSummary();
}catch(error){
if(configEls.vaseStatus && !configState.vases.length){
configEls.vaseStatus.hidden = false;
configEls.vaseStatus.textContent = floeverAiI18n.text(error?.message || "Vazolar yüklenemedi.");
}
if(configEls.flowerStatus && !configState.flowers.length){
configEls.flowerStatus.hidden = false;
configEls.flowerStatus.textContent = floeverAiI18n.text(error?.message || "Çiçekler yüklenemedi.");
}
}
}
function renderGenerationLoadingCard(isFollowup){
showResultView();
const beautifying = Boolean(configState.beautifyMode);
const loadingFacts = [
  { text: "Floever kompozisyon motoru çiçeklerin rollerini, formlarını ve hareket yönlerini birlikte değerlendiriyor." },
  { text: "Demet, buket ve spray ürünleri tek parça korunarak yalnızca bütün ürün birimi halinde yerleştiriliyor." },
  { text: "En uygun tasarım; odak, karşı denge, yükseklik ritmi, negatif alan ve vazo oranlarına göre seçiliyor." }
];
let loadingFactIndex = 0;
resultBox.innerHTML = floeverAiI18n.html(`<div class="ai-loading-card ai-loading-card-with-facts">
  <div class="ai-loading-title">${beautifying ? "Aranjmanınız Floever kompozisyonuyla güzelleştiriliyor…" : isFollowup ? "Yeni görünüm arka planda hazırlanıyor…" : "Aranjmanınız arka planda hazırlanıyor…"}</div>
  <div class="ai-loading-progress"><span></span></div>
  <div class="ai-loading-fact-rotator" aria-live="polite" aria-label="Kısa bekleme notu">
    <div class="ai-loading-fact-heading">${beautifying ? "En uygun kompozisyon hazırlanıyor" : "Bunları biliyor muydunuz?"}</div>
    <span data-loading-fact-text></span>
  </div>
  ${floeverWaitGameMarkup()}
</div>`);
const stopWaitGame = startFloeverWaitGame(resultBox.querySelector("[data-ai-wait-game]"));
const loadingFactText = resultBox.querySelector("[data-loading-fact-text]");
const loadingFactRotator = resultBox.querySelector(".ai-loading-fact-rotator");
function renderLoadingFact(animate){
  const fact = loadingFacts[loadingFactIndex % loadingFacts.length];
  if(!loadingFactText) return;
  if(animate && loadingFactRotator){
    loadingFactRotator.classList.add("is-changing");
    window.setTimeout(function(){ loadingFactText.textContent = floeverAiI18n.text(fact.text); loadingFactRotator.classList.remove("is-changing"); }, 220);
  }else{
    loadingFactText.textContent = floeverAiI18n.text(fact.text);
  }
}
renderLoadingFact(false);
const timer = window.setInterval(function(){ loadingFactIndex = (loadingFactIndex + 1) % loadingFacts.length; renderLoadingFact(true); }, 10000);
return function(){ window.clearInterval(timer); if(stopWaitGame) stopWaitGame(); };
}
function handleGenerateCompletedData(data, isFollowup){
const persisted = buildPersistedResultData(data);
const isBeautified = Boolean(data && data.beautify && data.beautify.used);
const isVaseChanged = Boolean(data && data.vaseChange && data.vaseChange.used);
const jobId = data.creditSystem && data.creditSystem.jobId ? String(data.creditSystem.jobId) : (isFollowup ? (configState.lastJobId || configState.originalJobId) : "");
if(!isBeautified && !isVaseChanged){
configState.originalResultData = persisted;
configState.originalJobId = jobId;
configState.beautifyMode = "";
configState.beautifyRecommendationIds = [];
}
configState.lastJobId = jobId;
configState.lastImage = data.image || "";
configState.step = 4;
configState.lastResultData = persisted;
configState.resultCurrentCompositionTemplateId = String(data && data.compositionPlan && data.compositionPlan.templateId || "");
configState.selectedCompositionTemplateId = configState.resultCurrentCompositionTemplateId;
configState.compositionRecommendations = [];
configState.compositionRecommendationKey = "";
configState.compositionRecommendationsError = "";
const revisionIteration = Math.max(0, Math.min(2, Number(data && data.revision && data.revision.iteration || data && data.vaseChange && data.vaseChange.iteration || data && data.beautify && data.beautify.iteration || 0)));
if(isBeautified){
configState.compositionChangesUsed = Math.max(1, revisionIteration || Math.min(2, Number(configState.compositionChangesUsed || 0) + 1));
configState.retryUsed = configState.compositionChangesUsed >= 2;
configState.beautifyMode = data.beautify.mode || configState.beautifyMode || "same_products";
configState.beautifyRecommendationIds = Array.isArray(data.beautify.recommendationIds) ? data.beautify.recommendationIds.map(String) : configState.beautifyRecommendationIds;
}else if(isVaseChanged){
configState.compositionChangesUsed = Math.max(1, revisionIteration || Math.min(2, Number(configState.compositionChangesUsed || 0) + 1));
configState.retryUsed = configState.compositionChangesUsed >= 2;
}else if(isFollowup || data.retry?.used){
configState.retryUsed = true;
}else{
configState.retryUsed = false;
configState.compositionChangesUsed = 0;
}
configState.backgroundJobStatus = "completed";
configState.beautifyGenerating = false;
configState.vaseChangeGenerating = false;
configState.activeShareCode = "";
configState.shareUnavailableItems = [];
configState.sharedPreviewOnly = false;
if(data.creditSystem && data.creditSystem.enabled && Number.isFinite(Number(data.creditSystem.creditBalance))){
creditState.balance = Number(data.creditSystem.creditBalance);
updateCreditUI();
}
scheduleConfiguratorStateSave();
renderConfiguredResult(data, jobId);
window.setTimeout(function(){ void loadPreviousDesigns(true); }, 500);
}
async function pollBackgroundDesignJob(jobId, isRetry){
const pollEpoch = configuratorResetEpoch;
let lastMessageTick = 0;
for(;;){
await waitMs(3500);
if(pollEpoch !== configuratorResetEpoch || String(configState.backgroundJobId || "") !== String(jobId || "")) return;
const response = await apiFetch("/api/background-design-jobs/" + encodeURIComponent(jobId), {method:"GET"});
const data = await readJsonResponse(response) || {};
if(!response.ok) throw new Error(data.error || "Arka plandaki tasarım durumuna ulaşılamadı.");
const job = data.job || {};
configState.backgroundJobStatus = job.status || "processing";
saveConfiguratorStateLocal();
if(job.status === "completed"){
if(pollEpoch !== configuratorResetEpoch || String(configState.backgroundJobId || "") !== String(jobId || "")) return;
if(!job.result) throw new Error("Tasarım tamamlandı ancak sonuç alınamadı.");
handleGenerateCompletedData(job.result, isRetry);
return;
}
if(job.status === "failed"){
clearConfiguratorBackgroundJob();
throw new Error(job.error || "Tasarım arka planda oluşturulamadı.");
}
lastMessageTick += 1;
if(lastMessageTick % 4 === 0){
setConfigStatus("Tasarımınız arka planda hazırlanıyor…", "");
}
}
}
async function resumeBackgroundDesignIfNeeded(){
if(!configState.backgroundJobId || configState.backgroundJobStatus !== "processing") return;
const isRetry = Boolean(configState.backgroundIsRetry);
let cleanupLoading = null;
try{
cleanupLoading = renderGenerationLoadingCard(isRetry);
setConfigStatus("Devam eden tasarımınız kontrol ediliyor…", "");
await pollBackgroundDesignJob(configState.backgroundJobId, isRetry);
}catch(error){
resultBox.innerHTML = floeverAiI18n.html('<div class="ai-message">' + escapeHtml(error?.message || "Devam eden tasarım alınamadı.") + '</div>');
setConfigStatus(error?.message || "Devam eden tasarım alınamadı.", "error");
}finally{
if(cleanupLoading) cleanupLoading();
}
}
async function generateConfiguredArrangement(options){
const opts = options || {};
const isRetry = Boolean(opts.retry === true);
const beautifyMode = ["same_products","floever_recommended"].indexOf(String(opts.beautifyMode || "")) !== -1 ? String(opts.beautifyMode) : "";
const isBeautify = Boolean(beautifyMode);
const isVaseChange = Boolean(opts.vaseChange === true);
const isFollowup = isRetry || isBeautify || isVaseChange;
const requestedCompositionTemplateId = (isBeautify || isVaseChange)
? String(opts.compositionTemplateId || configState.resultCurrentCompositionTemplateId || configState.selectedCompositionTemplateId || "")
: "";
const step1Error = validateConfigStep(1); if(step1Error){ setConfigStep(1); setConfigStatus(step1Error, "error"); return; }
const step2Error = validateConfigStep(2); if(step2Error){ setConfigStep(2); setConfigStatus(step2Error, "error"); return; }
const step3Error = validateConfigStep(3); if(step3Error){ setConfigStep(3); setConfigStatus(step3Error, "error"); return; }
if((isBeautify || isVaseChange) && Number(configState.compositionChangesUsed || 0) >= 2){ setConfigStatus("Bu aranjman için toplam üç tasarım hakkı kullanıldı.", "error"); return; }
if(isRetry && configState.retryUsed){ setConfigStatus("Tekrar deneme hakkı kullanıldı.", "error"); return; }
const sourceJobId = String(opts.sourceJobId || (isBeautify || isVaseChange ? configState.lastJobId : (configState.originalJobId || configState.lastJobId)) || "");
if(isFollowup && !sourceJobId){ setConfigStatus("Aranjmanı geliştirmek için önce bir tasarım oluşturulmalı.", "error"); return; }
if(authState.mode !== "authenticated"){
setConfigStatus("Tasarım oluşturmak için giriş yapmanız gerekiyor.", "error");
openAuthPrompt("own_stems", "login");
return;
}
if(systemState.aiSystemPaused){ setConfigStatus(systemState.aiSystemPauseMessage || "Floever AI Studio geçici olarak durduruldu.", "error"); return; }
if(shouldRequireProfileCompletion()){ openProfileCompletionModal(); return; }
const currentCost = getScenarioCreditCostFor("own_stems", "same");
if(!isFollowup && creditState.enabled && currentCost !== null && Number(creditState.balance) < currentCost){ openCreditPurchaseModal({reason:"insufficient", requiredCredits:currentCost, availableCredits:creditState.balance}); return; }
if(!isFollowup){
clearConfiguratorCompletedResultState({clearResultBox:true, save:false});
}else{
if(!configState.originalResultData && configState.lastResultData) configState.originalResultData = configState.lastResultData;
if(!configState.originalJobId) configState.originalJobId = sourceJobId;
}
const fd = new FormData();
fd.set("selected_scenario", "own_stems");
fd.set("arrangement_mode", "stock_flowers");
fd.set("selected_library_flowers", JSON.stringify(selectedConfigFlowers()));
fd.set("style", getSelectedArrangementStyle());
fd.set("composition_plan", JSON.stringify(buildArrangementCompositionPlan()));
fd.set("selected_composition_template_id", requestedCompositionTemplateId);
fd.set("ai_support_mode", "off");
fd.set("note", configEls.note?.value || "");
fd.set("retry_design", isRetry ? "1" : "0");
if(isRetry) fd.set("retry_for_job_id", sourceJobId);
fd.set("beautify_design", isBeautify ? "1" : "0");
fd.set("vase_change_design", isVaseChange ? "1" : "0");
if(isVaseChange) fd.set("vase_change_source_job_id", sourceJobId);
if(isBeautify){
fd.set("beautify_mode", beautifyMode);
fd.set("beautify_source_job_id", sourceJobId);
fd.set("beautify_recommendation_ids", JSON.stringify(configState.beautifyRecommendationIds || []));
}
if(configState.vaseMode === "floever") fd.set("selected_vase_id", configState.selectedVaseId);
else {
const ownVaseFile = configState.ownVaseFile || (configEls.ownVaseInput && configEls.ownVaseInput.files && configEls.ownVaseInput.files[0]);
if(!ownVaseFile){ setConfigStatus("Kendi vazo fotoğrafınızı yeniden seçmeniz gerekiyor.", "error"); return; }
fd.append("vase_image", ownVaseFile);
}
configState.beautifyMode = beautifyMode;
configState.beautifyGenerating = isBeautify;
configState.vaseChangeGenerating = isVaseChange;
setConfigStatus(isBeautify ? "En uygun Floever kompozisyonu hazırlanıyor…" : isVaseChange ? "Aranjman yeni vazoyla yeniden hazırlanıyor…" : isRetry ? "Aynı seçimlerle yeni görünüm hazırlanıyor…" : "Aranjman arka planda hazırlanıyor…", "");
if(configEls.generate) configEls.generate.disabled = true;
if(configEls.next) configEls.next.disabled = true;
["configBeautifySame","configBeautifyRecommended"].forEach(function(id){ const button=document.getElementById(id); if(button) button.disabled=true; });
configState.retryGenerating = isFollowup;
configState.backgroundIsRetry = isFollowup;
let cleanupLoading = null;
try{
await ensureStorefrontSession(false);
cleanupLoading = renderGenerationLoadingCard(isFollowup);
const startResponse = await apiFetch("/api/background-design-jobs", {method:"POST", body:fd});
const startData = await readJsonResponse(startResponse) || {};
if(!startResponse.ok || !startData.jobId) throw new Error(startData.error || "Arka plan tasarım işi başlatılamadı.");
configState.backgroundJobId = String(startData.jobId || "");
configState.backgroundJobStatus = "processing";
scheduleConfiguratorStateSave();
await pollBackgroundDesignJob(configState.backgroundJobId, isFollowup);
}catch(error){
if(isVaseChange && opts.vaseBackup){
restoreVaseChangeBackup(opts.vaseBackup);
renderConfigVases();
syncVaseSourceDecisionUi();
renderConfigSummary();
}
if(isBeautify && Array.isArray(opts.selectionBackup)){
configState.selectedFlowers = new Map();
opts.selectionBackup.forEach(function(item){ if(item && item.id) configState.selectedFlowers.set(String(item.id), Math.max(1, Number(item.count || 1))); });
configState.beautifyRecommendationIds = [];
renderConfigFlowers();
renderConfigSummary();
}
if(isBeautify && configState.originalResultData && configState.originalResultData.image){
configState.lastResultData = configState.originalResultData;
configState.lastImage = configState.originalResultData.image;
configState.beautifyMode = "";
renderConfiguredResult(configState.originalResultData, configState.originalJobId || configState.lastJobId);
const beautifyStatus = document.getElementById("configBeautifyStatus");
if(beautifyStatus){ beautifyStatus.textContent = floeverAiI18n.text(error?.message || "Aranjman güzelleştirilemedi."); beautifyStatus.classList.add("is-error"); }
}else{
resultBox.innerHTML = floeverAiI18n.html('<div class="ai-message">' + escapeHtml(error?.message || "Görsel oluşturulamadı.") + '</div>');
}
if(!isFollowup){ configState.retryUsed = false; }
setConfigStatus(error?.message || "Görsel oluşturulamadı.", "error");
}finally{
if(cleanupLoading) cleanupLoading();
configState.retryGenerating = false;
configState.beautifyGenerating = false;
configState.vaseChangeGenerating = false;
if(configEls.generate) configEls.generate.disabled = false;
if(configEls.next) configEls.next.disabled = false;
scheduleConfiguratorStateSave();
}
}
function renderResultOrderLines(){
const lines = [];
const vase = selectedConfigVase();
if(configState.vaseMode === "floever" && vase){
lines.push(`<div><span>${escapeHtml(vase.name)}</span><strong>${formatTry(parseConfigMoney(vase.priceAmount || vase.priceLabel))}</strong></div>`);
}else{
lines.push(`<div><span>Kendi vazonuz</span><strong>Vazo fiyatı yok</strong></div>`);
}
selectedConfigFlowers().forEach(function(item){
const flower = getConfigFlowerById(item.id);
if(!flower) return;
const unit = parseConfigMoney(flower.priceAmount || flower.priceLabel);
lines.push(`<div><span>${escapeHtml(flower.name)} × ${item.count}</span><strong>${formatTry(unit * Number(item.count || 1))}</strong></div>`);
});
if(configState.specialWaterApplication){
lines.push(`<div><span>Özel su uygulaması</span><strong>${formatTry(getSpecialWaterApplicationPrice())}</strong></div>`);
}
return lines.join("");
}
function renderResultEditList(){
const rows = selectedConfigFlowers().map(function(item){
const flower = getConfigFlowerById(item.id);
if(!flower) return "";
const unit = parseConfigMoney(flower.priceAmount || flower.priceLabel);
return `<div class="ai-result-edit-line" data-result-edit-line="${escapeHtml(flower.id)}"><img src="${escapeHtml(flower.imageUrl)}" alt="${escapeHtml(flower.name)}"><div><div class="ai-result-edit-name">${escapeHtml(flower.name)}</div><div class="ai-result-edit-price">${formatTry(unit)} / adet</div></div><div class="ai-result-qty"><button type="button" data-result-qty-minus="${escapeHtml(flower.id)}">−</button><input type="number" min="1" max="99" value="${Number(item.count || 1)}" data-result-qty-input="${escapeHtml(flower.id)}"><button type="button" data-result-qty-plus="${escapeHtml(flower.id)}">+</button></div></div>`;
}).filter(Boolean).join("");
return rows || `<div class="ai-message">Seçili çiçek bulunamadı.</div>`;
}
function updateConfiguredResultPricing(){
const totalEl = document.getElementById("configOrderTotal");
const summaryTotalEl = document.getElementById("configResultSummaryTotal");
const linesEl = document.getElementById("configOrderLines");
const summaryLinesEl = document.getElementById("configResultSummaryLines");
const listEl = document.getElementById("configResultEditList");
const totalText = formatTry(calculateConfigTotal());
if(totalEl) totalEl.textContent = floeverAiI18n.text(totalText);
if(summaryTotalEl) summaryTotalEl.textContent = floeverAiI18n.text(totalText);
if(linesEl) linesEl.innerHTML = floeverAiI18n.html(renderResultOrderLines());
if(summaryLinesEl) summaryLinesEl.innerHTML = floeverAiI18n.html(renderResultOrderLines());
if(listEl) listEl.innerHTML = floeverAiI18n.html(renderResultEditList());
refreshResultRecommendations();
bindConfiguredResultEditControls();
renderConfigFlowers();
renderConfigSummary();
}
function setConfigFlowerQuantity(id, quantity){
const safeId = String(id || "");
const qty = Math.max(1, Math.min(99, Number(quantity || 1)));
if(!getConfigFlowerById(safeId)) return;
configState.selectedFlowers.set(safeId, qty);
updateConfiguredResultPricing();
}
function bindConfiguredResultEditControls(){
Array.prototype.forEach.call(document.querySelectorAll("[data-result-qty-minus]"), function(btn){
btn.addEventListener("click", function(){
const id = btn.getAttribute("data-result-qty-minus") || "";
const current = configState.selectedFlowers.get(String(id)) || 1;
setConfigFlowerQuantity(id, Math.max(1, Number(current) - 1));
});
});
Array.prototype.forEach.call(document.querySelectorAll("[data-result-qty-plus]"), function(btn){
btn.addEventListener("click", function(){
const id = btn.getAttribute("data-result-qty-plus") || "";
const current = configState.selectedFlowers.get(String(id)) || 1;
setConfigFlowerQuantity(id, Number(current) + 1);
});
});
Array.prototype.forEach.call(document.querySelectorAll("[data-result-qty-input]"), function(input){
input.addEventListener("change", function(){
setConfigFlowerQuantity(input.getAttribute("data-result-qty-input") || "", input.value);
});
});
const waterToggle = document.getElementById("configWaterApplication");
if(waterToggle){
waterToggle.checked = Boolean(configState.specialWaterApplication);
waterToggle.addEventListener("change", function(){
configState.specialWaterApplication = Boolean(waterToggle.checked);
updateConfiguredResultPricing();
});
}
const updateButton = document.getElementById("configRegenerateButton");
if(updateButton){ updateButton.addEventListener("click", generateConfiguredArrangement); }
const chooseOrderButton = document.getElementById("configChooseOrder");
if(chooseOrderButton){ chooseOrderButton.addEventListener("click", function(){ showConfiguredResultPanel("order"); }); }
const chooseEditButton = document.getElementById("configChooseEdit");
if(chooseEditButton){ chooseEditButton.addEventListener("click", function(){ resetConfiguratorCompletely({showSetup:true}); }); }
Array.prototype.forEach.call(document.querySelectorAll(".ai-water-info"), function(info){
info.addEventListener("click", function(event){
event.preventDefault();
event.stopPropagation();
Array.prototype.forEach.call(document.querySelectorAll(".ai-water-info.is-open"), function(openInfo){ if(openInfo !== info) openInfo.classList.remove("is-open"); });
info.classList.toggle("is-open");
});
const pop = info.querySelector(".ai-water-pop");
if(pop){ pop.addEventListener("click", function(event){ event.stopPropagation(); }); }
});
if(!window.__floeverAiWaterInfoCloseBound){
window.__floeverAiWaterInfoCloseBound = true;
document.addEventListener("click", function(){
Array.prototype.forEach.call(document.querySelectorAll(".ai-water-info.is-open"), function(info){ info.classList.remove("is-open"); });
});
}
}
function showConfiguredResultPanel(panel){
const card = document.querySelector(".ai-result-card");
const orderPanel = document.getElementById("configResultOrderPanel");
const editPanel = document.getElementById("configResultEditPanel");
const orderButton = document.getElementById("configChooseOrder");
const editButton = document.getElementById("configChooseEdit");
const activePanel = panel === "edit" ? "edit" : "order";
if(card) card.setAttribute("data-active-panel", activePanel);
if(orderPanel){ orderPanel.hidden = activePanel !== "order"; orderPanel.classList.toggle("is-active", activePanel === "order"); }
if(editPanel){ editPanel.hidden = activePanel !== "edit"; editPanel.classList.toggle("is-active", activePanel === "edit"); }
if(orderButton){ orderButton.classList.toggle("is-active", activePanel === "order"); orderButton.setAttribute("aria-expanded", activePanel === "order" ? "true" : "false"); }
if(editButton){ editButton.classList.toggle("is-active", activePanel === "edit"); editButton.setAttribute("aria-expanded", activePanel === "edit" ? "true" : "false"); }
const target = activePanel === "order" ? orderPanel : editPanel;
if(target && typeof target.scrollIntoView === "function"){
  setTimeout(function(){ target.scrollIntoView({behavior:"smooth", block:"nearest"}); }, 30);
}
}
function extractConfigCmNumbers(value){
const text = String(value || "").replace(/,/g, ".").trim();
const matches = text.match(/(\d+(?:\.\d+)?)\s*(?:cm|CM|Cm)?/g) || [];
return matches
.map(function(item){ return Number.parseFloat(String(item).replace(/[^0-9.]/g, "")); })
.filter(function(num){ return Number.isFinite(num) && num > 0 && num < 500; });
}
function parseConfigProductDimension(value){
const text = String(value || "");
const numbers = extractConfigCmNumbers(text);
if(!numbers.length) return {width:0, depth:0, height:0};
function labeled(labels){
for(const label of labels){
const re = new RegExp(label + "\\\\s*[:=]?\\\\s*(\\\\d+(?:[,.]\\\\d+)?)\\\\s*cm?", "i");
const match = text.match(re);
if(match){
const parsed = Number.parseFloat(String(match[1]).replace(",", "."));
if(Number.isFinite(parsed) && parsed > 0) return parsed;
}
}
return 0;
}
const height = labeled(["yükseklik","yukseklik","height","uzunluk"]) || (numbers.length >= 3 ? numbers[2] : numbers[numbers.length - 1]);
const width = labeled(["en","width","genişlik","genislik"]) || (numbers.length >= 2 ? numbers[1] : numbers[0]);
const depth = labeled(["boy","derinlik","depth","çap","cap","diameter"]) || numbers[0] || width;
return {width:width || 0, depth:depth || width || 0, height:height || 0};
}
function maxConfigDimensionFromItem(item){
const text = [
item && item.dimensions,
item && item.optionSummary,
item && item.variantTitle,
item && item.heightCm ? item.heightCm + " cm" : ""
].filter(Boolean).join(" ");
const numbers = extractConfigCmNumbers(text);
return numbers.length ? Math.max.apply(null, numbers) : 0;
}
function estimateArrangementFromSelection(){
const vase = selectedConfigVase();
const flowerItems = selectedConfigFlowers()
.map(function(item){
const flower = getConfigFlowerById(item.id);
return flower ? Object.assign({}, flower, {count:item.count}) : null;
})
.filter(Boolean);
const vaseDim = parseConfigProductDimension([
vase && vase.dimensions,
vase && vase.optionSummary,
vase && vase.variantTitle
].filter(Boolean).join(" "));
const flowerHeights = flowerItems
.map(maxConfigDimensionFromItem)
.filter(function(num){ return Number.isFinite(num) && num > 0; });
const maxFlowerHeight = flowerHeights.length ? Math.max.apply(null, flowerHeights) : 0;
const stemCount = flowerItems.reduce(function(sum, item){
const count = Number(item.count || 1);
return sum + (Number.isFinite(count) && count > 0 ? count : 1);
}, 0);
const vaseHeight = vaseDim.height || 0;
const vaseWidth = Math.max(vaseDim.width || 0, vaseDim.depth || 0);
if(!vaseHeight && !maxFlowerHeight && !vaseWidth){
return {
label: "Ürün ölçü bilgisi eksik",
note: "Tahmini ölçü için vazo ve/veya çiçek varyasyonlarında cm ölçüsü bulunamadı."
};
}
const visibleFlowerHeight = maxFlowerHeight ? Math.max(10, maxFlowerHeight * 0.45) : Math.max(12, vaseHeight * 0.55);
const estimatedHeight = Math.max(vaseHeight || 0, (vaseHeight || 0) + visibleFlowerHeight);
const spreadBase = Math.max(vaseWidth || 0, maxFlowerHeight ? maxFlowerHeight * 0.55 : 0, vaseHeight ? vaseHeight * 0.65 : 0);
const countMultiplier = Math.min(1.45, 1 + Math.max(0, stemCount - 1) * 0.07);
const estimatedWidth = Math.max(vaseWidth || 0, spreadBase * countMultiplier);
const estimatedDepth = Math.max(vaseDim.depth || 0, estimatedWidth * 0.7);
const w = Math.max(1, Math.round(estimatedWidth));
const d = Math.max(1, Math.round(estimatedDepth));
const h = Math.max(1, Math.round(estimatedHeight));
return {
label: "Yaklaşık " + w + " x " + d + " x " + h + " cm",
note: ""
};
}
function renderArrangementEstimateHtml(estimate){
if(!estimate || !estimate.label) return "";
return `<div class="ai-arrangement-estimate"><span>Tahmini ölçü</span><strong>${escapeHtml(estimate.label)}</strong></div>`;
}

function ensureFloeverBeautifyStyles(){
if(document.getElementById("floeverBeautifyStyles")) return;
const style = document.createElement("style");
style.id = "floeverBeautifyStyles";
style.textContent = `
.ai-beautify-box{margin-top:14px;padding:18px;border:1px solid rgba(59,42,33,.14);border-radius:20px;background:#f7f3ec}
.ai-beautify-head{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:14px}
.ai-beautify-kicker{display:block;font-size:11px;font-weight:800;letter-spacing:.11em;text-transform:uppercase;color:#7a6759;margin-bottom:4px}
.ai-beautify-head h4{margin:0;font-size:20px;line-height:1.2;color:#2d211a}
.ai-beautify-head p{margin:7px 0 0;color:#6f5d50;font-size:13px;line-height:1.5}
.ai-beautify-free{flex:0 0 auto;padding:5px 9px;border-radius:999px;background:#fff;color:#304a2e;font-size:11px;font-weight:800;border:1px solid rgba(48,74,46,.18)}
.ai-beautify-options{display:grid;gap:10px}
.ai-beautify-option{width:100%;display:grid;grid-template-columns:44px minmax(0,1fr) auto;gap:12px;align-items:center;text-align:left;padding:13px;border:1px solid rgba(59,42,33,.13);border-radius:16px;background:#fff;cursor:pointer;transition:.18s ease;font:inherit;color:inherit}
.ai-beautify-option:hover{transform:translateY(-1px);border-color:rgba(48,74,46,.38);box-shadow:0 10px 22px rgba(59,42,33,.07)}
.ai-beautify-option:disabled{opacity:.55;cursor:not-allowed;transform:none;box-shadow:none}
.ai-beautify-icon{width:44px;height:44px;border-radius:14px;display:grid;place-items:center;background:#f1eadf;font-size:20px}
.ai-beautify-copy strong{display:block;font-size:14px;color:#2d211a;margin-bottom:3px}
.ai-beautify-copy span{display:block;font-size:12px;line-height:1.4;color:#756357}
.ai-beautify-arrow{font-size:20px;color:#7a6759}
.ai-beautify-recs{margin-top:10px;padding:12px;border-radius:15px;background:rgba(255,255,255,.72);border:1px dashed rgba(59,42,33,.15)}
.ai-beautify-rec{display:grid;grid-template-columns:42px minmax(0,1fr) auto;gap:10px;align-items:center;padding:8px 0;border-bottom:1px solid rgba(59,42,33,.08)}
.ai-beautify-rec:last-child{border-bottom:0}
.ai-beautify-rec img{width:42px;height:42px;object-fit:contain;border-radius:10px;background:#fff}
.ai-beautify-rec strong{display:block;font-size:12px;color:#2d211a}
.ai-beautify-rec small{display:block;margin-top:2px;color:#76665a;font-size:10.5px;line-height:1.35}
.ai-beautify-rec em{font-style:normal;font-size:11px;font-weight:800;white-space:nowrap;color:#304a2e}
.ai-beautify-total{display:flex;justify-content:space-between;gap:12px;align-items:center;margin-top:10px;padding-top:10px;border-top:1px solid rgba(59,42,33,.1);font-size:12px;color:#66564a}
.ai-beautify-total strong{font-size:13px;color:#2d211a}
.ai-beautified-badge{margin-top:14px;padding:14px 16px;border-radius:17px;background:#edf3eb;border:1px solid rgba(48,74,46,.18)}
.ai-beautified-badge span{display:block;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#496347}
.ai-beautified-badge strong{display:block;margin-top:4px;color:#283d27;font-size:15px}
.ai-result-compare{display:flex;gap:8px;justify-content:center;margin:10px 0 4px}
.ai-result-compare button{border:1px solid rgba(59,42,33,.16);background:#fff;padding:8px 12px;border-radius:999px;font:inherit;font-size:12px;font-weight:700;cursor:pointer}
.ai-result-compare button.is-active{background:#304a2e;color:#fff;border-color:#304a2e}
.ai-beautify-status{min-height:18px;margin-top:9px;font-size:12px;color:#6f5d50}
.ai-beautify-status.is-error{color:#a53d34}
@media(max-width:620px){.ai-beautify-option{grid-template-columns:40px minmax(0,1fr) 18px;padding:12px}.ai-beautify-box{padding:14px}.ai-beautify-head{display:block}.ai-beautify-free{display:inline-block;margin-top:8px}}
`;
document.head.appendChild(style);
}

function getBeautifyRecommendationItems(){
const selectedCount = selectedConfigFlowers().length;
if(selectedCount >= 10) return [];
const availableSlots = Math.max(0, 10 - selectedCount);
const items = getRecommendedConfigFlowers(Math.min(2, availableSlots), "result");
return items.slice(0, availableSlots).map(function(item){
const flower = item.flower;
const quantity = Math.max(1, Number(item.meta && item.meta.suggestedQuantity || recommendedQuantityForFlower(flower, analyzeArrangementCompletion(selectedConfigFlowerObjects())) || 1));
const unitPrice = parseConfigMoney(flower.priceAmount || flower.priceLabel);
return {
flower:flower,
quantity:quantity,
reason:recommendationReasonForFlower(flower, item.meta || {}),
priceDelta:unitPrice * quantity
};
});
}

function beautifyRecommendationTotal(items){
return (items || []).reduce(function(total, item){ return total + Number(item.priceDelta || 0); }, 0);
}

function renderBeautifyRecommendationList(items){
if(!items.length){
return `<div class="ai-beautify-recs"><div class="ai-beautify-total"><span>Seçiminiz kompozisyon açısından yeterli görünüyor.</span><strong>Ek ürün yok</strong></div></div>`;
}
return `<div class="ai-beautify-recs">${items.map(function(item){
return `<div class="ai-beautify-rec"><img src="${escapeHtml(item.flower.imageUrl)}" alt="${escapeHtml(item.flower.name)}"><div><strong>${escapeHtml(item.flower.name)} × ${item.quantity}</strong><small>${escapeHtml(item.reason)}</small></div><em>+${formatTry(item.priceDelta)}</em></div>`;
}).join("")}<div class="ai-beautify-total"><span>Öneriler kullanılırsa yeni toplam</span><strong>${formatTry(calculateConfigTotal() + beautifyRecommendationTotal(items))}</strong></div></div>`;
}

function renderBeautifyPanelHtml(data){
const beautified = Boolean(data && data.beautify && data.beautify.used);
if(!beautified) return "";
const templateName = data.beautify.templateName || data.compositionPlan && data.compositionPlan.templateName || "Floever kompozisyonu";
return `<div class="ai-beautified-badge"><span>Yeni kompozisyon</span><strong>${escapeHtml(templateName)}</strong></div>`;
}

function applyFloeverBeautifyRecommendations(items){
const addedIds = [];
(items || []).forEach(function(item){
const id = String(item.flower && item.flower.id || "");
if(!id) return;
const current = Number(configState.selectedFlowers.get(id) || 0);
const maxProfile = Math.max(1, numericAiField(item.flower, ["maxQuantity","aiMaxQuantity"], 99) || 99);
const stock = Number(item.flower.stockQuantity);
const stockLimit = Number.isFinite(stock) && stock > 0 ? stock : 99;
const next = Math.min(99, maxProfile, stockLimit, current + Number(item.quantity || 1));
configState.selectedFlowers.set(id, Math.max(1, next));
addedIds.push(id);
});
configState.beautifyRecommendationIds = addedIds;
renderConfigFlowers();
renderConfigSummary();
updateConfiguredResultPricing();
return addedIds;
}

function bindBeautifyControls(){
const sameButton = document.getElementById("configBeautifySame");
const recommendedButton = document.getElementById("configBeautifyRecommended");
if(sameButton){
sameButton.addEventListener("click", function(){ generateConfiguredArrangement({beautifyMode:"same_products"}); });
}
if(recommendedButton && !recommendedButton.disabled){
recommendedButton.addEventListener("click", function(){
const items = getBeautifyRecommendationItems();
if(!items.length) return;
const selectionBackup = selectedConfigFlowers().map(function(item){ return {id:item.id,count:item.count}; });
applyFloeverBeautifyRecommendations(items);
generateConfiguredArrangement({beautifyMode:"floever_recommended", selectionBackup:selectionBackup});
});
}
Array.prototype.forEach.call(document.querySelectorAll("[data-result-image-view]"), function(button){
button.addEventListener("click", function(){
const image = document.getElementById("configResultMainImage");
if(!image) return;
const view = button.getAttribute("data-result-image-view");
const original = configState.originalResultData && configState.originalResultData.image;
const beautified = configState.lastResultData && configState.lastResultData.image;
image.src = view === "original" && original ? original : beautified || image.src;
Array.prototype.forEach.call(document.querySelectorAll("[data-result-image-view]"), function(item){ item.classList.toggle("is-active", item === button); });
});
});
}


function renderConfiguredResult(data, jobId){
ensureFloeverBeautifyStyles();
showResultView();
configState.step = 4;
const isBeautified = Boolean(data && data.beautify && data.beautify.used);
const isVaseChanged = Boolean(data && data.vaseChange && data.vaseChange.used);
const arrangementEstimate = data.arrangementEstimate || estimateArrangementFromSelection();
const waterChecked = configState.specialWaterApplication ? "checked" : "";
const totalText = formatTry(calculateConfigTotal());
const resultLines = renderResultOrderLines();
const originalImage = configState.originalResultData && configState.originalResultData.image;
const comparisonHtml = isBeautified && originalImage
? `<div class="ai-result-compare"><button type="button" data-result-image-view="beautified" class="is-active">Floever Güzelleştirmesi</button><button type="button" data-result-image-view="original">İlk Tasarım</button></div>`
: "";
resultBox.innerHTML = floeverAiI18n.html(`
<div class="ai-result-card ai-result-card-v47" data-active-panel="none">
<div class="ai-result-processes" aria-label="Tasarım adımları">
<span class="is-complete" role="button" tabindex="0" data-result-step-jump="1"><b>1</b> Vazo</span>
<span class="is-complete" role="button" tabindex="0" data-result-step-jump="2"><b>2</b> Çiçekler</span>
<span class="is-complete" role="button" tabindex="0" data-result-step-jump="3"><b>3</b> Tarz</span>
<span class="is-active" role="button" tabindex="0" data-result-step-jump="4"><b>4</b> Tasarım</span>
</div>
<div class="ai-result-main ai-result-main-polished ai-result-main-v47">
<section class="ai-result-visual ai-result-visual-v47">
<h3>${isVaseChanged ? "Yeni vazoyla tasarım hazır" : isBeautified ? `${escapeHtml(currentArrangementStyleLabel())} için yeni kompozisyon hazır` : "Tasarım Hazır"}</h3>
${comparisonHtml}
<img id="configResultMainImage" src="${data.image}" alt="${isBeautified ? "Floever güzelleştirilmiş aranjman tasarımı" : "AI aranjman tasarımı"}">
<div class="ai-result-actions ai-result-actions-v47">
</div>

</section>
<aside class="ai-result-side ai-result-side-polished ai-result-side-v47">
<div class="ai-result-shop-summary">
<div class="ai-side-kicker">Özet</div>
<div class="ai-result-total-box">
<span>Toplam</span>
<strong id="configResultSummaryTotal">${totalText}</strong>
</div>
${renderArrangementEstimateHtml(arrangementEstimate)}
<div class="ai-result-summary-lines" id="configResultSummaryLines">${resultLines}</div>
</div>
${renderBeautifyPanelHtml(data)}
${renderSharedAvailabilityNoticeHtml()}
<div class="ai-result-choice-grid" aria-label="Tasarım aksiyonları" style="grid-template-columns:1fr;">
<button type="button" class="ai-result-choice-btn is-primary" id="configChooseOrder" aria-expanded="false" ${configState.shareUnavailableItems.length ? "disabled" : ""}>
<strong>Sipariş Ver</strong>
<span>${configState.shareUnavailableItems.length ? "Stok durumunu kontrol edin" : "Ödemeye geç"}</span>
</button>
</div>
${renderResultSecondaryActionsHtml()}
${renderFloeverWhatsappContactHtml(data)}
<div class="ai-result-decision-panel ai-order-box" id="configResultOrderPanel" hidden>
<div class="ai-side-kicker">Sipariş</div>
<label class="ai-water-option">
<input type="checkbox" id="configWaterApplication" ${waterChecked}>
<span>
<span class="ai-water-title-row">
<strong>Özel su uygulaması</strong>
<span class="ai-water-info" tabindex="0" aria-label="Özel su uygulaması bilgisi">?
<span class="ai-water-pop" role="tooltip">
<img src="https://cdn.shopify.com/s/files/1/0943/6990/6967/files/ERJ14-126-2-768x768.jpg?v=1782304707" alt="Özel epoksi su efekti örneği">
<strong>Özel su uygulaması</strong>
Gerçek su değildir; dekoratif özel uygulamadır.
</span>
</span>
<em>+${formatTry(getSpecialWaterApplicationPrice())}</em>
</span>
<small>Gerçek su değildir; dekoratif özel uygulamadır.</small>
</span>
</label>
<div class="ai-order-lines" id="configOrderLines">${resultLines}</div>
<div class="ai-order-total" id="configOrderTotal">${totalText}</div>
<button type="button" class="ai-btn ai-order-btn" id="configOrderButton" ${configState.shareUnavailableItems.length ? "disabled" : ""}><span>${configState.shareUnavailableItems.length ? "Eksik ürün var" : "Ödemeye Geç"}</span></button>
<div class="ai-followup-status" id="configOrderStatus" aria-live="polite"></div>
</div>
</aside>
</div>
${renderPostDesignCompositionPickerHtml(data)}
<section id="configPreviousDesignsSectionResult" data-previous-designs-section="result" style="max-width:1120px;margin:30px auto 0;padding:0 16px;display:block;"></section>
</div>`);
const orderButton = document.getElementById('configOrderButton');
if(orderButton){ orderButton.addEventListener('click', createConfiguredDraftOrder); }
bindConfiguredResultEditControls();
bindBeautifyControls();
bindPostDesignCompositionControls();
bindShareAndVaseChangeControls();
bindResultStepNavigation();
renderPreviousDesignsSlider();
void loadPreviousDesigns(false);
void ensurePostDesignCompositionRecommendationsLoaded(data, false);
}
async function createConfiguredDraftOrder(){
const status = document.getElementById('configOrderStatus');
const button = document.getElementById('configOrderButton');
try{
if(configState.shareUnavailableItems.length) throw new Error("Paylaşılan tasarımda stokta olmayan ürünler var. Eksik ürünleri değiştirmeden sipariş oluşturulamaz.");
if(status){ status.textContent = floeverAiI18n.text("Ödeme bağlantısı hazırlanıyor…"); status.className = "ai-followup-status"; }
if(button) button.disabled = true;
const orderRequest={method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({ jobId:configState.lastJobId, shareCode:configState.activeShareCode || "", imageUrl:configState.lastImage || "", generatedImageUrl:configState.lastImage || "", designImageUrl:configState.lastImage || "", lineItemProperties:{"AI Aranjman Görseli":configState.lastImage || ""}, selectedVaseId: configState.vaseMode === "floever" ? configState.selectedVaseId : "", selectedFlowers:selectedConfigFlowers(), style:getSelectedArrangementStyle(), compositionPlan:buildArrangementCompositionPlan(), aiSupportMode:"off", note:configEls.note?.value || "", specialWaterApplication: Boolean(configState.specialWaterApplication), gameRewardToken:authState.mode === "authenticated" ? ((readGameReward()||{}).token || "") : "" })};
const response = configState.sharedPreviewOnly && configState.activeShareCode
? await fetch(String(API_BASE_URL).replace(/\/+$/,'')+'/api/custom-arrangement-order',Object.assign({cache:'no-store'},orderRequest))
: await apiFetch('/api/custom-arrangement-order',orderRequest);
const data = await readJsonResponse(response) || {};
if(!response.ok || !data.checkoutUrl) throw new Error(data.error || "Sipariş bağlantısı oluşturulamadı.");
if(Number(data.discountPercent||0)>0){
try{ localStorage.removeItem("floever_ai_game_reward_v1"); }catch(error){}
window.FLOEVER_GAME_REWARD=null;
}
if(status){ status.textContent = floeverAiI18n.text("Ödeme sayfasına yönlendiriliyorsunuz…"); status.className = "ai-followup-status is-success"; }
window.location.href = data.checkoutUrl;
}catch(error){
if(status){ status.textContent = floeverAiI18n.text(error?.message || "Sipariş oluşturulamadı."); status.className = "ai-followup-status is-error"; }
if(button) button.disabled = false;
}
}

function ensurePreviousDesignsSection(){
let section = document.getElementById("configPreviousDesignsSection");
if(section){
section.setAttribute("data-previous-designs-section", "page");
return section;
}
section = document.createElement("section");
section.id = "configPreviousDesignsSection";
section.setAttribute("data-previous-designs-section", "page");
section.style.cssText = "max-width:1120px;margin:34px auto 24px;padding:0 16px;display:block;";
const root = configEls.root || document.getElementById("aiConfigurator");
if(root && root.parentNode){
root.parentNode.insertBefore(section, root.nextSibling);
}else if(resultView && resultView.parentNode){
resultView.parentNode.insertBefore(section, resultView.nextSibling);
}else{
document.body.appendChild(section);
}
return section;
}

function getPreviousDesignSections(){
ensurePreviousDesignsSection();
return Array.prototype.slice.call(document.querySelectorAll('[data-previous-designs-section]'));
}

function resolvePreviousDesignAssetUrl(value){
const raw = String(value || "").trim();
if(!raw) return "";
if(/^https?:\/\//i.test(raw) || raw.startsWith("data:") || raw.startsWith("blob:")) return raw;
const base = String(authState.apiBaseUrl || API_BASE_URL || "").replace(/\/+$/, "");
try{
return new URL(base + (raw.startsWith("/") ? raw : "/" + raw), window.location.origin).href;
}catch(error){
return raw;
}
}

function normalizePreviousDesignRecord(design){
if(!design || typeof design !== "object") return design;
return Object.assign({}, design, {
previewImageUrl: resolvePreviousDesignAssetUrl(design.previewImageUrl),
previewImageDownloadUrl: resolvePreviousDesignAssetUrl(design.previewImageDownloadUrl),
originalImageUrl: resolvePreviousDesignAssetUrl(design.originalImageUrl)
});
}

function previousDesignNumber(design){
const id = String(design && design.id || "");
const shortId = id.split("-")[0].slice(0,8).toUpperCase();
return "Tasarım #" + (shortId || "—");
}

function previousDesignPriceValue(design){
const metadata = design && design.requestMetadata || {};
const snapshot = metadata.pricingSnapshot || {};
if(Number.isFinite(Number(snapshot.totalPrice))) return Number(snapshot.totalPrice);
if(Number.isFinite(Number(snapshot.subtotal))) return Number(snapshot.subtotal);
let total = Number(metadata.selectedVase && (metadata.selectedVase.priceAmount || parseConfigMoney(metadata.selectedVase.priceLabel)) || 0);
(Array.isArray(metadata.selectedStockFlowers) ? metadata.selectedStockFlowers : []).forEach(function(item){
const quantity = Math.max(1, Number(item && item.count || 1));
const unit = Number(item && item.priceAmount || parseConfigMoney(item && item.priceLabel));
total += unit * quantity;
});
return total;
}

function previousDesignsHeaderHtml(instanceKey){
return `<div style="display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:14px;"><h3 style="margin:0;color:#3B2A21;font-size:24px;">Önceki Tasarımlar</h3><div style="display:flex;gap:8px;"><button type="button" data-previous-design-scroll="prev" data-previous-design-track="${escapeHtml(instanceKey)}" style="width:40px;height:40px;border-radius:999px;border:1px solid #DDCFBF;background:#fff;cursor:pointer;font-size:20px;">‹</button><button type="button" data-previous-design-scroll="next" data-previous-design-track="${escapeHtml(instanceKey)}" style="width:40px;height:40px;border-radius:999px;border:1px solid #DDCFBF;background:#fff;cursor:pointer;font-size:20px;">›</button></div></div>`;
}

function renderPreviousDesignsSliderInto(section, index){
if(!section) return;
const instanceKey = String(section.getAttribute("data-previous-designs-section") || ("history-" + index));
const header = previousDesignsHeaderHtml(instanceKey);
const topBorder = instanceKey === "result" ? "" : "border-top:1px solid #E9DFD3;";
const shellStyle = `${topBorder}padding-top:${instanceKey === "result" ? "6px" : "24px"};`;
if(configState.previousDesignsLoading){
section.innerHTML = floeverAiI18n.html(`<div style="${shellStyle}">${header}<p style="margin:0;color:#6C5A4D;">Tasarımlar yükleniyor…</p></div>`);
return;
}
if(authState.mode === "guest"){
section.innerHTML = floeverAiI18n.html(`<div style="${shellStyle}">${header}<p style="margin:0;color:#6C5A4D;">Önceki tasarımlarını görmek için giriş yapmalısın.</p></div>`);
return;
}
const designs = Array.isArray(configState.previousDesigns) ? configState.previousDesigns.filter(function(item){ return item && item.status === "completed" && item.previewImageUrl; }) : [];
if(!designs.length){
const emptyText = configState.previousDesignsError || "Henüz kayıtlı bir tasarım bulunmuyor.";
section.innerHTML = floeverAiI18n.html(`<div style="${shellStyle}">${header}<p style="margin:0;color:${configState.previousDesignsError ? "#8A5E3B" : "#6C5A4D"};">${escapeHtml(emptyText)}</p></div>`);
return;
}
const cards = designs.map(function(design){
const price = previousDesignPriceValue(design);
const priceText = price > 0 ? formatTry(price) : "Fiyat bilgisi yok";
return `<button type="button" data-previous-design-id="${escapeHtml(design.id)}" style="appearance:none;flex:0 0 220px;width:220px;text-align:left;background:#fff;border:1px solid #E6DCCF;border-radius:18px;padding:10px;cursor:pointer;scroll-snap-align:start;box-shadow:0 4px 14px rgba(59,42,33,.05);"><img src="${escapeHtml(design.previewImageUrl)}" alt="${escapeHtml(previousDesignNumber(design))}" loading="lazy" decoding="async" style="display:block;width:100%;aspect-ratio:1/1;object-fit:cover;object-position:center;border-radius:13px;background:#F7F3EC;"><span style="display:block;margin-top:10px;font-size:12px;color:#8E673C;font-weight:700;letter-spacing:.03em;">${escapeHtml(previousDesignNumber(design))}</span><strong style="display:block;margin-top:5px;color:#3B2A21;font-size:16px;">${escapeHtml(priceText)}</strong></button>`;
}).join("");
section.innerHTML = floeverAiI18n.html(`<div style="${shellStyle}">${header}<div data-previous-design-track-key="${escapeHtml(instanceKey)}" style="display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;padding:2px 2px 14px;scrollbar-width:thin;">${cards}</div></div>`);
}

function renderPreviousDesignsSlider(){
getPreviousDesignSections().forEach(function(section,index){
renderPreviousDesignsSliderInto(section,index);
});
bindPreviousDesignsControls();
}

function mergeHistoricalProductsIntoLibraries(metadata){
const vase = metadata && metadata.selectedVase;
if(vase && vase.id && !configState.vases.some(function(item){ return String(item.id) === String(vase.id); })){
configState.vases.push(Object.assign({active:true,priceAmount:parseConfigMoney(vase.priceAmount || vase.priceLabel)}, vase));
}
(Array.isArray(metadata && metadata.selectedStockFlowers) ? metadata.selectedStockFlowers : []).forEach(function(item){
if(!item || !item.id || configState.flowers.some(function(existing){ return String(existing.id) === String(item.id); })) return;
configState.flowers.push(Object.assign({active:true,availableForSale:true,priceAmount:parseConfigMoney(item.priceAmount || item.priceLabel),stockQuantity:99}, item));
});
}

function restorePreviousDesign(design){
if(!design || !design.previewImageUrl) return;
design = normalizePreviousDesignRecord(design);
const metadata = design.requestMetadata || {};
mergeHistoricalProductsIntoLibraries(metadata);
configState.vaseMode = metadata.selectedVase && metadata.selectedVase.id ? "floever" : "own";
configState.vaseSourceChosen = true;
configState.activeShareCode = "";
configState.shareUnavailableItems = [];
configState.sharedPreviewOnly = false;
configState.selectedVaseId = metadata.selectedVase && metadata.selectedVase.id ? String(metadata.selectedVase.id) : "";
configState.selectedFlowers = new Map();
(Array.isArray(metadata.selectedStockFlowers) ? metadata.selectedStockFlowers : []).forEach(function(item){
const id = String(item && item.id || "");
if(id) configState.selectedFlowers.set(id, Math.max(1, Number(item.count || 1)));
});
if(configEls.style) configEls.style.value = metadata.styleInput || metadata.normalizedStyle || "AI Seçimi";
if(configEls.note) configEls.note.value = metadata.note || "";
const historicalIsBeautified = Boolean(metadata.isBeautifyDesign);
const historicalIsVaseChange = Boolean(metadata.isVaseChangeDesign || metadata.revisionType === "vase_change");
const historicalCompositionIteration = Math.max(0, Math.min(2, Number(metadata.revisionIteration || metadata.compositionIteration || ((historicalIsBeautified || historicalIsVaseChange) ? 1 : 0))));
const historicalRetryUsed = Boolean(metadata.isOneTimeRetry || historicalCompositionIteration >= 2);
const historicalSourceJobId = String(metadata.vaseChangeSourceJobId || metadata.beautifySourceJobId || metadata.derivedFromDesignJobId || metadata.retryForJobId || design.id || "");
const resultData = {
success:true,
scenario:metadata.scenario || design.scenario || "own_stems",
image:design.previewImageUrl,
originalImage:design.originalImageUrl || "",
scenarioMaterials:{userFlowers:Array.isArray(metadata.selectedStockFlowers) ? metadata.selectedStockFlowers : [],aiSupportMode:metadata.aiSupportMode || "off",aiSupportModeLabel:metadata.aiSupportModeLabel || "Kapalı",aiAdditions:Array.isArray(metadata.aiAdditions) ? metadata.aiAdditions : []},
arrangementEstimate:metadata.arrangementEstimate || null,
pricingSnapshot:metadata.pricingSnapshot || null,
compositionPlan:metadata.compositionPlan || metadata.compositionLibrary || null,
requestMetadata:metadata,
revision:{type:metadata.revisionType || (historicalIsVaseChange ? "vase_change" : historicalIsBeautified ? "composition" : "initial"),iteration:historicalCompositionIteration,remaining:Math.max(0,2-historicalCompositionIteration)},
vaseChange:historicalIsVaseChange ? {used:true,iteration:historicalCompositionIteration,remaining:Math.max(0,2-historicalCompositionIteration),sourceJobId:historicalSourceJobId} : {used:false,available:historicalCompositionIteration < 2},
beautify:historicalIsBeautified ? {used:true,available:historicalCompositionIteration < 2,iteration:historicalCompositionIteration,sourceJobId:historicalSourceJobId,templateId:metadata.compositionPlan && metadata.compositionPlan.templateId || null,templateName:metadata.compositionPlan && metadata.compositionPlan.templateName || null} : {used:false,available:!historicalRetryUsed},
retry:{used:historicalRetryUsed,remaining:historicalRetryUsed ? 0 : 1},
creditSystem:{enabled:true,jobId:design.id,retryUsed:historicalRetryUsed}
};
configState.lastJobId = String(design.id || "");
configState.originalJobId = historicalSourceJobId || configState.lastJobId;
configState.lastImage = design.previewImageUrl;
configState.lastResultData = resultData;
configState.originalResultData = resultData;
configState.retryUsed = historicalRetryUsed;
configState.compositionChangesUsed = historicalCompositionIteration;
configState.step = 4;
configState.resultCurrentCompositionTemplateId = String(resultData.compositionPlan && resultData.compositionPlan.templateId || "");
configState.selectedCompositionTemplateId = configState.resultCurrentCompositionTemplateId;
configState.compositionRecommendations = [];
configState.compositionRecommendationKey = "";
renderConfigVases();
populateFlowerFilters();
renderConfigFlowers();
renderConfigSummary();
syncStyleCards();
renderConfiguredResult(resultData, configState.lastJobId);
scheduleConfiguratorStateSave();
window.setTimeout(function(){
const target = resultView || resultBox;
if(target && target.scrollIntoView) target.scrollIntoView({behavior:"smooth",block:"start"});
},80);
}

function bindPreviousDesignsControls(){
Array.prototype.forEach.call(document.querySelectorAll("[data-previous-design-id]"), function(button){
if(button.dataset.previousDesignBound === "true") return;
button.dataset.previousDesignBound = "true";
button.addEventListener("click", function(){
const id = String(button.getAttribute("data-previous-design-id") || "");
const design = configState.previousDesigns.find(function(item){ return String(item.id) === id; });
restorePreviousDesign(design);
});
});
Array.prototype.forEach.call(document.querySelectorAll("[data-previous-design-scroll]"), function(button){
if(button.dataset.previousScrollBound === "true") return;
button.dataset.previousScrollBound = "true";
button.addEventListener("click", function(){
const key = String(button.getAttribute("data-previous-design-track") || "");
const section = button.closest('[data-previous-designs-section]');
const track = section ? section.querySelector(`[data-previous-design-track-key="${cssEscapeForSelector(key)}"]`) : null;
if(!track) return;
const direction = button.getAttribute("data-previous-design-scroll") === "prev" ? -1 : 1;
track.scrollBy({left:direction * Math.max(250, Math.floor(track.clientWidth * .82)),behavior:"smooth"});
});
});
Array.prototype.forEach.call(document.querySelectorAll("[data-previous-design-refresh]"), function(button){
if(button.dataset.previousRefreshBound === "true") return;
button.dataset.previousRefreshBound = "true";
button.addEventListener("click", function(){ void loadPreviousDesigns(true); });
});
}

function cssEscapeForSelector(value){
if(window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(value || ""));
return String(value || "").replace(/(["\\])/g, "\\$1");
}

async function loadPreviousDesigns(force){
ensurePreviousDesignsSection();
if(authState.mode !== "authenticated"){
renderPreviousDesignsSlider();
return;
}
if(configState.previousDesignsLoading) return;
if(!force && configState.previousDesigns.length){ renderPreviousDesignsSlider(); return; }
configState.previousDesignsLoading = true;
configState.previousDesignsError = "";
renderPreviousDesignsSlider();
try{
const response = await apiFetch("/api/me/designs?limit=30", {method:"GET"});
const data = await readJsonResponse(response) || {};
if(!response.ok || !Array.isArray(data.designs)) throw new Error(data.error || "Önceki tasarımlar alınamadı.");
configState.previousDesigns = data.designs.map(normalizePreviousDesignRecord);
}catch(error){
configState.previousDesignsError = error && error.message || "Önceki tasarımlar alınamadı.";
}finally{
configState.previousDesignsLoading = false;
renderPreviousDesignsSlider();
}
}


function ensureFloeverStudioV127Styles(){
const id = "floever-ai-v133-mobile-ui-share-preview-step-navigation";
if(document.getElementById(id)) return;
const style = document.createElement("style");
style.id = id;
style.textContent = `
.ai-vase-source-decision{border:1px solid #E8DED1;background:#FBF8F3;border-radius:22px;padding:20px;margin:0 0 20px}
.ai-vase-source-decision h3{margin:0 0 6px;color:#3B2A21;font-size:22px}
.ai-vase-source-decision p{margin:0 0 16px;color:#6C5A4D;line-height:1.5}
.ai-vase-source-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
.ai-vase-source-card{position:relative;min-height:176px;border:1px solid #D9CEBF;border-radius:18px;background:#fff;padding:20px;text-align:left;cursor:pointer;transition:border-color .18s,background .18s,transform .18s}
.ai-vase-source-card:hover{border-color:#8CA082;transform:translateY(-1px)}
.ai-vase-source-card.is-selected{border-color:#304A2E;background:#F4F8F1}
.ai-vase-source-card .ai-vase-source-icon{font-size:34px;display:block;margin-bottom:20px}
.ai-vase-source-card strong{display:block;color:#3B2A21;font-size:17px;margin-bottom:7px}
.ai-vase-source-card small{display:block;color:#6C5A4D;line-height:1.45}
.ai-vase-source-card .ai-vase-source-check{position:absolute;right:14px;top:14px;width:24px;height:24px;border-radius:50%;background:#304A2E;color:#fff;display:none;align-items:center;justify-content:center;font-size:14px}
.ai-vase-source-card.is-selected .ai-vase-source-check{display:flex}
.ai-vase-source-change{display:inline-flex;margin:12px 0 2px;border:0;background:transparent;color:#304A2E;text-decoration:underline;cursor:pointer;font:inherit}
.ai-share-code-entry{border:1px solid #E8DED1;border-radius:18px;background:#fff;padding:16px;margin-bottom:16px}
.ai-share-code-entry summary{cursor:pointer;color:#3B2A21;font-weight:650}
.ai-share-code-row{display:flex;gap:9px;margin-top:12px}
.ai-share-code-row input{flex:1;min-width:0;border:1px solid #D9CEBF;border-radius:12px;padding:11px 13px;text-transform:uppercase}
.ai-share-code-row button{border:0;border-radius:12px;padding:11px 16px;background:#304A2E;color:#fff;cursor:pointer}
.ai-share-code-status{font-size:12px;margin-top:8px;color:#6C5A4D}
.ai-share-code-status:empty{display:none}
.ai-config-product-card.ai-flower-stable{position:relative;display:grid;grid-template-rows:auto 1fr 52px;min-height:360px;height:100%;border:1px solid #E4DACC!important;background:#fff!important;overflow:visible;transition:border-color .18s,background .18s,box-shadow .18s}
.ai-config-product-card.ai-flower-stable:hover{border-color:#B8A894!important;box-shadow:0 7px 20px rgba(59,42,33,.06)}
.ai-config-product-card.ai-flower-stable.is-selected{border:1px solid #304A2E!important;background:#F7FAF4!important;box-shadow:0 5px 18px rgba(48,74,46,.07)!important}
.ai-flower-stable .ai-config-product-select{display:grid;grid-template-rows:205px 1fr;width:100%;height:100%;min-height:0}
.ai-flower-stable .ai-config-product-image{height:205px;min-height:205px;aspect-ratio:1/1;overflow:hidden;background:#F5F1EB}
.ai-flower-stable .ai-config-product-image img{width:100%;height:100%;object-fit:contain;display:block}
.ai-flower-stable .ai-config-product-body{min-height:92px;padding:11px 12px;display:flex;flex-direction:column}
.ai-flower-stable .ai-config-product-title{min-height:44px;line-height:1.35}
.ai-flower-stable .ai-config-product-price{margin-top:auto}
.ai-flower-stable .ai-config-qty-row{height:52px;min-height:52px;margin:0;padding:8px 12px;border-top:1px solid #EEE6DC;display:flex!important;visibility:visible!important}
.ai-flower-stable:not(.is-selected) .ai-config-qty-row{opacity:.48}
.ai-flower-stable .ai-config-selected-check{position:absolute;right:12px;top:12px;z-index:4;width:25px;height:25px;border-radius:50%;background:#304A2E;color:#fff;display:flex;align-items:center;justify-content:center;font-size:14px;box-shadow:0 2px 8px rgba(0,0,0,.10)}
.ai-flower-stable .ai-config-count-badge{position:absolute;right:10px;bottom:59px;z-index:4;border:1px solid #C8D5C3;background:#F7FAF4;color:#304A2E;border-radius:999px;padding:4px 8px;font-size:11px;font-weight:700}
.ai-share-unavailable{border:1px solid #D7A97B;background:#FFF8EE;border-radius:16px;padding:14px;margin:14px 0;color:#5F402B}
.ai-share-unavailable strong{display:block;margin-bottom:7px}
.ai-share-unavailable ul{margin:0;padding-left:18px}
.ai-share-unavailable small{display:block;margin-top:4px;color:#795C45}
.ai-result-secondary-actions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin:12px 0 4px}
.ai-result-secondary-actions button{border:1px solid #D7CCBE;background:#FBF8F3;color:#304A2E;border-radius:14px;cursor:pointer;padding:11px 12px;font:inherit;font-size:13px;font-weight:700;display:flex;align-items:center;justify-content:center;gap:7px;min-height:46px}
.ai-result-secondary-actions button:hover{border-color:#8CA082;background:#F3F7EF}
.ai-result-secondary-actions button:disabled{opacity:.45;cursor:not-allowed}
.ai-secondary-action-icon{width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#EAF1E5;font-size:16px}
.ai-studio-modal-shell{position:fixed;inset:0;z-index:999999;background:rgba(30,25,20,.46);display:flex;align-items:center;justify-content:center;padding:18px}
.ai-studio-modal-shell[hidden]{display:none!important}
.ai-studio-modal-card{width:min(620px,100%);max-height:88vh;overflow:auto;background:#fff;border-radius:24px;padding:22px;box-shadow:0 24px 80px rgba(0,0,0,.22)}
.ai-studio-modal-head{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:16px}
.ai-studio-modal-head h3{margin:0;color:#3B2A21}
.ai-studio-modal-close{border:0;background:#F2ECE4;border-radius:50%;width:34px;height:34px;cursor:pointer}
.ai-vase-change-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}
.ai-vase-change-option{border:1px solid #E4DACC;background:#fff;border-radius:15px;padding:9px;cursor:pointer;text-align:left}
.ai-vase-change-option.is-selected{border-color:#304A2E;background:#F7FAF4}
.ai-vase-change-option img{width:100%;height:130px;object-fit:contain;background:#F5F1EB;border-radius:10px}
.ai-vase-change-option strong{display:block;font-size:13px;margin-top:7px;color:#3B2A21}
.ai-modal-field{display:block;margin:12px 0}
.ai-modal-field span{display:block;font-size:12px;color:#6C5A4D;margin-bottom:5px}
.ai-modal-field input{width:100%;border:1px solid #D9CEBF;border-radius:12px;padding:11px}
.ai-modal-actions{display:flex;justify-content:flex-end;gap:9px;margin-top:16px}
.ai-modal-actions button,.ai-modal-primary{border:0;border-radius:12px;padding:11px 17px;cursor:pointer}
.ai-modal-primary{background:#304A2E;color:#fff}
.ai-modal-secondary{background:#F2ECE4;color:#3B2A21}
.ai-share-output{border:1px solid #E5DACE;background:#FBF8F3;border-radius:18px;padding:13px;margin-top:12px;word-break:break-word}
.ai-share-preview{display:block;width:min(210px,62vw);aspect-ratio:9/16;object-fit:cover;margin:0 auto 12px;border-radius:13px;border:1px solid #DED3C6;background:#fff;box-shadow:0 8px 24px rgba(59,42,33,.09)}
.ai-share-code-badge{display:flex;align-items:center;justify-content:center;gap:9px;min-height:48px;border:1px solid #C5B3D6;background:#F5EFFA;color:#5D3678;border-radius:13px;padding:8px 13px;text-align:center}
.ai-share-code-badge small{font-size:11px;font-weight:650;color:#806690;letter-spacing:.02em}
.ai-share-code-badge strong{font-size:18px;font-weight:850;letter-spacing:.12em}
.ai-social-share-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:7px;margin-top:12px}
.ai-social-share-button{appearance:none;border:1px solid #DDD1C2;background:#fff;border-radius:13px;min-height:66px;padding:7px 4px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;cursor:pointer;color:#3B2A21;font:inherit;font-weight:700;transition:transform .16s,border-color .16s,box-shadow .16s}
.ai-social-share-button .ai-social-icon-disc{width:32px;height:32px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 10px rgba(0,0,0,.10)}
.ai-social-share-button.is-instagram .ai-social-icon-disc{background:linear-gradient(135deg,#833AB4,#E1306C 55%,#FCAF45)}
.ai-social-share-button.is-pinterest .ai-social-icon-disc{background:#BD081C}
.ai-social-share-button.is-tiktok .ai-social-icon-disc{background:#111}
.ai-social-share-button.is-whatsapp .ai-social-icon-disc{background:#25D366}
.ai-social-share-button:hover{transform:translateY(-1px);border-color:#B8A894;box-shadow:0 5px 14px rgba(59,42,33,.05)}
.ai-social-share-button:disabled{opacity:.55;cursor:wait;transform:none}
.ai-social-share-button svg{width:18px;height:18px;display:block}
.ai-social-share-button>span:last-child{font-size:10px;white-space:nowrap}
.ai-share-utility-row{display:flex;justify-content:center;gap:7px;flex-wrap:wrap;margin-top:10px}
.ai-share-utility-row button{border:0;border-radius:999px;background:#F2ECE4;color:#3B2A21;padding:8px 12px;cursor:pointer;font:inherit;font-size:11px;font-weight:650}
.ai-whatsapp-contact{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;margin-top:12px;border:1px solid #A8C8A4;background:#F2F8EF;color:#23432A;border-radius:15px;padding:13px 16px;text-decoration:none;font-weight:750;line-height:1.25}
.ai-whatsapp-contact svg{width:21px;height:21px;flex:0 0 auto}.ai-whatsapp-contact:hover{background:#EAF4E7;border-color:#78A474}
.ai-result-processes [data-result-step-jump]{cursor:pointer}
@media(max-width:760px){
.ai-vase-source-grid{grid-template-columns:1fr}
.ai-vase-source-card{min-height:148px}
.ai-config-product-card.ai-flower-stable{min-height:286px}
.ai-flower-stable .ai-config-product-select{grid-template-rows:145px 1fr}
.ai-flower-stable .ai-config-product-image{height:145px;min-height:145px}
.ai-flower-stable .ai-config-product-body{min-height:86px;padding:9px}
.ai-vase-change-grid{grid-template-columns:repeat(2,minmax(0,1fr))}
.ai-share-code-row{flex-direction:column}
.ai-social-share-grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:5px}
.ai-studio-modal-card{padding:16px;border-radius:22px}
.ai-config-footer{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:10px!important;align-items:center!important;padding:12px 14px calc(12px + env(safe-area-inset-bottom))!important}
#configPrevButton,#configNextButton{position:static!important;inset:auto!important;width:100%!important;min-width:0!important;min-height:52px!important;margin:0!important;padding:12px 14px!important;border-radius:16px!important;justify-content:center!important}
#configPrevButton[hidden],#configNextButton[hidden]{display:none!important}
.ai-config-footer.is-step-1{grid-template-columns:1fr!important}
.ai-config-footer.is-step-1 #configNextButton{grid-column:1/-1}
.ai-result-secondary-actions{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
.ai-result-secondary-actions button{font-size:12px;padding:10px 8px}
.ai-share-preview{width:min(170px,52vw)}
}`;
document.head.appendChild(style);
}

function ensureFloeverStudioV135PolishStyles(){
const id = "floever-ai-v135-polish-styles";
if(document.getElementById(id)) return;
const style = document.createElement("style");
style.id = id;
style.textContent = `
.ai-designer-page:not(.is-welcome-screen) .ai-header{display:none!important}
.ai-designer-page:not(.is-welcome-screen){padding-top:18px!important}
.ai-designer-page:not(.is-welcome-screen) .ai-configurator{background:linear-gradient(180deg,#fffdf9 0%,#fdfaf5 100%)!important;border-color:rgba(191,163,106,.22)!important;box-shadow:0 24px 60px rgba(77,45,24,.08)!important}
.ai-designer-page:not(.is-welcome-screen) .ai-config-step-head{max-width:760px!important;margin:6px auto 22px!important;text-align:center!important}
.ai-designer-page:not(.is-welcome-screen) .ai-config-step h2{font-size:54px!important;font-weight:300!important;letter-spacing:-.02em!important}
.ai-designer-page:not(.is-welcome-screen) .ai-config-kicker{color:#b58b56!important}
.ai-vase-source-change{display:none!important}
.ai-config-footer{max-width:860px!important;margin:26px auto 0!important;padding:22px 24px!important;border:1px solid rgba(191,163,106,.24)!important;border-radius:28px!important;background:#fffdf9!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:14px!important;align-items:center!important;justify-items:center!important}
.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{width:min(100%,340px)!important;justify-content:center!important;margin:0 auto!important}
.ai-config-footer.is-step-1{grid-template-columns:1fr!important}
.ai-config-footer.is-step-1 .ai-config-next{grid-column:1/-1!important}
.ai-config-status{grid-column:1/-1!important;order:3!important;margin-top:2px!important}
.ai-config-product-card.ai-flower-stable,.ai-config-product-card-clean{overflow:hidden!important}
.ai-config-product-card-clean.is-recommended,.ai-config-product-card.ai-flower-stable.is-recommended{padding-top:0!important}
.ai-config-product-card-clean .ai-config-recommend-tab,.ai-config-product-card.ai-flower-stable .ai-config-recommend-tab{position:absolute!important;top:12px!important;right:12px!important;left:auto!important;z-index:6!important;margin:0!important;width:auto!important;min-width:0!important;height:auto!important;padding:9px 12px!important;border-radius:999px!important;border:1px solid rgba(191,163,106,.26)!important;background:rgba(245,238,223,.96)!important;color:#9a6a3f!important;font-size:11px!important;font-weight:800!important;letter-spacing:.02em!important;line-height:1!important;box-shadow:0 8px 18px rgba(77,45,24,.08)!important}
.ai-config-product-card-clean .ai-config-product-image,.ai-config-product-card.ai-flower-stable .ai-config-product-image{position:relative!important}
.ai-config-product-card.ai-flower-stable.is-selected,.ai-config-product-card-clean.is-selected{border-color:#c4b29b!important;background:#fffaf6!important;box-shadow:0 0 0 1px rgba(196,178,155,.55) inset,0 12px 28px rgba(77,45,24,.08)!important}
.ai-config-product-card.ai-flower-stable.is-selected .ai-config-qty-row,.ai-config-product-card-clean.is-selected .ai-config-qty-row{background:#f8f1e8!important;border-top:1px solid #eadfce!important}
.ai-config-product-card.ai-flower-stable .ai-config-selected-check{background:#9a6a3f!important;color:#fffaf0!important}
.ai-config-product-card.ai-flower-stable .ai-config-count-badge{border-color:#d8cab8!important;background:#fff7ee!important;color:#8a6843!important}
.ai-vase-source-card{min-height:190px!important;border-radius:24px!important;background:#fff!important}
.ai-vase-source-card strong{font-size:18px!important}
.ai-vase-source-card small{font-size:13px!important;line-height:1.5!important}
.ai-emoji-rain{position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:999999}
.ai-emoji-rain__item{position:absolute;top:-12vh;will-change:transform,opacity;animation:aiEmojiRainFall linear forwards;filter:drop-shadow(0 10px 18px rgba(0,0,0,.08));user-select:none}
@keyframes aiEmojiRainFall{0%{transform:translate3d(0,-10vh,0) rotate(0deg);opacity:0}10%{opacity:1}100%{transform:translate3d(var(--drift,0px),115vh,0) rotate(var(--rotate,120deg));opacity:0}}
@media(max-width:760px){.ai-designer-page:not(.is-welcome-screen) .ai-config-step h2{font-size:38px!important}.ai-config-footer{padding:16px 14px calc(16px + env(safe-area-inset-bottom))!important;border-radius:24px!important}.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{width:100%!important;min-height:54px!important}.ai-vase-source-card{min-height:168px!important}.ai-config-product-card-clean .ai-config-recommend-tab,.ai-config-product-card.ai-flower-stable .ai-config-recommend-tab{top:10px!important;right:10px!important;padding:8px 10px!important;font-size:10px!important}}
`;
document.head.appendChild(style);
}

function ensureFloeverStudioV137Styles(){
const id = "floever-ai-v137-layout-game-stability";
if(document.getElementById(id)) return;
const style = document.createElement("style");
style.id = id;
style.textContent = `
.ai-config-top-tools{display:grid;grid-template-columns:minmax(220px,340px) minmax(0,1fr);align-items:center;gap:16px;margin:0 0 18px;padding:0 4px}
.ai-config-top-tools #aiCreditPanel{grid-column:2;justify-self:end;margin:0!important}
.ai-share-code-global{grid-column:1;width:100%;margin:0!important;padding:0!important;border:1px solid rgba(191,163,106,.30)!important;border-radius:16px!important;background:#fffdf9!important;overflow:hidden}
.ai-share-code-global summary{list-style:none;display:flex;align-items:center;gap:10px;min-height:44px;padding:10px 14px;color:#5d4432;font-size:12px;font-weight:800;cursor:pointer}
.ai-share-code-global summary::-webkit-details-marker{display:none}
.ai-share-code-gift{width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#f4eadb;color:#9a6a3f;font-size:16px}
.ai-share-code-chevron{margin-left:auto;color:#a47c50;font-size:15px;transition:transform .18s ease}
.ai-share-code-global[open] .ai-share-code-chevron{transform:rotate(180deg)}
.ai-share-code-global .ai-share-code-row{padding:0 12px 12px;margin:0;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px}
.ai-share-code-global .ai-share-code-row input{min-height:40px}
.ai-share-code-global .ai-share-code-row button{min-height:40px;white-space:nowrap}
.ai-share-code-global .ai-share-code-status{padding:0 12px 10px;margin:0}
.ai-configurator.is-welcome .ai-config-top-tools{display:none!important}
.ai-config-footer{position:sticky!important;bottom:0!important;z-index:30!important;width:calc(100% + 36px)!important;max-width:none!important;margin:24px -18px -18px!important;padding:18px max(24px,calc((100% - 760px)/2)) calc(18px + env(safe-area-inset-bottom))!important;border-radius:26px 26px 0 0!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;grid-template-areas:"back next" "status status"!important;box-shadow:0 -12px 34px rgba(77,45,24,.09)!important}
.ai-config-footer.is-step-1{grid-template-columns:1fr!important;grid-template-areas:"next" "status"!important}
.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{width:100%!important;max-width:330px!important;min-height:52px!important;margin:0 auto!important;border-radius:16px!important;font-size:14px!important;font-weight:800!important}
.ai-config-footer .ai-back-btn{grid-area:back!important;background:#fffdf9!important;color:#5d4432!important;border-color:#dac8af!important;box-shadow:none!important}
.ai-config-footer .ai-config-next{grid-area:next!important}
.ai-config-footer .ai-config-status{grid-area:status!important}
.ai-flower-config-grid{grid-auto-rows:352px!important;align-items:stretch!important}
.ai-config-product-card.ai-flower-stable{height:352px!important;min-height:352px!important;max-height:352px!important;display:grid!important;grid-template-rows:minmax(0,1fr) 54px!important;contain:layout paint!important;transform:none!important;transition:border-color .16s ease,box-shadow .16s ease,background-color .16s ease!important}
.ai-config-product-card.ai-flower-stable:hover{transform:none!important}
.ai-flower-stable .ai-config-product-select{display:grid!important;grid-template-rows:214px minmax(0,1fr)!important;min-height:0!important;height:auto!important}
.ai-flower-stable .ai-config-product-image{height:214px!important;min-height:214px!important;padding:8px!important}
.ai-flower-stable .ai-config-product-body{height:84px!important;min-height:84px!important;max-height:84px!important;padding:9px 10px 8px!important;overflow:hidden!important;display:grid!important;grid-template-rows:auto minmax(28px,1fr) auto!important;align-content:stretch!important}
.ai-flower-stable .ai-config-product-kind{margin:0!important;align-self:start!important}
.ai-flower-stable .ai-config-product-title{height:32px!important;min-height:32px!important;max-height:32px!important;overflow:hidden!important;display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important}
.ai-flower-stable .ai-config-product-price{align-self:end!important;margin:0!important;white-space:nowrap!important}
.ai-flower-stable .ai-config-qty-row{height:54px!important;min-height:54px!important;max-height:54px!important;padding:8px 10px!important;margin:0!important;opacity:1!important}
.ai-flower-stable .ai-config-selected-check,.ai-flower-stable .ai-config-count-badge,.ai-flower-stable .ai-config-recommend-tab{position:absolute!important;z-index:7!important}
.ai-wait-game{margin:18px auto 0;max-width:760px;padding:14px;border:1px solid rgba(191,163,106,.30);border-radius:18px;background:#fffdf9;text-align:left}
.ai-wait-game-head{display:flex;align-items:center;justify-content:space-between;gap:14px;margin-bottom:10px}
.ai-wait-game-head>div:first-child span{display:block;color:#b58b56;font-size:9px;letter-spacing:.14em;text-transform:uppercase;font-weight:900}
.ai-wait-game-head strong{display:block;margin-top:2px;color:#3f2518;font-size:16px}
.ai-wait-game-score{padding:7px 10px;border-radius:999px;background:#f5ede1;color:#7b5b3e;font-size:11px;font-weight:800}
.ai-wait-game-score b{color:#17351f;font-size:14px}
.ai-wait-game-field{position:relative;height:142px;border:1px dashed #d9c7ad;border-radius:15px;background:radial-gradient(circle at 50% 45%,#fff 0,#fbf6ee 72%);overflow:hidden}
.ai-wait-game-flower{position:absolute;left:0;top:0;width:48px;height:48px;border:0;border-radius:50%;background:#fff;box-shadow:0 8px 20px rgba(77,45,24,.14);font-size:25px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .26s ease,box-shadow .16s ease}
.ai-wait-game-flower.is-caught{box-shadow:0 0 0 8px rgba(191,163,106,.12),0 8px 20px rgba(77,45,24,.14)}
.ai-wait-game>small{display:block;margin-top:8px;color:#8b796a;font-size:10.5px;text-align:center}
@media(max-width:760px){
.ai-config-top-tools{grid-template-columns:minmax(0,1fr) auto;gap:8px;padding:0;margin-bottom:12px}
.ai-config-top-tools #aiCreditPanel{grid-column:2;max-width:148px}
.ai-share-code-global{grid-column:1;min-width:0}
.ai-share-code-global summary{min-height:40px;padding:8px 10px;font-size:10px}
.ai-share-code-global summary span:nth-child(2){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.ai-share-code-gift{width:23px;height:23px;font-size:13px}
.ai-share-code-global[open]{grid-column:1/-1}
.ai-config-footer{width:calc(100% + 20px)!important;margin:16px -10px -10px!important;padding:12px 10px calc(12px + env(safe-area-inset-bottom))!important;gap:8px!important;border-radius:20px 20px 0 0!important}
.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{max-width:none!important;min-height:50px!important;font-size:12px!important;padding:10px 8px!important}
.ai-flower-config-grid{grid-auto-rows:300px!important}
.ai-config-product-card.ai-flower-stable{height:300px!important;min-height:300px!important;max-height:300px!important;grid-template-rows:minmax(0,1fr) 48px!important}
.ai-flower-stable .ai-config-product-select{grid-template-rows:164px minmax(0,1fr)!important}
.ai-flower-stable .ai-config-product-image{height:164px!important;min-height:164px!important}
.ai-flower-stable .ai-config-product-body{height:82px!important;min-height:82px!important;max-height:82px!important;padding:8px!important}
.ai-flower-stable .ai-config-qty-row{height:48px!important;min-height:48px!important;max-height:48px!important;padding:6px!important}
.ai-wait-game-field{height:122px}
}
`;
document.head.appendChild(style);
}

function ensureFloeverStudioV139FixStyles(){
const id = "floever-ai-v139-card-footer-share-fix";
if(document.getElementById(id)) return;
const style = document.createElement("style");
style.id = id;
style.textContent = `
.ai-designer-page{--floever-action-gradient:linear-gradient(135deg,#0d5a36 0%,#176b43 52%,#0b4d2f 100%)}
.ai-btn,.ai-btn-primary,.ai-credit-buy-btn,.ai-credit-package-btn,.ai-download-btn,.ai-followup-btn,.ai-result-update-btn,.ai-config-next,.ai-config-generate,.ai-recommendation-add,.ai-share-code-row button{background:var(--floever-action-gradient)!important;border-color:rgba(13,90,54,.48)!important;color:#fffaf0!important;box-shadow:0 12px 24px rgba(13,90,54,.18)!important}
.ai-configurator-progress button.is-active{background:var(--floever-action-gradient)!important;border-color:rgba(13,90,54,.48)!important}
.ai-config-footer:before,.ai-config-footer:after{display:none!important;content:none!important}
.ai-config-footer{position:sticky!important;bottom:0!important;z-index:30!important;width:100%!important;max-width:900px!important;margin:24px auto 0!important;padding:16px!important;border:1px solid rgba(191,163,106,.25)!important;border-radius:22px!important;background:rgba(255,253,249,.97)!important;box-shadow:0 -10px 28px rgba(77,45,24,.08)!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;grid-template-areas:"back next" "status status"!important;gap:12px!important;box-sizing:border-box!important}
.ai-config-footer.is-step-1{grid-template-columns:1fr!important;grid-template-areas:"next" "status"!important}
.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{width:100%!important;max-width:330px!important;min-height:52px!important;margin:0 auto!important;padding:12px 18px!important;border-radius:16px!important;font-size:14px!important;font-weight:800!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;line-height:1.15!important;box-sizing:border-box!important}
.ai-config-footer .ai-back-btn{grid-area:back!important;background:#fffdf9!important;color:#624936!important;border:1px solid #d9c6aa!important;box-shadow:none!important}
.ai-config-footer .ai-config-next{grid-area:next!important}
.ai-config-footer .ai-config-status{grid-area:status!important;margin:0!important;padding:0!important;min-height:0!important}
.ai-config-footer .ai-config-status:empty{display:none!important}
.ai-flower-config-grid{grid-auto-rows:350px!important;align-items:stretch!important}
.ai-config-product-card.ai-flower-stable{width:100%!important;height:350px!important;min-height:350px!important;max-height:350px!important;margin:0!important;padding:0!important;display:grid!important;grid-template-rows:296px 54px!important;overflow:hidden!important;contain:layout paint!important;transform:none!important;transition:border-color .14s ease,box-shadow .14s ease,background-color .14s ease!important;border-radius:18px!important}
.ai-config-product-card.ai-flower-stable:hover{transform:none!important}
.ai-config-product-card.ai-flower-stable.is-recommended{margin:0!important;padding:0!important}
.ai-flower-stable .ai-config-product-select{height:296px!important;min-height:296px!important;display:grid!important;grid-template-rows:206px 90px!important;overflow:hidden!important}
.ai-flower-stable .ai-config-product-image{width:100%!important;height:206px!important;min-height:206px!important;max-height:206px!important;padding:10px!important;background:#fff!important;overflow:hidden!important}
.ai-flower-stable .ai-config-product-image img{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important}
.ai-flower-stable .ai-config-product-body{width:100%!important;height:90px!important;min-height:90px!important;max-height:90px!important;padding:8px 10px 9px!important;display:grid!important;grid-template-rows:18px 32px 22px!important;gap:3px!important;overflow:hidden!important;align-content:start!important;background:#fffdf9!important;box-sizing:border-box!important}
.ai-flower-stable .ai-config-product-kind{display:inline-flex!important;justify-self:start!important;align-self:center!important;width:max-content!important;max-width:100%!important;margin:0!important;padding:4px 8px!important;border-radius:999px!important;font-size:9.5px!important;line-height:1!important;white-space:nowrap!important;background:#f3e6d1!important;color:#956937!important}
.ai-flower-stable .ai-config-product-title{width:100%!important;height:32px!important;min-height:32px!important;max-height:32px!important;margin:0!important;font-size:13px!important;line-height:16px!important;overflow:hidden!important;display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important}
.ai-flower-stable .ai-config-product-price{height:22px!important;margin:0!important;align-self:end!important;font-size:15px!important;line-height:22px!important;white-space:nowrap!important}
.ai-flower-stable .ai-config-qty-row{width:100%!important;height:54px!important;min-height:54px!important;max-height:54px!important;margin:0!important;padding:8px 10px!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#fbf5ec!important;border-top:1px solid #eadfce!important;box-sizing:border-box!important;opacity:1!important}
.ai-flower-stable .ai-config-stepper{height:36px!important;align-items:center!important}
.ai-config-product-card.ai-flower-stable.is-selected{border-color:#b99161!important;background:#fffaf4!important;box-shadow:0 0 0 1px rgba(185,145,97,.45) inset,0 8px 20px rgba(77,45,24,.08)!important}
.ai-config-product-card.ai-flower-stable.is-selected .ai-config-product-body{background:#fffaf4!important}
.ai-config-product-card.ai-flower-stable.is-selected .ai-config-qty-row{background:#f7ecdd!important}
.ai-flower-stable .ai-config-selected-check{display:none!important}
.ai-config-product-card.ai-flower-stable.is-selected::after{content:"Seçildi"!important;position:absolute!important;top:10px!important;right:10px!important;z-index:8!important;min-height:28px!important;padding:7px 10px!important;border-radius:999px!important;background:var(--floever-action-gradient)!important;color:#fffaf0!important;font-size:10px!important;font-weight:800!important;line-height:1!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;box-shadow:0 8px 16px rgba(13,90,54,.18)!important}
.ai-flower-stable .ai-config-count-badge{right:9px!important;bottom:61px!important;border:1px solid #dcc8aa!important;background:#fff8ee!important;color:#8b6138!important;box-shadow:none!important}
.ai-flower-stable .ai-config-recommend-tab{top:10px!important;right:10px!important;left:auto!important;min-height:28px!important;padding:7px 10px!important;background:#fff4df!important;border:1px solid #ead2aa!important;color:#9b6a31!important;box-shadow:0 7px 15px rgba(77,45,24,.07)!important}
.ai-config-top-tools{grid-template-columns:minmax(260px,380px) minmax(0,1fr)!important;gap:18px!important;align-items:start!important;margin-bottom:18px!important}
.ai-share-code-global{width:100%!important;max-width:380px!important;border-radius:18px!important;background:#fffdf9!important;box-shadow:0 7px 18px rgba(77,45,24,.04)!important}
.ai-share-code-global summary{min-height:48px!important;padding:10px 13px!important;font-size:12px!important;line-height:1.2!important}
.ai-share-code-gift{width:28px!important;height:28px!important;background:#f2e5d2!important;color:#9a6a3f!important;font-size:15px!important}
.ai-share-code-global .ai-share-code-row{padding:0 12px 12px!important;display:grid!important;grid-template-columns:minmax(0,1fr) 112px!important;gap:8px!important;align-items:center!important}
.ai-share-code-global .ai-share-code-row input{width:100%!important;min-width:0!important;height:44px!important;min-height:44px!important;padding:10px 12px!important;border:1px solid #ddceb9!important;border-radius:12px!important;background:#fff!important;color:#3f2518!important;font-size:13px!important;box-shadow:none!important}
.ai-share-code-global .ai-share-code-row button{width:112px!important;height:44px!important;min-height:44px!important;padding:9px 10px!important;border-radius:12px!important;font-size:12px!important;white-space:nowrap!important}
.ai-share-code-global .ai-share-code-status{padding:0 12px 10px!important;font-size:11px!important}
@media(max-width:760px){
#configFlowerRecommendations{display:none!important}
.ai-config-footer{width:calc(100% + 20px)!important;max-width:none!important;margin:14px -10px -10px!important;padding:10px 10px calc(10px + env(safe-area-inset-bottom))!important;border-radius:18px 18px 0 0!important;gap:8px!important}
.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{max-width:none!important;min-height:48px!important;padding:10px 6px!important;border-radius:14px!important;font-size:11.5px!important}
.ai-flower-config-grid{grid-auto-rows:294px!important;gap:10px!important}
.ai-config-product-card.ai-flower-stable{height:294px!important;min-height:294px!important;max-height:294px!important;grid-template-rows:246px 48px!important;border-radius:16px!important}
.ai-flower-stable .ai-config-product-select{height:246px!important;min-height:246px!important;grid-template-rows:158px 88px!important}
.ai-flower-stable .ai-config-product-image{height:158px!important;min-height:158px!important;max-height:158px!important;padding:7px!important}
.ai-flower-stable .ai-config-product-body{height:88px!important;min-height:88px!important;max-height:88px!important;padding:7px 8px 8px!important;grid-template-rows:17px 31px 21px!important;gap:3px!important}
.ai-flower-stable .ai-config-product-title{font-size:11.5px!important;line-height:15px!important;height:30px!important;min-height:30px!important;max-height:30px!important}
.ai-flower-stable .ai-config-product-price{font-size:12.5px!important;line-height:21px!important}
.ai-flower-stable .ai-config-qty-row{height:48px!important;min-height:48px!important;max-height:48px!important;padding:6px!important}
.ai-flower-stable .ai-config-count-badge{bottom:54px!important;font-size:9px!important;padding:4px 7px!important}
.ai-config-product-card.ai-flower-stable.is-selected::after,.ai-flower-stable .ai-config-recommend-tab{top:7px!important;right:7px!important;min-height:24px!important;padding:6px 8px!important;font-size:9px!important}
.ai-config-top-tools{grid-template-columns:minmax(0,1fr) auto!important;gap:8px!important;align-items:start!important}
.ai-share-code-global{max-width:none!important}
.ai-share-code-global summary{min-height:40px!important;padding:7px 9px!important;font-size:10px!important}
.ai-share-code-gift{width:23px!important;height:23px!important;font-size:12px!important}
.ai-share-code-global[open]{grid-column:1/-1!important}
.ai-share-code-global .ai-share-code-row{grid-template-columns:minmax(0,1fr) 96px!important;padding:0 9px 9px!important;gap:6px!important}
.ai-share-code-global .ai-share-code-row input{height:40px!important;min-height:40px!important;font-size:11px!important;padding:8px 9px!important}
.ai-share-code-global .ai-share-code-row button{width:96px!important;height:40px!important;min-height:40px!important;font-size:10px!important;padding:7px 6px!important}
}
`;
document.head.appendChild(style);
}

function ensureFloeverStudioV140Styles(){
const id="floever-ai-v140-final-polish";
if(document.getElementById(id)) return;
const style=document.createElement("style");
style.id=id;
style.textContent=`
:root{--floever-order-orange:#a95526;--floever-order-orange-2:#c06a30}
.ai-config-footer{grid-template-columns:330px 330px!important;gap:0!important;justify-content:center!important}
.ai-config-footer .ai-back-btn,.ai-config-footer .ai-config-next{max-width:none!important;width:100%!important;margin:0!important}
.ai-config-footer .ai-back-btn{border-radius:17px 0 0 17px!important;border-right-width:0!important}
.ai-config-footer .ai-config-next{border-radius:0 17px 17px 0!important}
.ai-config-footer.is-step-1{grid-template-columns:360px!important}
.ai-config-footer.is-step-1 .ai-config-next{border-radius:17px!important}
.ai-card-gallery{position:relative!important}
.ai-card-gallery-image{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important;opacity:0!important;transition:opacity .22s ease!important;background:#fff!important}
.ai-card-gallery-image.is-active{opacity:1!important}
.ai-card-gallery-toggle{position:absolute!important;z-index:9!important;right:9px!important;top:172px!important;min-width:48px!important;height:28px!important;padding:0 8px!important;border:1px solid rgba(191,163,106,.35)!important;border-radius:999px!important;background:rgba(255,253,249,.94)!important;color:#78583b!important;box-shadow:0 5px 14px rgba(77,45,24,.09)!important;font:inherit!important;font-size:9.5px!important;font-weight:800!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:4px!important;cursor:pointer!important}
.ai-card-gallery-icon{font-size:10px!important;color:#a16f3d!important}
.ai-card-gallery-dots{position:absolute!important;z-index:8!important;left:50%!important;top:194px!important;transform:translateX(-50%)!important;display:flex!important;gap:4px!important;pointer-events:none!important}
.ai-card-gallery-dots i{width:5px!important;height:5px!important;border-radius:50%!important;background:#d9cdbd!important}
.ai-card-gallery-dots i.is-active{background:#9a6a3f!important}
.ai-vase-product-card .ai-card-gallery-toggle{top:auto!important;bottom:88px!important}
.ai-vase-product-card .ai-card-gallery-dots{top:auto!important;bottom:91px!important}
.ai-vase-change-modal-card{width:min(720px,100%)!important;padding:24px!important}
.ai-modal-kicker{display:block;margin:0 0 5px;color:#b27338;font-size:9px;letter-spacing:.14em;text-transform:uppercase;font-weight:900}
.ai-studio-modal-head h3{font-family:'Cormorant Garamond',Georgia,serif!important;font-size:34px!important;font-weight:500!important;color:#3f2518!important}
.ai-studio-modal-head p{margin:7px 0 0;color:#79695c;font-size:12px;line-height:1.5}
.ai-vase-price-info{display:flex;gap:12px;align-items:flex-start;margin:4px 0 16px;padding:12px 14px;border:1px solid #ead8bd;border-radius:16px;background:#fff8ed;color:#6a4930}
.ai-vase-price-info>span{width:30px;height:30px;border-radius:50%;background:#b96b32;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:900;flex:0 0 auto}
.ai-vase-price-info strong{display:block;font-size:12px;color:#5f3a22}
.ai-vase-price-info small{display:block;margin-top:3px;font-size:11px;line-height:1.45;color:#80634e}
.ai-vase-change-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:10px!important;max-height:390px;overflow:auto;padding:2px 3px 4px}
.ai-vase-change-option{position:relative!important;display:flex!important;flex-direction:column!important;min-height:190px!important;padding:8px!important;border:1px solid #e2d3c0!important;border-radius:18px!important;background:#fff!important;overflow:hidden!important;transition:border-color .16s ease,box-shadow .16s ease,background .16s ease!important}
.ai-vase-change-option:hover{border-color:#c5a67e!important;box-shadow:0 8px 20px rgba(77,45,24,.08)!important}
.ai-vase-change-option.is-selected{border-color:#38704b!important;background:#f7faf5!important;box-shadow:0 0 0 1px rgba(56,112,75,.24) inset!important}
.ai-vase-change-image{position:relative;display:block;width:100%;height:125px;border-radius:13px;background:#f8f4ee;overflow:hidden}
.ai-vase-change-image img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:8px;transition:opacity .22s ease}
.ai-vase-change-image .is-secondary{opacity:0}
.ai-vase-change-option:hover .ai-vase-change-image.has-second-image .is-primary{opacity:0}
.ai-vase-change-option:hover .ai-vase-change-image.has-second-image .is-secondary{opacity:1}
.ai-vase-change-image em{position:absolute;right:7px;bottom:7px;padding:4px 6px;border-radius:999px;background:rgba(255,255,255,.9);color:#76563a;font-size:8px;font-style:normal;font-weight:800}
.ai-vase-change-copy{display:block;padding:8px 3px 1px;text-align:left}
.ai-vase-change-copy strong{display:block;font-size:12px!important;color:#34251c!important;line-height:1.25}
.ai-vase-change-copy small{display:block;margin-top:3px;font-size:10px!important;color:#8b6847!important}
.ai-vase-change-selected{position:absolute;top:10px;right:10px;width:24px;height:24px;border-radius:50%;background:#2f6843;color:#fff;display:none;align-items:center;justify-content:center;font-size:12px;box-shadow:0 5px 12px rgba(47,104,67,.22)}
.ai-vase-change-option.is-selected .ai-vase-change-selected{display:flex}
.ai-vase-own-upload{position:relative;display:grid;grid-template-columns:42px minmax(0,1fr) auto;align-items:center;gap:12px;margin:14px 0 0;padding:13px 14px;border:1.5px dashed #d4bea0;border-radius:17px;background:#fffaf3;cursor:pointer;transition:border-color .16s,background .16s}
.ai-vase-own-upload:hover,.ai-vase-own-upload.is-selected{border-color:#9d6a3e;background:#fff6e9}
.ai-vase-own-upload input{position:absolute;inset:0;opacity:0;cursor:pointer}
.ai-vase-own-upload-icon{width:42px;height:42px;border-radius:13px;background:#f2e3cf;display:flex;align-items:center;justify-content:center;font-size:20px}
.ai-vase-own-upload-copy strong{display:block;color:#3d2b20;font-size:13px}
.ai-vase-own-upload-copy small{display:block;margin-top:2px;color:#806d5f;font-size:10.5px}
.ai-vase-own-upload-copy em{display:block;margin-top:4px;color:#a05d28;font-size:10px;font-style:normal;font-weight:700;max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.ai-vase-own-upload-action{padding:8px 11px;border-radius:11px;background:#fff;color:#6f4d32;border:1px solid #ddc7a8;font-size:10px;font-weight:800}
.ai-vase-change-actions{margin-top:14px!important;padding-top:14px;border-top:1px solid #eee2d4}
.ai-vase-change-actions button{min-height:44px!important}
#configShareDesignModal .ai-studio-modal-card{width:min(620px,100%)!important}
#configShareDesignModal .ai-studio-modal-head{padding-bottom:13px;border-bottom:1px solid #eee3d6}
.ai-wait-game-stats{display:flex;gap:7px;align-items:center}
.ai-wait-game-level{padding:7px 10px;border-radius:999px;background:#f1e6d7;color:#76583e;font-size:11px;font-weight:800}
.ai-wait-game-level b{color:#9a5a28;font-size:14px}
.ai-wait-game-flower{transition:transform .16s ease,box-shadow .12s ease,width .18s ease,height .18s ease,font-size .18s ease!important}
.ai-order-btn{background:linear-gradient(135deg,var(--floever-order-orange),var(--floever-order-orange-2))!important;border-color:#91431d!important;color:#fffaf5!important;box-shadow:0 12px 25px rgba(154,76,31,.24)!important}
.ai-order-btn:hover{filter:brightness(1.05)!important;box-shadow:0 15px 30px rgba(154,76,31,.30)!important}
.ai-share-code-chevron{width:24px!important;height:24px!important;margin-left:auto!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;flex:0 0 24px!important;color:#9a6a3f!important}
.ai-share-code-chevron svg{display:block;width:18px;height:18px}
.ai-share-code-global[open] .ai-share-code-chevron{transform:rotate(180deg)!important}
@media(max-width:760px){
.ai-config-footer{grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:0!important}
.ai-config-footer .ai-back-btn{border-radius:14px 0 0 14px!important}
.ai-config-footer .ai-config-next{border-radius:0 14px 14px 0!important}
.ai-config-footer.is-step-1{grid-template-columns:1fr!important}
.ai-config-footer.is-step-1 .ai-config-next{border-radius:14px!important}
.ai-card-gallery-toggle{top:126px!important;right:6px!important;height:24px!important;min-width:43px!important;padding:0 6px!important;font-size:8.5px!important}
.ai-card-gallery-dots{top:145px!important}
.ai-vase-product-card .ai-card-gallery-toggle{top:auto!important;bottom:80px!important}
.ai-vase-product-card .ai-card-gallery-dots{top:auto!important;bottom:83px!important}
.ai-vase-change-modal-card{padding:17px!important}
.ai-vase-change-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;max-height:360px}
.ai-vase-change-option{min-height:165px!important}
.ai-vase-change-image{height:102px}
.ai-vase-own-upload{grid-template-columns:36px minmax(0,1fr);gap:9px;padding:11px}
.ai-vase-own-upload-icon{width:36px;height:36px;font-size:17px}
.ai-vase-own-upload-action{grid-column:1/-1;text-align:center}
.ai-wait-game-stats{gap:4px}.ai-wait-game-score,.ai-wait-game-level{padding:6px 8px;font-size:9px}
}
`;
document.head.appendChild(style);
}

function readGameReward(){
if(window.FLOEVER_GAME_REWARD) return window.FLOEVER_GAME_REWARD;
try{
const parsed=JSON.parse(localStorage.getItem("floever_ai_game_reward_v1")||"null");
if(parsed && parsed.token && (!parsed.expiresAt || parsed.expiresAt>Date.now())){ window.FLOEVER_GAME_REWARD=parsed; return parsed; }
}catch(error){}
return null;
}
function cleanNewDesignQueryParam(){
/* Eski menü bağlantılarında kalmış olabilecek floever_new parametresi artık sıfırlama yapmaz. */
try{
const url=new URL(window.location.href);
if(url.searchParams.get("floever_new")!=="1") return;
url.searchParams.delete("floever_new");
window.history.replaceState({},document.title,url.pathname+(url.search?url.search:"")+url.hash);
}catch(error){}
}
function cleanSharedDesignNavigationState(){
try{
const url=new URL(window.location.href);
url.searchParams.delete("floever_share");
url.searchParams.delete("floever_new");
window.history.replaceState({},document.title,url.pathname+(url.search?url.search:"")+url.hash);
}catch(error){}
window.__floeverShareUrlLoaded=true;
["configGlobalShareCodeInput","configShareCodeInput"].forEach(function(id){
const input=document.getElementById(id); if(input) input.value="";
});
["configGlobalShareCodeStatus","configShareCodeStatus"].forEach(function(id){
const status=document.getElementById(id); if(status) status.textContent=floeverAiI18n.text("");
});
}
function startFreshDesignFlow(options){
const opts=options||{};
const shouldConfirm=opts.confirm!==false && hasMeaningfulConfiguratorState();
if(shouldConfirm && !window.confirm(floeverAiI18n.text("Yeni bir aranjmana başlamak için mevcut vazo, çiçek, tarz ve sonuç seçimleri silinsin mi?"))) return false;
cleanSharedDesignNavigationState();
resetConfiguratorCompletely({showSetup:true});
welcomeDismissedForCurrentPage=false;
showSetupView();
setWelcomeScreenVisible(true);
window.requestAnimationFrame(function(){ window.scrollTo({top:0,behavior:opts.instant?"auto":"smooth"}); });
return true;
}

function ensureNewDesignControl(){
if(!configEls.root) return null;
let bar=document.getElementById("configNewDesignBar");
if(bar) return bar;
bar=document.createElement("div");
bar.id="configNewDesignBar";
bar.className="ai-new-design-bar";
bar.innerHTML=floeverAiI18n.html('<button type="button" id="configNewDesignButton"><span>＋</span><strong>Yeni Tasarım</strong><small>Tüm seçimleri sıfırla</small></button>');
const progress=configEls.root.querySelector(".ai-configurator-progress");
if(progress) configEls.root.insertBefore(bar,progress); else configEls.root.insertBefore(bar,configEls.root.firstChild);
const button=bar.querySelector("#configNewDesignButton");
button.addEventListener("click",function(){
startFreshDesignFlow({confirm:true});
});
return bar;
}
function openFlowerEditorFromResult(){
clearConfiguratorCompletedResultState({clearResultBox:true,save:false});
showSetupView();
setConfigStep(2,{instant:true});
renderConfigFlowers();
renderConfigSummary();
scheduleConfiguratorStateSave();
}

function ensureVaseSourceDecisionUi(){
ensureFloeverStudioV127Styles();
ensureFloeverStudioV135PolishStyles();
ensureFloeverStudioV137Styles();
ensureFloeverStudioV139FixStyles();
ensureFloeverStudioV140Styles();
let box = document.getElementById("configVaseSourceDecision");
if(box) return box;
const step = document.querySelector('[data-config-step="1"]') || configEls.root;
if(!step) return null;
box = document.createElement("section");
box.id = "configVaseSourceDecision";
box.className = "ai-vase-source-decision";
box.innerHTML = floeverAiI18n.html(`
<h3>Aranjmanı hangi vazoda hazırlayalım?</h3>
<p>Önce vazo kaynağını seçin. Sonraki seçimlerinize geri dönerek dilediğiniz zaman değiştirebilirsiniz.</p>
<div class="ai-vase-source-grid">
<button type="button" class="ai-vase-source-card" data-vase-source-choice="floever">
<span class="ai-vase-source-check">✓</span><span class="ai-vase-source-icon">🏺</span>
<strong>Floever’dan Vazo Seç</strong><small>Floever vazo koleksiyonunu açar. Seçtiğiniz vazonun güncel fiyatı toplam tutara eklenir.</small>
</button>
<button type="button" class="ai-vase-source-card" data-vase-source-choice="own">
<span class="ai-vase-source-check">✓</span><span class="ai-vase-source-icon">📷</span>
<strong>Kendi Vazomu Kullan</strong><small>Vazonuzu önden, sade arka planda ve iyi ışıkta çekerek yükleyin. Vazo fiyatı eklenmez.</small>
</button>
</div>
`);
const firstPanel = configEls.floeverVasePanel || configEls.ownVasePanel;
if(firstPanel && firstPanel.parentNode) firstPanel.parentNode.insertBefore(box, firstPanel);
else step.insertBefore(box, step.firstChild);
Array.prototype.forEach.call(box.querySelectorAll("[data-vase-source-choice]"), function(button){
button.addEventListener("click", function(){
configState.vaseMode = button.getAttribute("data-vase-source-choice") === "own" ? "own" : "floever";
configState.vaseSourceChosen = true;
if(configState.vaseMode === "own") configState.selectedVaseId = "";
invalidateCompositionRecommendations();
syncVaseSourceDecisionUi();
renderConfigVases();
renderConfigSummary();
scheduleConfiguratorStateSave();
window.requestAnimationFrame(function(){
const panel = configState.vaseMode === "own" ? configEls.ownVasePanel : configEls.floeverVasePanel;
if(panel && panel.scrollIntoView) panel.scrollIntoView({behavior:"smooth",block:"nearest"});
});
});
});
const change = box.querySelector("#configChangeVaseSource");
if(change) change.addEventListener("click", function(){
configState.vaseSourceChosen = false;
syncVaseSourceDecisionUi();
scheduleConfiguratorStateSave();
});
return box;
}

function bindShareCodeEntryUi(entry){
if(!entry) return null;
if(entry.dataset.toggleBound !== "true"){
entry.dataset.toggleBound = "true";
entry.addEventListener("toggle", function(){ if(entry.open) entry.dataset.userOpened = "true"; });
}
const button = entry.querySelector("[data-share-code-load], #configShareCodeLoad");
const input = entry.querySelector("[data-share-code-input], #configShareCodeInput");
const status = entry.querySelector("[data-share-code-status], #configShareCodeStatus");
if(button && button.dataset.bound !== "true"){
button.dataset.bound = "true";
button.addEventListener("click", function(){
void loadSharedDesignByCode(input ? input.value : "", status);
});
}
if(input && input.dataset.bound !== "true"){
input.dataset.bound = "true";
input.addEventListener("keydown", function(event){
if(event.key === "Enter"){
event.preventDefault();
void loadSharedDesignByCode(input.value, status);
}
});
}
return entry;
}
function ensureConfigTopTools(){
let tools = document.getElementById("configTopTools");
if(!tools){
tools = document.createElement("div");
tools.id = "configTopTools";
tools.className = "ai-config-top-tools";
const progress = configEls.root && configEls.root.querySelector(".ai-configurator-progress");
if(configEls.root){
if(progress) configEls.root.insertBefore(tools, progress);
else configEls.root.insertBefore(tools, configEls.root.firstChild);
}
}
return tools;
}
function ensureShareCodeEntryUi(){
/* Karşılama ekranındaki mevcut kod alanı yerinde kalır. */
bindShareCodeEntryUi(document.getElementById("configShareCodeEntry"));
const tools = ensureConfigTopTools();
let entry = document.getElementById("configGlobalShareCodeEntry");
if(!entry){
entry = document.createElement("details");
entry.id = "configGlobalShareCodeEntry";
entry.className = "ai-share-code-entry ai-share-code-global";
entry.innerHTML = floeverAiI18n.html(`<summary><span class="ai-share-code-gift" aria-hidden="true">✦</span><span>Aranjman kodum var mı?</span><span class="ai-share-code-chevron" aria-hidden="true"><svg viewBox="0 0 20 20" focusable="false"><path d="M5.5 7.5 10 12l4.5-4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span></summary>
<div class="ai-share-code-row"><input id="configGlobalShareCodeInput" data-share-code-input maxlength="16" placeholder="Örn: FLO-8H3K" autocomplete="off" aria-label="Aranjman kodu"><button type="button" id="configGlobalShareCodeLoad" data-share-code-load>Tasarımı Aç</button></div>
<div class="ai-share-code-status" id="configGlobalShareCodeStatus" data-share-code-status aria-live="polite"></div>`);
}
if(tools && entry.parentNode !== tools) tools.insertBefore(entry, tools.firstChild);
if(tools && creditPanel && creditPanel.parentNode !== tools) tools.appendChild(creditPanel);
return bindShareCodeEntryUi(entry);
}

function syncVaseSourceDecisionUi(){
const box = ensureVaseSourceDecisionUi();
const shareEntry = ensureShareCodeEntryUi();
if(shareEntry && !shareEntry.dataset.userOpened){ shareEntry.open = false; }
if(!box) return;
Array.prototype.forEach.call(document.querySelectorAll("[data-vase-mode]"), function(button){
button.hidden = true;
button.style.display = "none";
});
Array.prototype.forEach.call(box.querySelectorAll("[data-vase-source-choice]"), function(button){
const selected = configState.vaseSourceChosen && button.getAttribute("data-vase-source-choice") === configState.vaseMode;
button.classList.toggle("is-selected", selected);
button.setAttribute("aria-pressed", selected ? "true" : "false");
});
const change = box.querySelector("#configChangeVaseSource");
if(change) change.hidden = !configState.vaseSourceChosen;
if(configEls.floeverVasePanel) configEls.floeverVasePanel.hidden = !(configState.vaseSourceChosen && configState.vaseMode === "floever");
if(configEls.ownVasePanel) configEls.ownVasePanel.hidden = !(configState.vaseSourceChosen && configState.vaseMode === "own");
}

function preserveFlowerGridViewport(renderOperation){
const grid = configEls.flowerGrid;
if(!grid){ renderOperation(); return; }
const beforeGridTop = grid.getBoundingClientRect().top;
const active = document.activeElement;
const activeKey = active && (active.getAttribute("data-config-flower-qty") || active.getAttribute("data-config-flower-toggle") || active.getAttribute("data-config-flower-minus") || active.getAttribute("data-config-flower-plus"));
const activeAttr = active && ["data-config-flower-qty","data-config-flower-toggle","data-config-flower-minus","data-config-flower-plus"].find(function(attr){ return active.hasAttribute && active.hasAttribute(attr); });
const activeCard = active && active.closest ? active.closest(".ai-config-product-card") : null;
const beforeCardTop = activeCard ? activeCard.getBoundingClientRect().top : null;
renderOperation();
window.requestAnimationFrame(function(){
let delta = 0;
let next = null;
if(activeKey && activeAttr){
next = grid.querySelector("[" + activeAttr + '="' + cssEscapeForSelector(activeKey) + '"]');
const nextCard = next && next.closest ? next.closest(".ai-config-product-card") : null;
if(nextCard && beforeCardTop !== null) delta = nextCard.getBoundingClientRect().top - beforeCardTop;
}
if(!delta){
const afterGridTop = grid.getBoundingClientRect().top;
delta = afterGridTop - beforeGridTop;
}
if(Math.abs(delta) > 1) window.scrollBy(0, delta);
if(next && next.focus) next.focus({preventScroll:true});
});
}

function renderConfigFlowers(){
if(!configEls.flowerGrid) return;
const recommendationBox = ensureFlowerRecommendationsBox();
if(!configState.flowers.length){
if(recommendationBox){ recommendationBox.innerHTML = floeverAiI18n.html(""); recommendationBox.hidden = true; }
configEls.flowerGrid.innerHTML = floeverAiI18n.html("");
configEls.flowerGrid.classList.remove("is-single","is-duo");
if(configEls.flowerStatus){ configEls.flowerStatus.hidden = false; configEls.flowerStatus.textContent = floeverAiI18n.text("Henüz çiçek eklenmedi."); }
return;
}
const visibleFlowers = configState.flowers.filter(flowerMatchesFilters);
if(configEls.flowerStatus) configEls.flowerStatus.textContent = floeverAiI18n.text("");
refreshFlowerRecommendations();
const selectedObjects = selectedConfigFlowerObjects();
const analysis = analyzeArrangementCompletion(selectedObjects);
const limit = analysis.productCount <= 1 ? 3 : analysis.productCount <= 3 ? 2 : 1;
const recommended = selectedObjects.length && !analysis.isComplete ? getRecommendedConfigFlowers(limit, "card") : [];
const recommendedInfoMap = new Map(recommended.map(function(item,index){ return [String(item.flower.id), {rank:index+1,reason:recommendationReasonForFlower(item.flower,item.meta||{})}]; }));
preserveFlowerGridViewport(function(){
configEls.flowerGrid.classList.toggle("is-single", visibleFlowers.length === 1);
configEls.flowerGrid.classList.toggle("is-duo", visibleFlowers.length === 2);
if(!visibleFlowers.length){
configEls.flowerGrid.innerHTML = floeverAiI18n.html('<div class="ai-message">Bu filtrelere uygun çiçek bulunamadı.</div>');
return;
}
configEls.flowerGrid.innerHTML = floeverAiI18n.html(visibleFlowers.map(function(flower,index){
const qty = Number(configState.selectedFlowers.get(String(flower.id)) || 0);
const selected = qty > 0;
const price = flower.priceLabel || (flower.priceAmount ? formatTry(flower.priceAmount) : "Fiyat yok");
const kind = getConfigFlowerKindLabel(flower);
const recommendationInfo = recommendedInfoMap.get(String(flower.id));
const gallery = renderProductCardImageGallery(flower,"flower",index);
return `<article class="ai-config-product-card ai-config-product-card-clean ai-flower-stable ${selected ? "is-selected" : ""} ${recommendationInfo && !selected ? "is-recommended" : ""}">
${recommendationInfo && !selected ? `<div class="ai-config-recommend-tab" title="${escapeHtml(recommendationInfo.reason || "Seçiminize göre önerildi")}">Uyumlu</div>` : ""}
${selected ? `<span class="ai-config-selected-check" aria-hidden="true">✓</span>` : ""}
<button type="button" class="ai-config-product-select" data-config-flower-toggle="${escapeHtml(flower.id)}" aria-pressed="${selected ? "true" : "false"}">
<div class="ai-config-product-image ai-card-gallery" data-card-gallery-key="${escapeHtml(gallery.key)}">${gallery.imagesHtml}</div>
<div class="ai-config-product-body"><div class="ai-config-product-kind">${escapeHtml(kind)}</div><div class="ai-config-product-title">${escapeHtml(flower.name)}</div><div class="ai-config-product-price">${escapeHtml(price)} <small>/ adet</small></div></div>
</button>
${gallery.controlsHtml}
<div class="ai-config-qty-row ai-config-qty-clean"><span>Adet</span><div class="ai-config-stepper">
<button type="button" data-config-flower-minus="${escapeHtml(flower.id)}" aria-label="Adet azalt">−</button>
<input type="number" min="0" max="99" value="${qty}" data-config-flower-qty="${escapeHtml(flower.id)}" inputmode="numeric">
<button type="button" data-config-flower-plus="${escapeHtml(flower.id)}" aria-label="Adet artır">+</button>
</div></div></article>`;
}).join(""));
});
bindProductCardGalleries(configEls.flowerGrid);
function commitFlower(id, quantity){
const flowerId = String(id || "");
const activeControl = configEls.flowerGrid ? configEls.flowerGrid.querySelector('[data-config-flower-toggle="' + cssEscapeForSelector(flowerId) + '"]') : null;
const activeCard = activeControl && activeControl.closest ? activeControl.closest(".ai-config-product-card") : null;
const beforeTop = activeCard ? activeCard.getBoundingClientRect().top : null;
const qty = Math.max(0,Math.min(99,Number(quantity||0)));
if(qty > 0) configState.selectedFlowers.set(flowerId,qty);
else configState.selectedFlowers.delete(flowerId);
invalidateCompositionRecommendations();
renderConfigFlowers();
renderConfigSummary();
scheduleConfiguratorStateSave();
if(configState.step === 4) updateConfiguredResultPricing();
if(beforeTop !== null){
window.requestAnimationFrame(function(){
window.requestAnimationFrame(function(){
const nextControl = configEls.flowerGrid ? configEls.flowerGrid.querySelector('[data-config-flower-toggle="' + cssEscapeForSelector(flowerId) + '"]') : null;
const nextCard = nextControl && nextControl.closest ? nextControl.closest(".ai-config-product-card") : null;
if(!nextCard) return;
const delta = nextCard.getBoundingClientRect().top - beforeTop;
if(Math.abs(delta) > 1) window.scrollBy(0,delta);
});
});
}
}
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-toggle]"), function(btn){
btn.addEventListener("click", function(){ const id=btn.getAttribute("data-config-flower-toggle")||""; commitFlower(id,configState.selectedFlowers.has(String(id))?0:1); });
});
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-minus]"), function(btn){
btn.addEventListener("click", function(){ const id=btn.getAttribute("data-config-flower-minus")||""; commitFlower(id,Number(configState.selectedFlowers.get(String(id))||0)-1); });
});
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-plus]"), function(btn){
btn.addEventListener("click", function(){ const id=btn.getAttribute("data-config-flower-plus")||""; commitFlower(id,Number(configState.selectedFlowers.get(String(id))||0)+1); });
});
Array.prototype.forEach.call(configEls.flowerGrid.querySelectorAll("[data-config-flower-qty]"), function(input){
input.addEventListener("change", function(){ commitFlower(input.getAttribute("data-config-flower-qty")||"",input.value); });
});
}

function normalizeSharedUnavailableItem(item){
return {
type:String(item && item.type || ""),
id:String(item && item.id || ""),
name:String(item && item.name || "Ürün"),
count:Math.max(1,Number(item && item.count || 1)),
reason:String(item && item.reason || "Ürün şu anda kullanılamıyor."),
suggestions:Array.isArray(item && item.suggestions) ? item.suggestions.slice(0,3) : []
};
}

function renderSharedAvailabilityNoticeHtml(){
if(!configState.shareUnavailableItems.length) return "";
const rows = configState.shareUnavailableItems.map(function(item){
const suggestions = Array.isArray(item.suggestions) && item.suggestions.length
? `<small>Benzer seçenekler: ${item.suggestions.map(function(s){ return escapeHtml(s.name || "Ürün"); }).join(", ")}. Otomatik eklenmedi.</small>`
: "";
return `<li><b>${escapeHtml(item.name)}</b>${item.count > 1 ? " × " + item.count : ""}: ${escapeHtml(item.reason)}${suggestions}</li>`;
}).join("");
return `<div class="ai-share-unavailable"><strong>Bu tasarımdaki bazı ürünler şu anda kullanılamıyor</strong><ul>${rows}</ul><small>Ürünler otomatik olarak değiştirilmedi. Stok yenilendiğinde aynı kodla tekrar kontrol edebilirsiniz.</small></div>`;
}

function normalizePublicResultImageUrl(value){
const raw=String(value||"").trim();
if(!raw||raw.startsWith("data:")||raw.startsWith("blob:")) return "";
try{ return new URL(raw,window.location.origin).toString(); }catch(error){ return raw; }
}

function buildFloeverWhatsappContactUrl(data){
const imageUrl=normalizePublicResultImageUrl(data&&data.image||configState.lastImage||"");
const lines=["Merhaba Floever, AI Studio’da hazırladığım bu aranjman hakkında bilgi almak istiyorum."];
if(imageUrl) lines.push("Aranjman görseli: "+imageUrl);
if(configState.activeShareCode) lines.push("Aranjman kodu: "+String(configState.activeShareCode));
lines.push("Tahmini toplam: "+formatTry(calculateConfigTotal()));
return "https://wa.me/905393800859?text="+encodeURIComponent(lines.join("\n"));
}

function renderFloeverWhatsappContactHtml(data){
return `<a class="ai-whatsapp-contact" id="configWhatsappContactButton" href="${escapeHtml(buildFloeverWhatsappContactUrl(data))}" target="_blank" rel="noopener">${socialPlatformIconSvg("whatsapp")}<span>Bu aranjman için Floever ile iletişime geç</span></a>`;
}

async function ensureAuthenticatedForSharedChange(){
/* Paylaşılan tasarımı görüntülemek ve satın almak serbesttir; yalnızca düzenleme giriş ister. */
if(!configState.sharedPreviewOnly) return true;
try{
if(authState.mode === "loading") await ensureStorefrontSession(false);
}catch(error){}
if(authState.mode !== "authenticated"){
openAuthPrompt("own_stems", "login");
return false;
}
return true;
}
async function beginSharedDesignEditing(targetStep){
if(!(await ensureAuthenticatedForSharedChange())) return false;
if(configState.vaseMode === "own" && sharedOwnVaseHydrationPromise){
try{ await sharedOwnVaseHydrationPromise; }catch(error){}
}
configState.sharedPreviewOnly=false;
configState.activeShareCode="";
configState.shareUnavailableItems=[];
clearConfiguratorCompletedResultState({clearResultBox:true,save:false});
showSetupView();
setConfigStep(Math.max(1,Math.min(3,Number(targetStep)||1)),{instant:true});
scheduleConfiguratorStateSave();
return true;
}
function renderResultSecondaryActionsHtml(){
const isShared = Boolean(configState.sharedPreviewOnly);
const canRevise = isShared || (Boolean(configState.lastJobId) && Number(configState.compositionChangesUsed || 0) < 2);
const canShare = !isShared && Boolean(configState.lastJobId);
return `<div class="ai-result-edit-actions" aria-label="Tasarımı düzenle">
<div class="ai-result-action-group-label">Tasarımı düzenle</div>
<div class="ai-result-edit-action-grid">
<button type="button" id="configChangeVaseButton" ${canRevise ? "" : "disabled"}><span class="ai-secondary-action-icon">↻</span><span>${isShared ? "Vazoyu Değiştir" : (canRevise ? "Vazoyu Değiştir" : "Değişiklik hakkı tamamlandı")}</span></button>
<button type="button" id="configEditFlowersButton"><span class="ai-secondary-action-icon">✿</span><span>Çiçekleri Düzenle</span></button>
</div>
</div>
${canShare ? `<div class="ai-result-share-actions" aria-label="Tasarımı paylaş"><div class="ai-result-action-group-label">Paylaşım</div><button type="button" id="configShareDesignButton"><span class="ai-secondary-action-icon">↗</span><span>Paylaş</span></button></div>` : ""}`;
}

function ensureStudioModal(id){
let modal = document.getElementById(id);
if(modal) return modal;
modal = document.createElement("div");
modal.id = id;
modal.className = "ai-studio-modal-shell";
modal.hidden = true;
document.body.appendChild(modal);
modal.addEventListener("click", function(event){ if(event.target === modal) closeStudioModal(modal); });
return modal;
}
function openStudioModal(modal){ if(!modal) return; modal.hidden=false; setPageModalState(true); }
function closeStudioModal(modal){ if(!modal) return; modal.hidden=true; setPageModalState(false); }

function restoreVaseChangeBackup(backup){
if(!backup) return;
if(configState.ownVasePreviewUrl && configState.ownVasePreviewUrl !== backup.ownVasePreviewUrl && window.URL && URL.revokeObjectURL){
try{ URL.revokeObjectURL(configState.ownVasePreviewUrl); }catch(error){}
}
configState.vaseMode = backup.vaseMode || "floever";
configState.vaseSourceChosen = true;
configState.selectedVaseId = backup.selectedVaseId || "";
configState.ownVaseFile = backup.ownVaseFile || null;
configState.ownVasePreviewUrl = backup.ownVasePreviewUrl || "";
}

function openVaseChangeModal(){
if(!configState.lastJobId || configState.sharedPreviewOnly) return;
if(Number(configState.compositionChangesUsed || 0) >= 2){ setConfigStatus("Bu aranjman için toplam üç tasarım hakkı kullanıldı.","error"); return; }
const modal = ensureStudioModal("configVaseChangeModal");
let pendingMode = configState.vaseMode;
let pendingId = configState.selectedVaseId;
let pendingFile = null;
modal.innerHTML = floeverAiI18n.html(`<div class="ai-studio-modal-card ai-vase-change-modal-card">
<div class="ai-studio-modal-head"><div><span class="ai-modal-kicker">Vazo seçimi</span><h3>Vazoyu Değiştir</h3><p>Yeni vazonuzu seçin. Çiçekleriniz, adetleriniz ve tasarım tarzınız korunur.</p></div><button type="button" class="ai-studio-modal-close" data-modal-close aria-label="Pencereyi kapat">×</button></div>
<div class="ai-vase-change-grid">${configState.vases.map(function(vase){
return `<button type="button" class="ai-vase-change-option ${pendingMode==="floever" && String(pendingId)===String(vase.id) ? "is-selected" : ""}" data-vase-change-id="${escapeHtml(vase.id)}">${renderModalVaseImage(vase)}<span class="ai-vase-change-copy"><strong>${escapeHtml(vase.name)}</strong><small class="ai-vase-change-price">${escapeHtml(vase.priceLabel || formatTry(vase.priceAmount || 0))}</small></span><span class="ai-vase-change-selected">✓</span></button>`;
}).join("")}</div>
<label class="ai-vase-own-upload ${pendingMode==="own" ? "is-selected" : ""}"><input type="file" id="configVaseChangeOwnFile" accept="image/*"><span class="ai-vase-own-upload-icon" aria-hidden="true">📷</span><span class="ai-vase-own-upload-copy"><strong>Kendi vazomu yükle</strong><small>Önden çekilmiş, iyi ışıklı bir fotoğraf seçin.</small><em id="configVaseChangeOwnFileName">Fotoğraf seçilmedi</em></span><span class="ai-vase-own-upload-action">Dosya Seç</span></label>
<div id="configVaseChangeStatus" class="ai-share-code-status"></div>
<div class="ai-modal-actions ai-vase-change-actions"><button type="button" class="ai-modal-secondary" data-modal-close>Vazgeç</button><button type="button" class="ai-modal-primary" id="configVaseChangeApply">Yeni Vazoyla Oluştur</button></div>
</div>`);
bindProductCardGalleries(modal);
Array.prototype.forEach.call(modal.querySelectorAll("[data-modal-close]"),function(button){ button.addEventListener("click",function(){ closeStudioModal(modal); }); });
Array.prototype.forEach.call(modal.querySelectorAll("[data-vase-change-id]"),function(button){
button.addEventListener("click",function(){
pendingMode="floever"; pendingId=button.getAttribute("data-vase-change-id")||""; pendingFile=null;
Array.prototype.forEach.call(modal.querySelectorAll("[data-vase-change-id]"),function(item){ item.classList.toggle("is-selected",item===button); });
const input=modal.querySelector("#configVaseChangeOwnFile"); if(input) input.value="";
const uploadBox=modal.querySelector(".ai-vase-own-upload"); if(uploadBox) uploadBox.classList.remove("is-selected");
const fileName=modal.querySelector("#configVaseChangeOwnFileName"); if(fileName) fileName.textContent=floeverAiI18n.text("Fotoğraf seçilmedi");
});
});
const ownInput=modal.querySelector("#configVaseChangeOwnFile");
if(ownInput) ownInput.addEventListener("change",function(){
pendingFile=ownInput.files&&ownInput.files[0] ? ownInput.files[0] : null;
const uploadBox=ownInput.closest(".ai-vase-own-upload");
const fileName=modal.querySelector("#configVaseChangeOwnFileName");
if(fileName) fileName.textContent=floeverAiI18n.text(pendingFile ? pendingFile.name : "Fotoğraf seçilmedi");
if(uploadBox) uploadBox.classList.toggle("is-selected",Boolean(pendingFile));
if(pendingFile){ pendingMode="own"; pendingId=""; Array.prototype.forEach.call(modal.querySelectorAll("[data-vase-change-id]"),function(item){ item.classList.remove("is-selected"); }); }
});
const apply=modal.querySelector("#configVaseChangeApply");
if(apply) apply.addEventListener("click",function(){
if(pendingMode==="floever" && !pendingId) return;
if(pendingMode==="own" && !pendingFile){ const status=modal.querySelector("#configVaseChangeStatus"); if(status) status.textContent=floeverAiI18n.text("Kendi vazonuz için bir fotoğraf seçin."); return; }
const backup={vaseMode:configState.vaseMode,selectedVaseId:configState.selectedVaseId,ownVaseFile:configState.ownVaseFile,ownVasePreviewUrl:configState.ownVasePreviewUrl};
configState.vaseMode=pendingMode; configState.vaseSourceChosen=true; configState.selectedVaseId=pendingId;
if(pendingMode==="own"){
configState.ownVaseFile=pendingFile;
configState.ownVasePreviewUrl=window.URL&&URL.createObjectURL ? URL.createObjectURL(pendingFile) : "";
}
closeStudioModal(modal);
renderConfigVases(); syncVaseSourceDecisionUi(); renderConfigSummary();
void generateConfiguredArrangement({vaseChange:true,sourceJobId:configState.lastJobId,compositionTemplateId:configState.resultCurrentCompositionTemplateId,vaseBackup:backup});
});
openStudioModal(modal);
}

function isLikelyMobileShareDevice(){
const ua=String(navigator.userAgent||"");
return /Android|iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && Number(navigator.maxTouchPoints||0)>1);
}

function downloadPreparedStoryBlob(blob,filename){
if(!blob) return;
const url=window.URL&&URL.createObjectURL ? URL.createObjectURL(blob) : "";
if(!url) return;
const anchor=document.createElement("a");
anchor.href=url;
anchor.download=filename||"floever-aranjman-paylasim.png";
anchor.style.display="none";
document.body.appendChild(anchor);
anchor.click();
anchor.remove();
window.setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(error){} },1500);
}

async function prepareShareStoryFile(share){
const storyUrl=String(share&&share.storyUrl||share&&share.storyDownloadUrl||"");
if(!storyUrl) throw new Error("Paylaşım görseli bağlantısı bulunamadı.");
const response=await fetch(storyUrl,{method:"GET",headers:{Accept:"image/png"},cache:"no-store"});
if(!response.ok) throw new Error("Paylaşım görseli indirilemedi.");
const blob=await response.blob();
if(!String(blob.type||"").includes("image/")) throw new Error("Paylaşım görseli geçerli değil.");
const filename="floever-aranjman-"+String(share.shareCode||"").toLowerCase()+".png";
let file=null;
try{ file=new File([blob],filename,{type:blob.type||"image/png",lastModified:Date.now()}); }catch(error){}
return {blob:blob,file:file,filename:filename};
}

function buildPlatformShareLabel(platform){
switch(String(platform||"")){
case "instagram": return "Instagram";
case "pinterest": return "Pinterest";
case "tiktok": return "TikTok";
case "whatsapp": return "WhatsApp";
default: return "Paylaş";
}
}

function socialPlatformIconSvg(platform){
switch(String(platform||"")){
case "instagram":
return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="17.5" cy="6.6" r="1.2" fill="currentColor"/></svg>';
case "pinterest":
return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/><path d="M9.3 18.5c.7-2.2 1.2-4.1 1.6-5.9-.8-1.5-.1-4 1.7-4 1.4 0 2 1 2 2.2 0 1.4-.9 3.4-1.3 5.3-.3 1.6.8 2.8 2.4 2.8 2.9 0 4.8-3.7 4.8-7 0-4-3.3-6.9-7.6-6.9-5.3 0-8.5 3.9-8.5 8.1 0 2.2.8 4 2.4 4.7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
case "tiktok":
return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4v10.1a4.2 4.2 0 1 1-3.4-4.1v2.7a1.7 1.7 0 1 0 1 1.5V4h2.4c.4 2.2 1.8 3.6 4 4v2.5c-1.6-.2-3-.8-4-1.8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
case "whatsapp":
return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11.7a8 8 0 0 1-11.8 7l-4.2 1.1 1.1-4A8 8 0 1 1 20 11.7Z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><path d="M8.5 8.2c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.8 1.8c.1.3.1.5-.1.7l-.7.8c-.2.2-.1.4 0 .6.5.9 1.2 1.7 2.1 2.2.2.1.4.2.6 0l.9-1c.2-.2.4-.3.7-.1l1.8.9c.3.1.4.3.4.5 0 .6-.3 1.4-.8 1.8-.6.5-1.4.7-2.2.5-1.6-.4-3.2-1.4-4.5-2.7-1.3-1.3-2.3-2.8-2.6-4.2-.2-.7 0-1.3.4-1.8.4-.5.9-.7 1.5-.8Z" fill="currentColor"/></svg>';
default:
return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 12h8M12 8l4 4-4 4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}
}

function buildPlatformShareText(share){
const link=String(share&&share.designPageUrl||share&&share.shareUrl||"");
return "Bu aranjmanı sen de oluştur · "+String(share&&share.shareCode||"")+(link ? "\n"+link : "");
}

function canSharePreparedFile(prepared){
return Boolean(
prepared&&prepared.file&&
typeof navigator.share==="function"&&
(typeof navigator.canShare!=="function"||navigator.canShare({files:[prepared.file]}))
);
}

async function sharePreparedFile(prepared,share){
if(!canSharePreparedFile(prepared)) return false;
await navigator.share({
files:[prepared.file],
title:"Floever aranjmanım",
text:buildPlatformShareText(share)
});
return true;
}

function openPlatformUrl(primaryUrl,fallbackUrl){
const primary=String(primaryUrl||"").trim();
const fallback=String(fallbackUrl||"").trim();
if(!primary&&!fallback) return;
const startedAt=Date.now();
if(primary){
try{ window.location.href=primary; }catch(error){}
}
if(fallback){
window.setTimeout(function(){
if(document.visibilityState!=="visible"||Date.now()-startedAt>2400) return;
try{ window.location.href=fallback; }catch(error){}
},900);
}
}

async function openShareInPlatform(platform,prepared,share,status,button){
if(!prepared||!prepared.blob) throw new Error("Paylaşım görseli henüz hazır değil.");
const appLabel=buildPlatformShareLabel(platform);
const originalHtml=button&&button.innerHTML||"";
if(button){ button.disabled=true; }
try{
const designPageUrl=String(share&&share.designPageUrl||share&&share.shareUrl||"");
const storyUrl=String(share&&share.storyUrl||share&&share.storyDownloadUrl||"");
const shareText=buildPlatformShareText(share);
if(navigator.clipboard&&designPageUrl){ navigator.clipboard.writeText(designPageUrl).catch(function(){}); }

if(platform==="pinterest"){
const createUrl="https://www.pinterest.com/pin/create/button/?url="+encodeURIComponent(designPageUrl)+"&media="+encodeURIComponent(storyUrl)+"&description="+encodeURIComponent(shareText);
if(status) status.textContent=floeverAiI18n.text("Pinterest açılıyor…");
window.location.href=createUrl;
return;
}

if(platform==="whatsapp"){
try{
if(await sharePreparedFile(prepared,share)) return;
}catch(error){
if(error&&error.name==="AbortError") return;
}
const whatsappText=["Bu aranjmanı sen de oluştur",String(share&&share.shareCode||""),designPageUrl].filter(Boolean).join("\n");
openPlatformUrl("whatsapp://send?text="+encodeURIComponent(whatsappText),"https://wa.me/?text="+encodeURIComponent(whatsappText));
return;
}

if(platform==="tiktok"){
downloadPreparedStoryBlob(prepared.blob,prepared.filename);
if(status) status.textContent=floeverAiI18n.text("Görsel kaydedildi. TikTok açılıyor…");
openPlatformUrl("snssdk1233://upload","https://www.tiktok.com/upload?lang=tr-TR");
return;
}

try{
if(await sharePreparedFile(prepared,share)){
if(status) status.textContent=floeverAiI18n.text("Instagram paylaşım ekranı açıldı.");
return;
}
}catch(error){
if(error&&error.name==="AbortError"){
if(status) status.textContent=floeverAiI18n.text("Paylaşım iptal edildi.");
return;
}
}

downloadPreparedStoryBlob(prepared.blob,prepared.filename);
if(platform==="instagram"){
if(status) status.textContent=floeverAiI18n.text("Görsel kaydedildi. Instagram açılıyor…");
openPlatformUrl("instagram://story-camera","https://www.instagram.com/");
return;
}
if(status) status.textContent=floeverAiI18n.text("Görsel indirildi.");
}finally{
if(button){ button.disabled=false; button.innerHTML=floeverAiI18n.html(originalHtml); }
}
}

function openShareDesignModal(){
if(!configState.lastJobId) return;
const modal=ensureStudioModal("configShareDesignModal");
let preparedStory=null;
let createdShare=null;
modal.innerHTML=floeverAiI18n.html(`<div class="ai-studio-modal-card">
<div class="ai-studio-modal-head"><div><span class="ai-modal-kicker">Tasarımını paylaş</span><h3>Paylaş</h3><p>Aranjmanınızı başkalarının da görmesi ve aynı ürünlerle kendi tasarımını oluşturabilmesi için paylaşın.</p></div><button type="button" class="ai-studio-modal-close" data-modal-close aria-label="Pencereyi kapat">×</button></div>
<label class="ai-modal-field"><span>Paylaşım başlığı</span><input id="configShareHeadline" value="Bu aranjmanı sen de oluştur" maxlength="80"></label>
<label style="display:flex;gap:9px;align-items:center;margin:12px 0 4px;color:#3B2A21"><input type="checkbox" id="configShareShowPrice"> Aranjman fiyatını göster</label>
<div id="configShareCreateStatus" class="ai-share-code-status" aria-live="polite"></div><div id="configShareOutput"></div>
<div class="ai-modal-actions"><button type="button" class="ai-modal-secondary" data-modal-close>Kapat</button><button type="button" class="ai-modal-primary" id="configShareCreate">Görseli Hazırla</button></div>
</div>`);
Array.prototype.forEach.call(modal.querySelectorAll("[data-modal-close]"),function(button){ button.addEventListener("click",function(){ closeStudioModal(modal); }); });
const create=modal.querySelector("#configShareCreate");
if(create) create.addEventListener("click",async function(){
const status=modal.querySelector("#configShareCreateStatus");
try{
create.disabled=true; if(status) status.textContent=floeverAiI18n.text("Hazırlanıyor…");
const response=await apiFetch("/api/me/designs/"+encodeURIComponent(configState.lastJobId)+"/share-codes",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({
headline:(modal.querySelector("#configShareHeadline")||{}).value||"",
showPrice:Boolean((modal.querySelector("#configShareShowPrice")||{}).checked)
})});
const data=await readJsonResponse(response)||{};
if(!response.ok||!data.share) throw new Error(data.error||"Paylaşım kodu oluşturulamadı.");
createdShare=data.share;
preparedStory=await prepareShareStoryFile(createdShare);
const share=createdShare;
const output=modal.querySelector("#configShareOutput");
if(output) output.innerHTML=floeverAiI18n.html(`<div class="ai-share-output"><img class="ai-share-preview" src="${escapeHtml(share.storyUrl||share.storyDownloadUrl||"")}" alt="Hazırlanan paylaşım görseli"><div class="ai-share-code-badge"><small>Aranjman kodu</small><strong>${escapeHtml(share.shareCode)}</strong></div><div class="ai-social-share-grid"><button type="button" class="ai-social-share-button is-instagram" id="configInstagramShare" aria-label="Instagram'da paylaş"><span class="ai-social-icon-disc">${socialPlatformIconSvg("instagram")}</span><span>Instagram</span></button><button type="button" class="ai-social-share-button is-pinterest" id="configPinterestShare" aria-label="Pinterest'te paylaş"><span class="ai-social-icon-disc">${socialPlatformIconSvg("pinterest")}</span><span>Pinterest</span></button><button type="button" class="ai-social-share-button is-tiktok" id="configTiktokShare" aria-label="TikTok'ta paylaş"><span class="ai-social-icon-disc">${socialPlatformIconSvg("tiktok")}</span><span>TikTok</span></button><button type="button" class="ai-social-share-button is-whatsapp" id="configWhatsappShare" aria-label="WhatsApp'ta paylaş"><span class="ai-social-icon-disc">${socialPlatformIconSvg("whatsapp")}</span><span>WhatsApp</span></button></div><div class="ai-share-utility-row"><button type="button" id="configDownloadStory">Görseli İndir</button><button type="button" id="configCopyShareLink">Bağlantıyı Kopyala</button></div></div>`);
const instagramButton=modal.querySelector("#configInstagramShare");
if(instagramButton) instagramButton.addEventListener("click",function(){ void openShareInPlatform("instagram",preparedStory,createdShare,status,instagramButton); });
const pinterestButton=modal.querySelector("#configPinterestShare");
if(pinterestButton) pinterestButton.addEventListener("click",function(){ void openShareInPlatform("pinterest",preparedStory,createdShare,status,pinterestButton); });
const tiktokButton=modal.querySelector("#configTiktokShare");
if(tiktokButton) tiktokButton.addEventListener("click",function(){ void openShareInPlatform("tiktok",preparedStory,createdShare,status,tiktokButton); });
const whatsappButton=modal.querySelector("#configWhatsappShare");
if(whatsappButton) whatsappButton.addEventListener("click",function(){ void openShareInPlatform("whatsapp",preparedStory,createdShare,status,whatsappButton); });
const download=modal.querySelector("#configDownloadStory");
if(download) download.addEventListener("click",function(){ downloadPreparedStoryBlob(preparedStory&&preparedStory.blob,preparedStory&&preparedStory.filename); });
const copy=modal.querySelector("#configCopyShareLink");
if(copy) copy.addEventListener("click",async function(){ const link=String(share.designPageUrl||share.shareUrl||""); try{ await navigator.clipboard.writeText(link); copy.textContent=floeverAiI18n.text("Kopyalandı"); }catch(error){ window.prompt(floeverAiI18n.text("Bağlantıyı kopyalayın:"),link); } });
if(status) status.textContent=floeverAiI18n.text("");
create.hidden=true;
}catch(error){ preparedStory=null; createdShare=null; if(status) status.textContent=floeverAiI18n.text(error&&error.message||"Paylaşım kodu oluşturulamadı."); }
finally{ create.disabled=false; }
});
openStudioModal(modal);
}

function bindResultStepNavigation(){
Array.prototype.forEach.call(document.querySelectorAll("[data-result-step-jump]"),function(button){
if(button.dataset.resultStepBound==="true") return;
button.dataset.resultStepBound="true";
const activate=function(){
const target=Math.max(1,Math.min(4,Number(button.getAttribute("data-result-step-jump"))||1));
if(target===4) return;
if(configState.sharedPreviewOnly){ void beginSharedDesignEditing(target); return; }
showSetupView();
setConfigStep(target);
};
button.addEventListener("click",activate);
button.addEventListener("keydown",function(event){ if(event.key==="Enter"||event.key===" "){ event.preventDefault(); activate(); } });
});
}

function bindShareAndVaseChangeControls(){
const vaseButton=document.getElementById("configChangeVaseButton");
if(vaseButton&&!vaseButton.disabled&&vaseButton.dataset.bound!=="true"){
vaseButton.dataset.bound="true";
vaseButton.addEventListener("click",function(){
if(configState.sharedPreviewOnly){ void beginSharedDesignEditing(1); return; }
openVaseChangeModal();
});
}
const flowerButton=document.getElementById("configEditFlowersButton");
if(flowerButton&&flowerButton.dataset.bound!=="true"){
flowerButton.dataset.bound="true";
flowerButton.addEventListener("click",function(){
if(configState.sharedPreviewOnly){ void beginSharedDesignEditing(2); return; }
openFlowerEditorFromResult();
});
}
const shareButton=document.getElementById("configShareDesignButton");
if(shareButton&&shareButton.dataset.bound!=="true"){ shareButton.dataset.bound="true"; shareButton.addEventListener("click",openShareDesignModal); }
}

function ensureSharedDesignLoadingPopup(){
let popup=document.getElementById("aiSharedDesignLoadingPopup");
if(popup) return popup;
popup=document.createElement("div");
popup.id="aiSharedDesignLoadingPopup";
popup.className="ai-share-loading-backdrop";
popup.hidden=true;
popup.innerHTML=floeverAiI18n.html(`<div class="ai-share-loading-card" role="status" aria-live="polite"><span class="ai-share-loading-spinner" aria-hidden="true"></span><strong>Aranjman yükleniyor</strong><small>Güncel ürün ve stok bilgileri hazırlanıyor…</small></div>`);
document.body.appendChild(popup);
return popup;
}
function setSharedDesignLoadingPopupVisible(visible){
const popup=ensureSharedDesignLoadingPopup();
popup.hidden=!visible;
}
function restoreSharedItemsIntoLoadedLibraries(){
if(!configState.sharedPreviewOnly || !configState.lastResultData) return;
const meta=configState.lastResultData.requestMetadata||{};
const selectedVase=meta.selectedVase||null;
if(selectedVase&&selectedVase.id) mergeSharedLibraryItem(configState.vases,selectedVase);
const flowers=Array.isArray(configState.lastResultData.scenarioMaterials&&configState.lastResultData.scenarioMaterials.userFlowers)
? configState.lastResultData.scenarioMaterials.userFlowers
: Array.isArray(meta.selectedStockFlowers) ? meta.selectedStockFlowers : [];
flowers.forEach(function(item){ if(item&&item.id) mergeSharedLibraryItem(configState.flowers,item); });
}

function mergeSharedLibraryItem(collection,item){
if(!item||!item.id) return;
const index=collection.findIndex(function(existing){ return String(existing.id)===String(item.id); });
if(index>=0) collection[index]=Object.assign({},collection[index],item);
else collection.push(item);
}

async function loadSharedDesignByCode(rawCode, preferredStatus){
const code=String(rawCode||"").trim().toUpperCase();
const status=preferredStatus || document.getElementById("configGlobalShareCodeStatus") || document.getElementById("configShareCodeStatus");
if(!code){ if(status) status.textContent=floeverAiI18n.text("Aranjman kodunu yazın."); return false; }
setSharedDesignLoadingPopupVisible(true);
try{
if(status) status.textContent=floeverAiI18n.text("Paylaşılan tasarım açılıyor…");
const response=await fetch(String(API_BASE_URL).replace(/\/+$/,"")+"/api/share-designs/"+encodeURIComponent(code),{method:"GET",headers:{Accept:"application/json"},cache:"no-store"});
const data=await readJsonResponse(response)||{};
if(!response.ok||!data.share||!data.source) throw new Error(data.error||"Aranjman kodu bulunamadı.");
setWelcomeScreenVisible(false,{remember:true});
configState.activeShareCode=String(data.share.shareCode||code);
configState.shareUnavailableItems=(Array.isArray(data.unavailable)?data.unavailable:[]).map(normalizeSharedUnavailableItem);
configState.sharedPreviewOnly=true;
configState.vaseMode=data.source.vaseMode==="own"?"own":"floever";
configState.vaseSourceChosen=true;
configState.selectedVaseId="";
configState.selectedFlowers=new Map();
if(data.source.selectedVase&&data.source.selectedVase.id){
mergeSharedLibraryItem(configState.vases,data.source.selectedVase);
configState.selectedVaseId=String(data.source.selectedVase.id);
}
sharedOwnVaseHydrationPromise=null;
if(configState.vaseMode==="own"&&data.source.vaseImageUrl){
sharedOwnVaseHydrationPromise=(async function(){
const vaseResponse=await fetch(data.source.vaseImageUrl,{cache:"force-cache"});
if(!vaseResponse.ok) return false;
const blob=await vaseResponse.blob();
configState.ownVaseFile=typeof File!=="undefined" ? new File([blob],"paylasilan-vazo.jpg",{type:blob.type||"image/jpeg"}) : blob;
if(configState.ownVasePreviewUrl&&window.URL&&URL.revokeObjectURL){ try{URL.revokeObjectURL(configState.ownVasePreviewUrl);}catch(error){} }
configState.ownVasePreviewUrl=window.URL&&URL.createObjectURL ? URL.createObjectURL(blob) : data.source.vaseImageUrl;
scheduleConfiguratorStateSave();
return true;
})().catch(function(){ return false; });
}
(Array.isArray(data.source.flowers)?data.source.flowers:[]).forEach(function(entry){
const item=entry.current||entry.stored||null;
if(item){
mergeSharedLibraryItem(configState.flowers,Object.assign({},item,{id:entry.id||item.id}));
configState.selectedFlowers.set(String(entry.id||item.id),Math.max(1,Number(entry.count||1)));
}
});
if(configEls.style) configEls.style.value=data.source.style||"AI Seçimi";
if(configEls.note) configEls.note.value=data.source.note||"";
configState.selectedCompositionTemplateId=String(data.source.compositionPlan&&data.source.compositionPlan.templateId||"");
configState.resultCurrentCompositionTemplateId=configState.selectedCompositionTemplateId;
configState.lastJobId="";
configState.originalJobId="";
configState.lastImage=data.source.imageUrl||data.share.imageUrl||"";
configState.compositionChangesUsed=0;
const sharedResult={
success:true,image:configState.lastImage,originalImage:configState.lastImage,
compositionPlan:data.source.compositionPlan||null,
pricingSnapshot:data.pricing||null,
scenarioMaterials:{userFlowers:selectedConfigFlowers().map(function(selected){ const flower=getConfigFlowerById(selected.id)||{}; return Object.assign({},flower,{count:selected.count}); }),aiSupportMode:"off",aiSupportModeLabel:"Kapalı",aiAdditions:[]},
requestMetadata:{styleInput:data.source.style||"AI Seçimi",selectedVase:data.source.selectedVase||null,selectedStockFlowers:selectedConfigFlowers().map(function(selected){ const flower=getConfigFlowerById(selected.id)||{}; return Object.assign({},flower,{count:selected.count}); }),compositionPlan:data.source.compositionPlan||null,note:data.source.note||""},
revision:{type:"shared",iteration:0,remaining:0},beautify:{used:false,available:false},vaseChange:{used:false,available:false},retry:{used:false,remaining:0},creditSystem:{enabled:false,jobId:"",retryUsed:false}
};
configState.lastResultData=sharedResult;
configState.step=4;
syncStyleCards(); syncVaseSourceDecisionUi(); renderConfigVases(); populateFlowerFilters(); renderConfigFlowers(); renderConfigSummary();
renderConfiguredResult(sharedResult,"");
const picker=document.getElementById("configPostDesignCompositionPicker"); if(picker) picker.remove();
scheduleConfiguratorStateSave();
if(status) status.textContent=floeverAiI18n.text("Tasarım güncel stok ve fiyatlarla açıldı.");
return true;
}catch(error){ if(status) status.textContent=floeverAiI18n.text(error&&error.message||"Paylaşılan tasarım açılamadı."); return false; }
finally{ setSharedDesignLoadingPopupVisible(false); }
}

function loadSharedDesignFromUrlIfPresent(){
if(window.__floeverShareUrlLoaded) return Promise.resolve(false);
let code="";
try{ code=new URL(window.location.href).searchParams.get("floever_share")||""; }catch(error){}
if(!code) return Promise.resolve(false);
window.__floeverShareUrlLoaded=true;
const entry=ensureShareCodeEntryUi(); if(entry) entry.open=true;
const globalInput=document.getElementById("configGlobalShareCodeInput"); if(globalInput) globalInput.value=code;
const welcomeInput=document.getElementById("configShareCodeInput"); if(welcomeInput) welcomeInput.value=code;
return loadSharedDesignByCode(code, document.getElementById("configGlobalShareCodeStatus") || document.getElementById("configShareCodeStatus"));
}

function syncFlowerFiltersFromInputs(){
configState.flowerFilters.search = configEls.flowerSearch ? configEls.flowerSearch.value.trim() : "";
configState.flowerFilters.type = configEls.flowerTypeFilter ? configEls.flowerTypeFilter.value : "";
configState.flowerFilters.color = configEls.flowerColorFilter ? configEls.flowerColorFilter.value : "";
configState.flowerFilters.price = configEls.flowerPriceFilter ? configEls.flowerPriceFilter.value : "";
renderConfigFlowers();
}
ensureFloeverStudioV127Styles();
ensureFloeverStudioV135PolishStyles();
ensureFloeverStudioV137Styles();
ensureFloeverStudioV139FixStyles();
ensureFloeverStudioV140Styles();
ensureVaseSourceDecisionUi();
ensureShareCodeEntryUi();
ensureNewDesignControl();
syncVaseSourceDecisionUi();
if(configEls.welcomeStart && configEls.welcomeStart.dataset.bound !== "true"){
configEls.welcomeStart.dataset.bound = "true";
configEls.welcomeStart.addEventListener("click", openConfiguratorFromWelcome);
}
if(configEls.prev){ configEls.prev.addEventListener("click", async function(){
if(configState.sharedPreviewOnly){ await beginSharedDesignEditing(Math.max(1,configState.step-1)); return; }
setConfigStep(configState.step - 1);
}); }
if(configEls.next){
configEls.next.addEventListener("click", async function(){
if(configState.sharedPreviewOnly){
if(!(await ensureAuthenticatedForSharedChange())) return;
configState.sharedPreviewOnly=false;
configState.activeShareCode="";
configState.shareUnavailableItems=[];
}
const err = validateConfigStep(configState.step);
if(err){ setConfigStatus(err, "error"); return; }
if(configState.step === 3){
generateConfiguredArrangement();
return;
}
setConfigStep(configState.step + 1);
});
}
if(configEls.generate){ configEls.generate.addEventListener("click", generateConfiguredArrangement); }
Array.prototype.forEach.call(document.querySelectorAll("[data-config-step-jump]"), function(btn){
btn.addEventListener("click", async function(){
const target = Number(btn.getAttribute("data-config-step-jump"));
if(configState.sharedPreviewOnly && target < 4){
await beginSharedDesignEditing(target);
return;
}
if(target === 1 && configState.step === 1 && hasMeaningfulConfiguratorState()){
if(window.confirm(floeverAiI18n.text("Baştan yeni bir aranjman tasarlamak için tüm seçimler sıfırlansın mı?"))){
resetConfiguratorCompletely({showSetup:true});
setWelcomeScreenVisible(false,{remember:true});
}
return;
}
if(target < 4){
showSetupView();
setConfigStep(target);
return;
}
for(let i=1;i<4;i++){
const err = validateConfigStep(i);
if(err){ showSetupView(); setConfigStep(i); setConfigStatus(err, "error"); return; }
}
if(configState.lastResultData&&configState.lastResultData.image){
renderConfiguredResult(configState.lastResultData,configState.lastJobId||"");
return;
}
generateConfiguredArrangement();
});
});
Array.prototype.forEach.call(document.querySelectorAll("[data-vase-mode]"), function(btn){ btn.addEventListener("click", function(){ configState.vaseMode = btn.getAttribute("data-vase-mode") || "floever"; invalidateCompositionRecommendations(); Array.prototype.forEach.call(document.querySelectorAll("[data-vase-mode]"), function(b){ b.classList.toggle("is-active", b === btn); }); if(configEls.floeverVasePanel) configEls.floeverVasePanel.hidden = configState.vaseMode !== "floever"; if(configEls.ownVasePanel) configEls.ownVasePanel.hidden = configState.vaseMode !== "own"; renderConfigSummary(); }); });
if(configEls.ownVaseInput){
configEls.ownVaseInput.addEventListener("change", function(){
const file = configEls.ownVaseInput.files && configEls.ownVaseInput.files[0] ? configEls.ownVaseInput.files[0] : null;
configState.ownVaseFile = file;
if(file){ configState.vaseMode = "own"; configState.vaseSourceChosen = true; }
if(configEls.ownVaseFilename) configEls.ownVaseFilename.textContent = floeverAiI18n.text(file ? file.name : "");
if(configState.ownVasePreviewUrl && window.URL && URL.revokeObjectURL) URL.revokeObjectURL(configState.ownVasePreviewUrl);
configState.ownVasePreviewUrl = file && window.URL && URL.createObjectURL ? URL.createObjectURL(file) : "";
invalidateCompositionRecommendations();
syncVaseSourceDecisionUi();
renderConfigSummary();
scheduleConfiguratorStateSave();
});
}
[configEls.flowerSearch, configEls.flowerTypeFilter, configEls.flowerColorFilter, configEls.flowerPriceFilter].forEach(function(el){
if(!el) return;
el.addEventListener(el.tagName === "INPUT" ? "input" : "change", syncFlowerFiltersFromInputs);
});
if(configEls.flowerFilterToggle){
configEls.flowerFilterToggle.addEventListener("click", function(){
configState.filtersOpen = !configState.filtersOpen;
if(configEls.flowerFilterPanel) configEls.flowerFilterPanel.hidden = !configState.filtersOpen;
configEls.flowerFilterToggle.classList.toggle("is-active", configState.filtersOpen);
configEls.flowerFilterToggle.textContent = floeverAiI18n.text(configState.filtersOpen ? "Filtreleri Gizle" : "Filtrele");
});
}
if(configEls.flowerFilterReset){
configEls.flowerFilterReset.addEventListener("click", function(){
if(configEls.flowerSearch) configEls.flowerSearch.value = "";
if(configEls.flowerTypeFilter) configEls.flowerTypeFilter.value = "";
if(configEls.flowerColorFilter) configEls.flowerColorFilter.value = "";
if(configEls.flowerPriceFilter) configEls.flowerPriceFilter.value = "";
syncFlowerFiltersFromInputs();
});
}
Array.prototype.forEach.call(document.querySelectorAll("[data-config-style-choice]"), function(card){
card.addEventListener("click", function(){
const value = card.getAttribute("data-config-style-choice") || "AI Seçimi";
if(configEls.style){
configEls.style.value = value;
invalidateCompositionRecommendations();
configEls.style.dispatchEvent(new Event("change", {bubbles:true}));
}
syncStyleCards();
renderConfigFlowers();
renderConfigSummary();
refreshStyleAdvice();
});
});
if(configEls.style) configEls.style.addEventListener("change", function(){ invalidateCompositionRecommendations(); syncStyleCards(); renderConfigFlowers(); renderConfigSummary(); refreshStyleAdvice(); });
if(configEls.note) configEls.note.addEventListener("change", function(){ renderConfigSummary(); });
syncStyleCards();
refreshStyleAdvice();
ensurePreviousDesignsSection();
renderPreviousDesignsSlider();
restoreConfiguratorStateLocal();
/* v152: Header/sidebar bağlantıları artık tasarımı otomatik sıfırlamaz. */
cleanNewDesignQueryParam();
// İlk ziyarette karşılama ekranını; devam eden tasarımda kayıtlı aşamayı göster.
applyConfiguratorOpeningView();
const openingWithSharedDesign=hasShareCodeInCurrentUrl();
const initialLibraryFlow=openingWithSharedDesign
? loadSharedDesignFromUrlIfPresent().then(function(){ return loadConfiguratorLibraries(); })
: loadConfiguratorLibraries();

initialLibraryFlow.finally(function(){
  // Paylaşım linkinde sonuç önce açılır; tam kütüphane hemen arkasından tamamlanır.
  restoreSharedItemsIntoLoadedLibraries();
  syncStyleCards();
  renderConfigVases();
  populateFlowerFilters();
  renderConfigFlowers();
  renderConfigSummary();
  applyConfiguratorOpeningView();

  // Paylaşım önizlemesi açıksa eski müşteri state'i sonucu ezmemelidir.
  if(configState.sharedPreviewOnly) return;

  // Server'daki kaldığın yer / arka plan job kontrolü arkadan çalışır; local görünümü bozmaz.
  window.setTimeout(function(){
    restoreConfiguratorStateFromServer().then(function(restored){
      if(restored){
        syncStyleCards();
        renderConfigVases();
        populateFlowerFilters();
        renderConfigFlowers();
        renderConfigSummary();
        applyConfiguratorOpeningView();
      }
      return resumeBackgroundDesignIfNeeded();
    }).catch(function(){
      return resumeBackgroundDesignIfNeeded();
    });
  }, 80);
});

}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", initAiDesigner);
} else {
initAiDesigner();
}
})();